import * as mr from "react";
import Gt, { createContext as Tn, useContext as Cn, useState as J, useCallback as ut, useEffect as xe, useRef as rt, useMemo as Vt, Fragment as Aa } from "react";
import Te from "@mui/material/Box";
import Pa from "@mui/material/Avatar";
import ja from "@mui/material/Menu";
import gn from "@mui/material/MenuItem";
import Ar from "@mui/material/ListItemIcon";
import pi from "@mui/material/Divider";
import vi from "@mui/material/IconButton";
import Yn from "@mui/material/Tooltip";
import Ua from "@mui/icons-material/Person";
import Na from "@mui/material/AppBar";
import La from "@mui/material/Toolbar";
import { Box as ae, CircularProgress as En, Typography as Ve, Button as $e, Breadcrumbs as Da, CardActionArea as Fa, Card as Kn, CardContent as Qn, Stack as zt, Chip as gi, IconButton as Xn, TextField as $t, FormControlLabel as mi, Checkbox as bi, Link as xs, Alert as mn, List as Ma, ListItemButton as Ga, ListItemText as Va, MenuItem as Ha, Table as za, TableHead as $a, TableRow as _s, TableCell as yt, TableBody as Ba, Divider as Ja, Dialog as Jn, DialogTitle as br, DialogContent as qn, DialogActions as Pr, Snackbar as qa, Tooltip as Wa } from "@mui/material";
import { colors as xt, Logo as yi } from "brand";
import { AuthProvider as Za, useAuth as Tt } from "react-oidc-context";
import { Delete as Ya, ArrowBack as Ka, Add as Qa, People as Xa, Edit as eo } from "@mui/icons-material";
import er from "@mui/material/Skeleton";
import tr from "@mui/material/Stack";
import { ThemeProvider as to, styled as lr, useTheme as no, useColorScheme as Si } from "@mui/material/styles";
import ro from "@mui/material/CssBaseline";
import so from "@mui/material/List";
import io from "@mui/material/ListItem";
import ao from "@mui/material/ListItemText";
import wi from "@mui/icons-material/Home";
import Ri from "@mui/icons-material/Settings";
import oo from "@mui/icons-material/ChevronLeft";
import uo from "@mui/icons-material/ChevronRight";
import { Navigate as xi, useLocation as lo } from "react-router-dom";
import bn from "@mui/material/Typography";
import _i from "@mui/material/Select";
import Is from "@mui/material/Switch";
import Ts from "@mui/material/FormControlLabel";
import co from "@mui/icons-material/Event";
import ho from "@mui/material/useMediaQuery";
import jr from "@mui/material/Chip";
import fo from "@mui/icons-material/Business";
import Cs from "@mui/icons-material/AdminPanelSettings";
import { useTranslation as po } from "i18n-fe";
import Ii from "@mui/icons-material/Brightness4";
import Ti from "@mui/icons-material/Brightness7";
import Ci from "@mui/icons-material/Logout";
import * as Ei from "axios";
import vo from "axios";
import go from "@mui/icons-material/DeleteOutline";
import mo from "@mui/icons-material/Lock";
var Ur = { exports: {} }, sn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Es;
function bo() {
  if (Es) return sn;
  Es = 1;
  var e = Gt, n = Symbol.for("react.element"), s = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, u, l) {
    var c, d = {}, h = null, m = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (c in u) i.call(u, c) && !r.hasOwnProperty(c) && (d[c] = u[c]);
    if (o && o.defaultProps) for (c in u = o.defaultProps, u) d[c] === void 0 && (d[c] = u[c]);
    return { $$typeof: n, type: o, key: h, ref: m, props: d, _owner: t.current };
  }
  return sn.Fragment = s, sn.jsx = a, sn.jsxs = a, sn;
}
var an = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Os;
function yo() {
  return Os || (Os = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Gt, n = Symbol.for("react.element"), s = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), t = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), j = Symbol.iterator, S = "@@iterator";
    function F(b) {
      if (b === null || typeof b != "object")
        return null;
      var U = j && b[j] || b[S];
      return typeof U == "function" ? U : null;
    }
    var q = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function B(b) {
      {
        for (var U = arguments.length, D = new Array(U > 1 ? U - 1 : 0), Z = 1; Z < U; Z++)
          D[Z - 1] = arguments[Z];
        be("error", b, D);
      }
    }
    function be(b, U, D) {
      {
        var Z = q.ReactDebugCurrentFrame, he = Z.getStackAddendum();
        he !== "" && (U += "%s", D = D.concat([he]));
        var ye = D.map(function(se) {
          return String(se);
        });
        ye.unshift("Warning: " + U), Function.prototype.apply.call(console[b], console, ye);
      }
    }
    var ee = !1, ue = !1, de = !1, W = !1, Se = !1, Fe;
    Fe = Symbol.for("react.module.reference");
    function et(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === i || b === r || Se || b === t || b === l || b === c || W || b === m || ee || ue || de || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === d || b.$$typeof === a || b.$$typeof === o || b.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === Fe || b.getModuleId !== void 0));
    }
    function ct(b, U, D) {
      var Z = b.displayName;
      if (Z)
        return Z;
      var he = U.displayName || U.name || "";
      return he !== "" ? D + "(" + he + ")" : D;
    }
    function dt(b) {
      return b.displayName || "Context";
    }
    function qe(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && B("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case i:
          return "Fragment";
        case s:
          return "Portal";
        case r:
          return "Profiler";
        case t:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case o:
            var U = b;
            return dt(U) + ".Consumer";
          case a:
            var D = b;
            return dt(D._context) + ".Provider";
          case u:
            return ct(b, b.render, "ForwardRef");
          case d:
            var Z = b.displayName || null;
            return Z !== null ? Z : qe(b.type) || "Memo";
          case h: {
            var he = b, ye = he._payload, se = he._init;
            try {
              return qe(se(ye));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Ie = Object.assign, we = 0, Pt, jt, tn, On, kn, nn, An;
    function Pn() {
    }
    Pn.__reactDisabledLog = !0;
    function jn() {
      {
        if (we === 0) {
          Pt = console.log, jt = console.info, tn = console.warn, On = console.error, kn = console.group, nn = console.groupCollapsed, An = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: Pn,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        we++;
      }
    }
    function Un() {
      {
        if (we--, we === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ie({}, b, {
              value: Pt
            }),
            info: Ie({}, b, {
              value: jt
            }),
            warn: Ie({}, b, {
              value: tn
            }),
            error: Ie({}, b, {
              value: On
            }),
            group: Ie({}, b, {
              value: kn
            }),
            groupCollapsed: Ie({}, b, {
              value: nn
            }),
            groupEnd: Ie({}, b, {
              value: An
            })
          });
        }
        we < 0 && B("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ce = q.ReactCurrentDispatcher, Me;
    function tt(b, U, D) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (he) {
            var Z = he.stack.trim().match(/\n( *(at )?)/);
            Me = Z && Z[1] || "";
          }
        return `
` + Me + b;
      }
    }
    var ht = !1, Ct;
    {
      var ft = typeof WeakMap == "function" ? WeakMap : Map;
      Ct = new ft();
    }
    function Et(b, U) {
      if (!b || ht)
        return "";
      {
        var D = Ct.get(b);
        if (D !== void 0)
          return D;
      }
      var Z;
      ht = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ye;
      ye = Ce.current, Ce.current = null, jn();
      try {
        if (U) {
          var se = function() {
            throw Error();
          };
          if (Object.defineProperty(se.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(se, []);
            } catch (Qe) {
              Z = Qe;
            }
            Reflect.construct(b, [], se);
          } else {
            try {
              se.call();
            } catch (Qe) {
              Z = Qe;
            }
            b.call(se.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qe) {
            Z = Qe;
          }
          b();
        }
      } catch (Qe) {
        if (Qe && Z && typeof Qe.stack == "string") {
          for (var te = Qe.stack.split(`
`), We = Z.stack.split(`
`), Ee = te.length - 1, Ue = We.length - 1; Ee >= 1 && Ue >= 0 && te[Ee] !== We[Ue]; )
            Ue--;
          for (; Ee >= 1 && Ue >= 0; Ee--, Ue--)
            if (te[Ee] !== We[Ue]) {
              if (Ee !== 1 || Ue !== 1)
                do
                  if (Ee--, Ue--, Ue < 0 || te[Ee] !== We[Ue]) {
                    var nt = `
` + te[Ee].replace(" at new ", " at ");
                    return b.displayName && nt.includes("<anonymous>") && (nt = nt.replace("<anonymous>", b.displayName)), typeof b == "function" && Ct.set(b, nt), nt;
                  }
                while (Ee >= 1 && Ue >= 0);
              break;
            }
        }
      } finally {
        ht = !1, Ce.current = ye, Un(), Error.prepareStackTrace = he;
      }
      var Nt = b ? b.displayName || b.name : "", Ot = Nt ? tt(Nt) : "";
      return typeof b == "function" && Ct.set(b, Ot), Ot;
    }
    function dr(b, U, D) {
      return Et(b, !1);
    }
    function ua(b) {
      var U = b.prototype;
      return !!(U && U.isReactComponent);
    }
    function Nn(b, U, D) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return Et(b, ua(b));
      if (typeof b == "string")
        return tt(b);
      switch (b) {
        case l:
          return tt("Suspense");
        case c:
          return tt("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case u:
            return dr(b.render);
          case d:
            return Nn(b.type, U, D);
          case h: {
            var Z = b, he = Z._payload, ye = Z._init;
            try {
              return Nn(ye(he), U, D);
            } catch {
            }
          }
        }
      return "";
    }
    var rn = Object.prototype.hasOwnProperty, ls = {}, cs = q.ReactDebugCurrentFrame;
    function Ln(b) {
      if (b) {
        var U = b._owner, D = Nn(b.type, b._source, U ? U.type : null);
        cs.setExtraStackFrame(D);
      } else
        cs.setExtraStackFrame(null);
    }
    function la(b, U, D, Z, he) {
      {
        var ye = Function.call.bind(rn);
        for (var se in b)
          if (ye(b, se)) {
            var te = void 0;
            try {
              if (typeof b[se] != "function") {
                var We = Error((Z || "React class") + ": " + D + " type `" + se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw We.name = "Invariant Violation", We;
              }
              te = b[se](U, se, Z, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ee) {
              te = Ee;
            }
            te && !(te instanceof Error) && (Ln(he), B("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Z || "React class", D, se, typeof te), Ln(null)), te instanceof Error && !(te.message in ls) && (ls[te.message] = !0, Ln(he), B("Failed %s type: %s", D, te.message), Ln(null));
          }
      }
    }
    var ca = Array.isArray;
    function hr(b) {
      return ca(b);
    }
    function da(b) {
      {
        var U = typeof Symbol == "function" && Symbol.toStringTag, D = U && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return D;
      }
    }
    function ha(b) {
      try {
        return ds(b), !1;
      } catch {
        return !0;
      }
    }
    function ds(b) {
      return "" + b;
    }
    function hs(b) {
      if (ha(b))
        return B("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", da(b)), ds(b);
    }
    var fs = q.ReactCurrentOwner, fa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ps, vs;
    function pa(b) {
      if (rn.call(b, "ref")) {
        var U = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (U && U.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function va(b) {
      if (rn.call(b, "key")) {
        var U = Object.getOwnPropertyDescriptor(b, "key").get;
        if (U && U.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function ga(b, U) {
      typeof b.ref == "string" && fs.current;
    }
    function ma(b, U) {
      {
        var D = function() {
          ps || (ps = !0, B("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", U));
        };
        D.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function ba(b, U) {
      {
        var D = function() {
          vs || (vs = !0, B("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", U));
        };
        D.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var ya = function(b, U, D, Z, he, ye, se) {
      var te = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: b,
        key: U,
        ref: D,
        props: se,
        // Record the component responsible for creating this element.
        _owner: ye
      };
      return te._store = {}, Object.defineProperty(te._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(te, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.defineProperty(te, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(te.props), Object.freeze(te)), te;
    };
    function Sa(b, U, D, Z, he) {
      {
        var ye, se = {}, te = null, We = null;
        D !== void 0 && (hs(D), te = "" + D), va(U) && (hs(U.key), te = "" + U.key), pa(U) && (We = U.ref, ga(U, he));
        for (ye in U)
          rn.call(U, ye) && !fa.hasOwnProperty(ye) && (se[ye] = U[ye]);
        if (b && b.defaultProps) {
          var Ee = b.defaultProps;
          for (ye in Ee)
            se[ye] === void 0 && (se[ye] = Ee[ye]);
        }
        if (te || We) {
          var Ue = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          te && ma(se, Ue), We && ba(se, Ue);
        }
        return ya(b, te, We, he, Z, fs.current, se);
      }
    }
    var fr = q.ReactCurrentOwner, gs = q.ReactDebugCurrentFrame;
    function Ut(b) {
      if (b) {
        var U = b._owner, D = Nn(b.type, b._source, U ? U.type : null);
        gs.setExtraStackFrame(D);
      } else
        gs.setExtraStackFrame(null);
    }
    var pr;
    pr = !1;
    function vr(b) {
      return typeof b == "object" && b !== null && b.$$typeof === n;
    }
    function ms() {
      {
        if (fr.current) {
          var b = qe(fr.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function wa(b) {
      return "";
    }
    var bs = {};
    function Ra(b) {
      {
        var U = ms();
        if (!U) {
          var D = typeof b == "string" ? b : b.displayName || b.name;
          D && (U = `

Check the top-level render call using <` + D + ">.");
        }
        return U;
      }
    }
    function ys(b, U) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var D = Ra(U);
        if (bs[D])
          return;
        bs[D] = !0;
        var Z = "";
        b && b._owner && b._owner !== fr.current && (Z = " It was passed a child from " + qe(b._owner.type) + "."), Ut(b), B('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, Z), Ut(null);
      }
    }
    function Ss(b, U) {
      {
        if (typeof b != "object")
          return;
        if (hr(b))
          for (var D = 0; D < b.length; D++) {
            var Z = b[D];
            vr(Z) && ys(Z, U);
          }
        else if (vr(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var he = F(b);
          if (typeof he == "function" && he !== b.entries)
            for (var ye = he.call(b), se; !(se = ye.next()).done; )
              vr(se.value) && ys(se.value, U);
        }
      }
    }
    function xa(b) {
      {
        var U = b.type;
        if (U == null || typeof U == "string")
          return;
        var D;
        if (typeof U == "function")
          D = U.propTypes;
        else if (typeof U == "object" && (U.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        U.$$typeof === d))
          D = U.propTypes;
        else
          return;
        if (D) {
          var Z = qe(U);
          la(D, b.props, "prop", Z, b);
        } else if (U.PropTypes !== void 0 && !pr) {
          pr = !0;
          var he = qe(U);
          B("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof U.getDefaultProps == "function" && !U.getDefaultProps.isReactClassApproved && B("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function _a(b) {
      {
        for (var U = Object.keys(b.props), D = 0; D < U.length; D++) {
          var Z = U[D];
          if (Z !== "children" && Z !== "key") {
            Ut(b), B("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Z), Ut(null);
            break;
          }
        }
        b.ref !== null && (Ut(b), B("Invalid attribute `ref` supplied to `React.Fragment`."), Ut(null));
      }
    }
    var ws = {};
    function Rs(b, U, D, Z, he, ye) {
      {
        var se = et(b);
        if (!se) {
          var te = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (te += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var We = wa();
          We ? te += We : te += ms();
          var Ee;
          b === null ? Ee = "null" : hr(b) ? Ee = "array" : b !== void 0 && b.$$typeof === n ? (Ee = "<" + (qe(b.type) || "Unknown") + " />", te = " Did you accidentally export a JSX literal instead of a component?") : Ee = typeof b, B("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ee, te);
        }
        var Ue = Sa(b, U, D, he, ye);
        if (Ue == null)
          return Ue;
        if (se) {
          var nt = U.children;
          if (nt !== void 0)
            if (Z)
              if (hr(nt)) {
                for (var Nt = 0; Nt < nt.length; Nt++)
                  Ss(nt[Nt], b);
                Object.freeze && Object.freeze(nt);
              } else
                B("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ss(nt, b);
        }
        if (rn.call(U, "key")) {
          var Ot = qe(b), Qe = Object.keys(U).filter(function(ka) {
            return ka !== "key";
          }), gr = Qe.length > 0 ? "{key: someKey, " + Qe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ws[Ot + gr]) {
            var Oa = Qe.length > 0 ? "{" + Qe.join(": ..., ") + ": ...}" : "{}";
            B(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, gr, Ot, Oa, Ot), ws[Ot + gr] = !0;
          }
        }
        return b === i ? _a(Ue) : xa(Ue), Ue;
      }
    }
    function Ia(b, U, D) {
      return Rs(b, U, D, !0);
    }
    function Ta(b, U, D) {
      return Rs(b, U, D, !1);
    }
    var Ca = Ta, Ea = Ia;
    an.Fragment = i, an.jsx = Ca, an.jsxs = Ea;
  }()), an;
}
process.env.NODE_ENV === "production" ? Ur.exports = bo() : Ur.exports = yo();
var f = Ur.exports;
function So({ menuItems: e }) {
  const [n, s] = mr.useState(null), i = !!n, t = (a) => {
    s(a.currentTarget);
  }, r = () => {
    s(null);
  };
  return /* @__PURE__ */ f.jsxs(mr.Fragment, { children: [
    /* @__PURE__ */ f.jsx(Te, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ f.jsx(Yn, { title: "Account settings", children: /* @__PURE__ */ f.jsx(
      vi,
      {
        onClick: t,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": i ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": i ? "true" : void 0,
        children: /* @__PURE__ */ f.jsx(Pa, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ f.jsx(Ua, {}) })
      }
    ) }) }),
    /* @__PURE__ */ f.jsx(
      ja,
      {
        anchorEl: n,
        id: "account-menu",
        open: i,
        onClose: r,
        onClick: r,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: e.map((a, o) => /* @__PURE__ */ f.jsxs(mr.Fragment, { children: [
          a.divider && /* @__PURE__ */ f.jsx(pi, {}),
          a.href ? /* @__PURE__ */ f.jsxs(gn, { component: "a", href: a.href, onClick: r, children: [
            a.icon && /* @__PURE__ */ f.jsx(Ar, { children: a.icon }),
            a.text
          ] }) : /* @__PURE__ */ f.jsxs(
            gn,
            {
              onClick: () => {
                var u;
                (u = a.onClick) == null || u.call(a), r();
              },
              children: [
                a.icon && /* @__PURE__ */ f.jsx(Ar, { children: a.icon }),
                a.text
              ]
            }
          )
        ] }, o))
      }
    )
  ] });
}
const wo = 64, Ro = ({ rightContent: e = null, brandLogo: n = null, sx: s = {} }) => /* @__PURE__ */ f.jsx(Na, { sx: { ...s }, position: "fixed", elevation: 1, children: /* @__PURE__ */ f.jsxs(
  La,
  {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: 0,
      minHeight: `${wo}px !important`
    },
    children: [
      n,
      /* @__PURE__ */ f.jsx(Te, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: e })
    ]
  }
) }), Rd = ({ children: e, sx: n = {} }) => /* @__PURE__ */ f.jsx(
  Te,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (s) => s.zIndex.appBar,
      ...n
    },
    children: e
  }
), xo = 64, _o = ({ children: e }) => /* @__PURE__ */ f.jsx(
  Te,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${xo}px - 56px)`,
      overflow: "auto"
    },
    children: e || /* @__PURE__ */ f.jsx("div", { children: "MainContent (stub)" })
  }
), Oi = "common-fe.navRailExpanded", ki = 72, Io = 200, To = () => {
  try {
    return window.localStorage.getItem(Oi) === "true";
  } catch {
    return !1;
  }
}, Co = (e) => {
  try {
    window.localStorage.setItem(Oi, String(e));
  } catch {
  }
}, Ai = Tn({
  expanded: !1,
  width: ki,
  toggleExpanded: () => {
  }
}), Eo = ({ children: e }) => {
  const [n, s] = J(To), i = ut(() => {
    s((r) => {
      const a = !r;
      return Co(a), a;
    });
  }, []), t = n ? Io : ki;
  return /* @__PURE__ */ f.jsx(Ai.Provider, { value: { expanded: n, width: t, toggleExpanded: i }, children: e });
}, Pi = () => Cn(Ai), yr = 64, Oo = { xs: 2, sm: 4, md: 8 }, ko = ({ appFooterEnabled: e, children: n, appFooter: s, appBar: i, navRail: t }) => {
  const { width: r } = Pi();
  return /* @__PURE__ */ f.jsxs(Te, { sx: { minHeight: "100vh", width: "100%" }, children: [
    /* @__PURE__ */ f.jsx(
      Te,
      {
        sx: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: 1300
        },
        children: i
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Te,
      {
        sx: {
          display: "flex",
          flexDirection: "row",
          pt: `${yr}px`
        },
        children: [
          t && /* @__PURE__ */ f.jsx(
            Te,
            {
              sx: {
                width: r,
                flexShrink: 0,
                position: "fixed",
                height: `calc(100vh - ${yr}px)`,
                top: yr,
                left: 0,
                zIndex: 1200,
                transition: "width 0.15s ease"
              },
              children: t
            }
          ),
          /* @__PURE__ */ f.jsx(
            Te,
            {
              sx: {
                flexGrow: 1,
                minWidth: 0,
                ml: t ? `${r}px` : 0,
                px: Oo,
                transition: "margin-left 0.15s ease"
              },
              children: /* @__PURE__ */ f.jsx(_o, { children: n })
            }
          )
        ]
      }
    ),
    e && s
  ] });
}, xd = ({
  appFooterEnabled: e = !0,
  children: n,
  appFooter: s = null,
  appBar: i = null,
  navRail: t = null
}) => /* @__PURE__ */ f.jsx(Eo, { children: /* @__PURE__ */ f.jsx(
  ko,
  {
    appFooterEnabled: e,
    appFooter: s,
    appBar: i,
    navRail: t,
    children: n
  }
) });
function Nr({ message: e }) {
  return /* @__PURE__ */ f.jsxs(
    ae,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ f.jsx(En, { sx: { color: xt.foxOrange } }),
        e && /* @__PURE__ */ f.jsx(Ve, { variant: "h6", sx: { mt: 2 }, children: e })
      ]
    }
  );
}
function ji(e = "") {
  return ["/", `${e}/callback`, `${e}/logout`, `${e}/logged-out`];
}
function Ao(e, n = "") {
  return typeof e == "string" && e.startsWith("/") && !ji(n).includes(e);
}
function Po(e = "") {
  return [`${e}/logout`, `${e}/logged-out`];
}
function jo(e, n = "") {
  return Po(n).includes(e);
}
function _d(e) {
  if (typeof e != "string" || e === "") return "";
  let n;
  try {
    n = new URL(e).pathname;
  } catch {
    return "";
  }
  const s = "/callback";
  return n.endsWith(s) ? n.slice(0, -s.length) : "";
}
function Id({ navigateFunction: e, location: n, basename: s = "" }) {
  return xe(() => {
    const i = setTimeout(() => {
      const t = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const r = Ao(t, s) ? t : "/";
      e(r, { replace: !0 });
    }, 500);
    return () => clearTimeout(i);
  }, [e, n, s]), /* @__PURE__ */ f.jsx(Nr, { message: "Signing you in..." });
}
let Ui = !1;
function Td() {
  Ui = !0;
}
function ks() {
  return Ui;
}
function Uo() {
  return typeof window < "u" && !!window.Cypress;
}
async function No({ navigate: e = () => window.location.replace("/") } = {}) {
  Ps(As(() => window.localStorage)), Ps(As(() => window.sessionStorage)), await Do(), await Fo(), e();
}
function As(e) {
  try {
    return e();
  } catch {
    return null;
  }
}
const Lo = "oidc.";
function Ps(e) {
  if (e)
    try {
      const n = [];
      for (let s = 0; s < e.length; s++) {
        const i = e.key(s);
        i && i.startsWith(Lo) && n.push(i);
      }
      n.forEach((s) => e.removeItem(s));
    } catch {
    }
}
async function Do() {
  var e, n;
  try {
    const s = await ((n = (e = navigator.serviceWorker) == null ? void 0 : e.getRegistrations) == null ? void 0 : n.call(e));
    if (!s) return;
    await Promise.all(s.map((i) => i.unregister()));
  } catch {
  }
}
async function Fo() {
  var e, n;
  try {
    const s = await ((n = (e = window.caches) == null ? void 0 : e.keys) == null ? void 0 : n.call(e));
    if (!s) return;
    await Promise.all(s.map((i) => window.caches.delete(i)));
  } catch {
  }
}
function Ni(e) {
  return e ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
}
function Mo({ error: e }) {
  const n = Ni();
  return /* @__PURE__ */ f.jsxs(
    ae,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal, matches FullScreenLoader
      },
      children: [
        /* @__PURE__ */ f.jsx(Ve, { variant: "h6", sx: { mb: 1 }, children: "Encountering error..." }),
        /* @__PURE__ */ f.jsx(
          Ve,
          {
            "data-testid": "auth-error-message",
            variant: "body2",
            sx: { mb: 3, maxWidth: 480, fontFamily: "monospace", color: "text.secondary" },
            children: e == null ? void 0 : e.message
          }
        ),
        /* @__PURE__ */ f.jsx(
          $e,
          {
            "data-testid": "auth-error-start-over",
            variant: "contained",
            onClick: () => No(),
            sx: { bgcolor: xt.foxOrange, "&:hover": { bgcolor: xt.foxOrange } },
            children: "Start over"
          }
        ),
        /* @__PURE__ */ f.jsxs(
          Ve,
          {
            "data-testid": "auth-error-build-id",
            variant: "caption",
            sx: { mt: 3, color: "text.secondary", fontFamily: "monospace" },
            children: [
              "Build ",
              n
            ]
          }
        )
      ]
    }
  );
}
function Go({ children: e, basename: n = "" }) {
  var a;
  const s = Tt(), i = jo(window.location.pathname, n), t = rt(!1), r = ((a = s.error) == null ? void 0 : a.source) === "signinSilent" && !s.isAuthenticated;
  return xe(() => {
    const o = window.location.pathname;
    ji(n).includes(o) || localStorage.setItem("redirect_url", o);
  }, [n]), xe(() => {
    var o;
    if (!s.isLoading && !s.isAuthenticated && (!s.error || r) && !ks() && !i) {
      if (!s.error && ((o = s.user) != null && o.refresh_token) && !t.current) {
        t.current = !0, s.signinSilent();
        return;
      }
      s.signinRedirect();
    }
  }, [
    s.isLoading,
    s.isAuthenticated,
    s.error,
    s,
    i,
    r
  ]), s.isLoading ? /* @__PURE__ */ f.jsx(Nr, { message: "Loading..." }) : s.error && !s.isAuthenticated && !ks() && !r ? /* @__PURE__ */ f.jsx(Mo, { error: s.error }) : !s.isAuthenticated && !i ? /* @__PURE__ */ f.jsx(Nr, { message: "Redirecting to login..." }) : e;
}
function Cd({ cognitoAuthConfig: e, basename: n = "", children: s }) {
  const i = Uo() ? { ...e, automaticSilentRenew: !1, monitorSession: !1 } : e;
  return /* @__PURE__ */ f.jsx(Za, { ...i, children: /* @__PURE__ */ f.jsx(Go, { basename: n, children: s }) });
}
const Ed = ({
  onConfirm: e,
  onCancel: n,
  confirmText: s = "Confirm",
  cancelText: i = "Cancel",
  buttonText: t = "Delete",
  buttonIcon: r = /* @__PURE__ */ f.jsx(Ya, {}),
  variant: a = "outlined",
  color: o = "error",
  size: u = "small",
  disabled: l = !1,
  "data-testid": c,
  confirmButtonTestId: d,
  cancelButtonTestId: h
}) => {
  const [m, j] = J(!1), S = () => {
    j(!0);
  }, F = () => {
    j(!1), e();
  }, q = () => {
    j(!1), n && n();
  };
  return m ? /* @__PURE__ */ f.jsxs(ae, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ f.jsx(
      $e,
      {
        variant: "contained",
        color: o,
        size: u,
        onClick: F,
        "data-testid": d,
        children: s
      }
    ),
    /* @__PURE__ */ f.jsx(
      $e,
      {
        variant: "outlined",
        size: u,
        onClick: q,
        "data-testid": h,
        children: i
      }
    )
  ] }) : /* @__PURE__ */ f.jsx(
    $e,
    {
      variant: a,
      color: o,
      size: u,
      startIcon: r,
      onClick: S,
      disabled: l,
      "data-testid": c,
      children: t
    }
  );
};
function Od({
  rows: e = 5,
  columns: n = 1,
  showHeader: s = !0,
  dense: i = !1,
  sx: t,
  ...r
}) {
  const a = i ? 28 : 40, o = i ? 0.75 : 1.25, u = Math.max(1, n), l = (c, d) => /* @__PURE__ */ f.jsx(tr, { direction: "row", spacing: o, sx: { width: "100%" }, children: Array.from({ length: u }).map((h, m) => /* @__PURE__ */ f.jsx(
    er,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    m
  )) }, c);
  return /* @__PURE__ */ f.jsx(
    Te,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...t },
      ...r,
      children: /* @__PURE__ */ f.jsxs(tr, { spacing: o, children: [
        s && l("header", a * 0.7),
        Array.from({ length: Math.max(1, e) }).map(
          (c, d) => l(`row-${d}`, a)
        )
      ] })
    }
  );
}
function kd() {
  const e = Tt();
  return /* @__PURE__ */ f.jsxs(
    ae,
    {
      "data-testid": "logged-out-page",
      component: "main",
      sx: {
        minHeight: "75vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default"
      },
      children: [
        /* @__PURE__ */ f.jsx(ae, { sx: { color: xt.darkGrey, mb: 4, lineHeight: 0 }, children: /* @__PURE__ */ f.jsx(
          yi,
          {
            "data-testid": "logged-out-logo",
            role: "img",
            "aria-label": "Fox Village",
            style: { width: 280, maxWidth: "100%", height: "auto" }
          }
        ) }),
        /* @__PURE__ */ f.jsx(Ve, { variant: "h5", gutterBottom: !0, children: "You have been signed out" }),
        /* @__PURE__ */ f.jsx(
          Ve,
          {
            variant: "body1",
            sx: { mb: 4, maxWidth: 480, color: "text.secondary" },
            children: "Your session has ended. Sign in again to continue."
          }
        ),
        /* @__PURE__ */ f.jsx(
          $e,
          {
            "data-testid": "logged-out-sign-in",
            variant: "contained",
            size: "large",
            onClick: () => e.signinRedirect(),
            sx: {
              bgcolor: xt.foxOrange,
              color: xt.darkRed,
              fontWeight: 700,
              textTransform: "none",
              px: 4,
              py: 1.25,
              "&:hover": {
                bgcolor: xt.foxOrange,
                filter: "brightness(0.92)"
              }
            },
            children: "Sign in again"
          }
        )
      ]
    }
  );
}
function Ad({ navigateFunction: e }) {
  const n = Tt();
  return xe(() => {
    let s = !0;
    async function i() {
      await n.removeUser(), s && e("/logged-out", { replace: !0 });
    }
    return i(), () => {
      s = !1;
    };
  }, [n, e]), /* @__PURE__ */ f.jsx("div", { children: "You have been logged out." });
}
function Pd({ theme: e, children: n }) {
  return !e || typeof e != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), n) : /* @__PURE__ */ f.jsxs(to, { theme: e, children: [
    /* @__PURE__ */ f.jsx(ro, {}),
    n
  ] });
}
const Vo = lr(Te)(({ theme: e, backgroundColor: n, color: s, width: i }) => ({
  width: i,
  height: "100%",
  backgroundColor: n || e.palette.background.paper,
  color: s || e.palette.text.primary,
  borderRight: `1px solid ${e.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  paddingTop: e.spacing(1),
  overflow: "hidden",
  transition: "width 0.15s ease"
})), Ho = lr(vi)(({ theme: e, backgroundColor: n, color: s }) => ({
  position: "absolute",
  top: e.spacing(1.5),
  right: 0,
  transform: "translateX(50%)",
  width: 20,
  height: 20,
  padding: 0,
  borderRadius: 4,
  backgroundColor: n || e.palette.background.paper,
  color: s || e.palette.text.primary,
  border: `1px solid ${e.palette.divider}`,
  zIndex: 1,
  "&:hover": {
    backgroundColor: n || e.palette.background.paper,
    opacity: 0.8
  }
})), jd = ({
  navItems: e,
  backgroundColor: n = "#1a1a1a",
  color: s = "inherit"
}) => {
  const { expanded: i, width: t, toggleExpanded: r } = Pi(), a = [
    {
      icon: /* @__PURE__ */ f.jsx(wi, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ f.jsx(Ri, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], o = e && e.length > 0 ? e : a;
  return /* @__PURE__ */ f.jsxs(Te, { sx: { position: "relative", width: "100%", height: "100%" }, children: [
    /* @__PURE__ */ f.jsx(Vo, { backgroundColor: n, color: s, width: t, children: /* @__PURE__ */ f.jsx(so, { sx: { width: "100%", p: 0 }, children: o.map((u, l) => {
      const c = /* @__PURE__ */ f.jsxs(
        io,
        {
          onClick: u.onClick,
          sx: {
            flexDirection: i ? "row" : "column",
            justifyContent: i ? "flex-start" : "center",
            py: 1,
            px: i ? 2 : 0,
            gap: i ? 1.5 : 0,
            color: "inherit",
            // #582 — nav items are clickable; show the pointer (hand) cursor
            // on hover (ListItem alone doesn't imply a button cursor).
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent",
              opacity: 0.8
            }
          },
          children: [
            /* @__PURE__ */ f.jsx(
              Ar,
              {
                sx: {
                  minWidth: "auto",
                  color: "inherit"
                },
                children: u.icon
              }
            ),
            i && /* @__PURE__ */ f.jsx(
              ao,
              {
                primary: u.text,
                primaryTypographyProps: {
                  variant: "caption",
                  align: "left",
                  sx: {
                    fontSize: "0.75rem",
                    color: "inherit",
                    whiteSpace: "nowrap"
                  }
                }
              }
            )
          ]
        },
        l
      );
      return i ? c : /* @__PURE__ */ f.jsx(Yn, { title: u.text, placement: "right", children: c }, l);
    }) }) }),
    /* @__PURE__ */ f.jsx(Yn, { title: i ? "Collapse navigation" : "Expand navigation", children: /* @__PURE__ */ f.jsx(
      Ho,
      {
        onClick: r,
        "aria-label": i ? "Collapse navigation" : "Expand navigation",
        backgroundColor: n,
        color: s,
        children: i ? /* @__PURE__ */ f.jsx(oo, { sx: { fontSize: 14 } }) : /* @__PURE__ */ f.jsx(uo, { sx: { fontSize: 14 } })
      }
    ) })
  ] });
};
function Ud({ children: e }) {
  return Tt().isAuthenticated ? e : /* @__PURE__ */ f.jsx(xi, { to: "/callback", replace: !0 });
}
const Nd = ({
  children: e,
  maxWidth: n = 600,
  minWidth: s = 320,
  backTo: i,
  backLabel: t,
  breadcrumbs: r,
  onBack: a
}) => {
  const o = () => {
    a && a();
  };
  return /* @__PURE__ */ f.jsxs(
    ae,
    {
      maxWidth: n,
      minWidth: s,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ f.jsx(
          ae,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ f.jsxs(ae, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              i && /* @__PURE__ */ f.jsx(
                $e,
                {
                  startIcon: /* @__PURE__ */ f.jsx(Ka, {}),
                  onClick: o,
                  variant: "outlined",
                  size: "small",
                  children: t || "Back"
                }
              ),
              r && /* @__PURE__ */ f.jsx(Da, { separator: "", children: Gt.Children.map(r, (u, l) => {
                const c = Gt.Children.count(r);
                let d = "middle";
                return c === 1 ? d = "single" : l === 0 ? d = "first" : l === c - 1 && (d = "last"), Gt.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        e
      ]
    }
  );
}, it = "12px", zo = lr(Te, {
  shouldForwardProp: (e) => e !== "position"
})(({ theme: e, position: n }) => {
  const s = () => {
    switch (n) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${it}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${it} 0, 100% 0, calc(100% - ${it}) 100%, 0 100%)`;
      case "last":
        return `polygon(${it} 0, calc(100% - ${it}) 0, 100% 50%, calc(100% - ${it}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${it}) 0, 100% 50%, calc(100% - ${it}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200],
    color: e.palette.getContrastText(
      e.palette.mode === "dark" ? e.palette.grey[800] : e.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: s(),
    // Nudge the items together to overlap
    marginLeft: n === "middle" || n === "last" ? `-${it}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: n === "middle" || n === "last" ? `calc(${it} + ${e.spacing(1)})` : e.spacing(2),
    paddingRight: `calc(${it} + ${e.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: e.palette.mode === "dark" ? e.palette.grey[700] : e.palette.grey[300]
    }
  };
}), $o = lr(bn)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), Ld = ({ label: e, component: n = "a", ...s }) => /* @__PURE__ */ f.jsx(zo, { component: n, ...s, children: /* @__PURE__ */ f.jsx($o, { children: e }) }), Dd = ({ onClick: e, label: n, "data-testid": s }) => /* @__PURE__ */ f.jsx(
  Fa,
  {
    onClick: e,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (i) => i.palette.mode === "dark" ? i.palette.grey[800] : i.palette.grey[200],
      borderRadius: (i) => i.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (i) => i.palette.mode === "dark" ? i.palette.grey[700] : i.palette.grey[300]
      }
    },
    "data-testid": s || "new-item-card-button",
    children: /* @__PURE__ */ f.jsxs(
      ae,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ f.jsx(
            ae,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ f.jsx(Qa, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ f.jsx(Ve, { variant: "button", component: "span", children: n })
        ]
      }
    )
  }
), Fd = ({ title: e, icon: n, tags: s = [], onEdit: i, showEdit: t, onMembers: r, showMembers: a, "data-testid": o, editButtonTestId: u, membersButtonTestId: l }) => /* @__PURE__ */ f.jsxs(
  Kn,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (c) => c.palette.mode === "dark" ? c.palette.grey[900] : c.palette.background.paper
    },
    "data-testid": o,
    elevation: 1,
    children: [
      /* @__PURE__ */ f.jsx(Qn, { sx: { pb: 1 }, children: /* @__PURE__ */ f.jsxs(ae, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        n && Gt.cloneElement(n, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ f.jsx(Ve, { variant: "h6", component: "div", noWrap: !0, children: e })
      ] }) }),
      /* @__PURE__ */ f.jsx(Qn, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ f.jsx(zt, { direction: "row", spacing: 1, children: s.map((c, d) => /* @__PURE__ */ f.jsx(
        gi,
        {
          label: c.label,
          color: c.color || "default",
          size: c.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ f.jsxs(ae, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        a && /* @__PURE__ */ f.jsx(
          Xn,
          {
            "aria-label": `manage members for ${e}`,
            onClick: r,
            sx: {
              color: "text.secondary"
            },
            "data-testid": l,
            children: /* @__PURE__ */ f.jsx(Xa, {})
          }
        ),
        t && /* @__PURE__ */ f.jsx(
          Xn,
          {
            "aria-label": `edit ${e}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ f.jsx(eo, {})
          }
        )
      ] })
    ]
  }
);
class hn extends Error {
}
hn.prototype.name = "InvalidTokenError";
function Bo(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (n, s) => {
    let i = s.charCodeAt(0).toString(16).toUpperCase();
    return i.length < 2 && (i = "0" + i), "%" + i;
  }));
}
function Jo(e) {
  let n = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (n.length % 4) {
    case 0:
      break;
    case 2:
      n += "==";
      break;
    case 3:
      n += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Bo(n);
  } catch {
    return atob(n);
  }
}
function Li(e, n) {
  if (typeof e != "string")
    throw new hn("Invalid token specified: must be a string");
  n || (n = {});
  const s = n.header === !0 ? 0 : 1, i = e.split(".")[s];
  if (typeof i != "string")
    throw new hn(`Invalid token specified: missing part #${s + 1}`);
  let t;
  try {
    t = Jo(i);
  } catch (r) {
    throw new hn(`Invalid token specified: invalid base64 for part #${s + 1} (${r.message})`);
  }
  try {
    return JSON.parse(t);
  } catch (r) {
    throw new hn(`Invalid token specified: invalid json for part #${s + 1} (${r.message})`);
  }
}
const Lr = "common-fe.activeOrgId", qo = "426e8750-5b55-59f4-90c7-835b46d6a990", Wo = (e) => {
  const n = e.filter((s) => s.id !== qo);
  return n.length ? n : e;
}, Zo = (e) => {
  if (!e) return !1;
  try {
    const n = Li(e), s = n["custom:super"] ?? n.super;
    return s === "true" || s === !0;
  } catch {
    return !1;
  }
}, Di = Tn({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1,
  orgResolved: !1
}), Yo = () => {
  try {
    return window.localStorage.getItem(Lr) || null;
  } catch {
    return null;
  }
}, Ko = (e) => {
  try {
    e ? window.localStorage.setItem(Lr, e) : window.localStorage.removeItem(Lr);
  } catch {
  }
}, Md = ({ listOrgs: e, children: n }) => {
  var S;
  const i = (S = Tt().user) == null ? void 0 : S.access_token, t = Zo(i), [r, a] = J([]), [o, u] = J(!0), [l, c] = J(null), [d, h] = J(() => Yo()), m = ut((F) => {
    h(F), Ko(F);
  }, []);
  xe(() => {
    if (!e) {
      u(!1);
      return;
    }
    let F = !1;
    const q = new AbortController();
    return (async () => {
      try {
        u(!0), c(null);
        const B = await e(t, q.signal);
        if (F) return;
        a(Wo(Array.isArray(B) ? B : []));
      } catch (B) {
        if (F) return;
        console.error("Failed to load orgs for switcher:", B), c(B), a([]);
      } finally {
        F || u(!1);
      }
    })(), () => {
      F = !0, q.abort();
    };
  }, [e, t]), xe(() => {
    if (!r.length) return;
    r.some((q) => q.id === d) || m(r[0].id);
  }, [r, d, m]);
  const j = d != null || !o;
  return /* @__PURE__ */ f.jsx(
    Di.Provider,
    {
      value: { orgs: r, activeOrgId: d, setActiveOrgId: m, loading: o, error: l, isSuper: t, orgResolved: j },
      children: n
    }
  );
}, ns = () => Cn(Di), Rt = "America/Los_Angeles", Qo = /^(?:GMT|UTC)?\s*([+-])\s*(\d{1,2})(?::?(\d{2}))?$/i, Xo = -14, eu = 12, Sr = /* @__PURE__ */ new Map();
function tu(e) {
  if (Sr.has(e)) return Sr.get(e);
  let n = !0;
  try {
    new Intl.DateTimeFormat("en-CA", { timeZone: e });
  } catch {
    n = !1;
  }
  return Sr.set(e, n), n;
}
function rs(e) {
  if (typeof e != "string") return Rt;
  const n = e.trim();
  if (!n) return Rt;
  if (/^(?:GMT|UTC)$/i.test(n)) return "Etc/GMT";
  const s = Qo.exec(n);
  if (s) {
    const [, i, t, r] = s;
    if (r && Number(r) !== 0) return Rt;
    const a = Number(t) * (i === "-" ? -1 : 1);
    return a < Xo || a > eu ? Rt : a === 0 ? "Etc/GMT" : `Etc/GMT${a < 0 ? "+" : "-"}${Math.abs(a)}`;
  }
  return tu(n) ? n : Rt;
}
function Fi(e) {
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (e == null) return null;
  const n = new Date(e);
  return Number.isNaN(n.getTime()) ? null : n;
}
function Gd(e, { timeZone: n = Rt, seconds: s = !1, hour12: i = !0 } = {}) {
  const t = Fi(e);
  return t ? t.toLocaleTimeString("en-US", {
    ...i ? { hour: "numeric", hour12: !0 } : { hour: "2-digit", hourCycle: "h23" },
    minute: "2-digit",
    ...s ? { second: "2-digit" } : {},
    timeZone: rs(n)
  }) : "";
}
function Vd(e, n = /* @__PURE__ */ new Date()) {
  var t;
  const s = rs(e);
  return ((t = new Intl.DateTimeFormat("en-US", {
    timeZone: s,
    timeZoneName: "short"
  }).formatToParts(n).find((r) => r.type === "timeZoneName")) == null ? void 0 : t.value) ?? s;
}
function nu(e, n = Rt) {
  const s = Fi(e);
  return s ? new Intl.DateTimeFormat("en-CA", {
    timeZone: rs(n),
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(s) : null;
}
const Dr = "common-fe.activeShowId", ru = Symbol("active-show-never-loaded"), Mi = Tn({
  shows: [],
  allShows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  patchShow: () => {
  },
  loading: !1,
  error: null,
  filterActive: !1,
  showAllShows: !1,
  setShowAllShows: () => {
  }
}), js = 3, Us = 24 * 60 * 60 * 1e3, wr = (e) => {
  if (typeof e != "string" || !e) return null;
  const n = /* @__PURE__ */ new Date(`${e}T00:00:00.000Z`);
  return Number.isNaN(n.getTime()) ? null : n;
}, su = (e, { todayKey: n = nu(/* @__PURE__ */ new Date(), Rt) } = {}) => {
  const s = wr(e == null ? void 0 : e.startDate), i = wr(e == null ? void 0 : e.endDate);
  if (!s || !i) return !0;
  const t = wr(n);
  if (!t) return !0;
  const r = s.getTime() - js * Us, a = i.getTime() + js * Us;
  return t.getTime() >= r && t.getTime() <= a;
}, iu = () => {
  try {
    return window.localStorage.getItem(Dr) || null;
  } catch {
    return null;
  }
}, au = (e) => {
  try {
    e ? window.localStorage.setItem(Dr, e) : window.localStorage.removeItem(Dr);
  } catch {
  }
}, ou = (e) => [...e].sort((n, s) => {
  const i = n != null && n.startDate ? new Date(n.startDate).getTime() : NaN, t = s != null && s.startDate ? new Date(s.startDate).getTime() : NaN, r = Number.isFinite(i), a = Number.isFinite(t);
  return r && a ? t - i : r ? -1 : a ? 1 : 0;
}), Hd = ({
  listShows: e,
  orgId: n,
  filterActive: s = !1,
  children: i
}) => {
  const [t, r] = J([]), [a, o] = J(!0), [u, l] = J(null), [c, d] = J(() => iu()), h = rt(ru), m = ut((ee) => {
    d(ee), au(ee);
  }, []), j = ut((ee, ue) => {
    r(
      (de) => de.map((W) => W.id === ee ? { ...W, ...ue } : W)
    );
  }, []);
  xe(() => {
    if (!e) {
      o(!1);
      return;
    }
    let ee = !1;
    const ue = new AbortController();
    return (async () => {
      try {
        o(!0);
        const de = await e(ue.signal);
        if (ee) return;
        h.current = n, l(null), r(Array.isArray(de) ? ou(de) : []);
      } catch (de) {
        if (ee) return;
        console.error("Failed to load shows for switcher:", de), h.current !== n && (l(de), r([]));
      } finally {
        ee || o(!1);
      }
    })(), () => {
      ee = !0, ue.abort();
    };
  }, [e, n]);
  const [S, F] = J(!1), q = Vt(() => !s || S ? t : t.filter((ee) => su(ee)), [t, s, S]);
  xe(() => {
    if (!t.length || t.some((de) => de.id === c)) return;
    const ue = q[0] || t[0];
    m(ue.id);
  }, [t, q, c, m]);
  const B = Vt(
    () => t.find((ee) => ee.id === c) || null,
    [t, c]
  ), be = Vt(
    () => ({
      shows: q,
      allShows: t,
      activeShowId: c,
      activeShow: B,
      setActiveShowId: m,
      patchShow: j,
      loading: a,
      error: u,
      filterActive: s,
      showAllShows: S,
      setShowAllShows: F
    }),
    [
      q,
      t,
      c,
      B,
      m,
      j,
      a,
      u,
      s,
      S
    ]
  );
  return /* @__PURE__ */ f.jsx(Mi.Provider, { value: be, children: i });
}, uu = () => Cn(Mi);
function Gi(e, { max: n = 28, tail: s = 12 } = {}) {
  if (!e || e.length <= n) return e;
  const i = Math.max(0, n - s - 1);
  return `${e.slice(0, i)}…${e.slice(-s)}`;
}
const lu = { max: 44, tail: 16 }, cu = { max: 28, tail: 12 }, Rr = (e) => (typeof (e == null ? void 0 : e.friendlyName) == "string" ? e.friendlyName.trim() : "") || null, zd = ({ onShowChange: e, toggleInDropdown: n = !1 }) => {
  const {
    shows: s,
    allShows: i,
    activeShowId: t,
    activeShow: r,
    setActiveShowId: a,
    loading: o,
    filterActive: u,
    showAllShows: l,
    setShowAllShows: c
  } = uu(), d = no(), h = ho(d.breakpoints.up("lg"), {
    defaultMatches: !0
  });
  if (o && !i.length)
    return /* @__PURE__ */ f.jsx(
      er,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!i || i.length === 0) return null;
  const m = (j) => {
    const S = j.target.value;
    a(S), e && e(S);
  };
  return /* @__PURE__ */ f.jsxs(
    Te,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ f.jsx(co, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ f.jsxs(
          _i,
          {
            value: t || "",
            onChange: m,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: () => {
              const j = r ? r.name || r.id : "", S = Rr(r);
              return /* @__PURE__ */ f.jsx(
                "span",
                {
                  title: j,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: S || Gi(
                    j,
                    h ? lu : cu
                  )
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              // { xs: 240, lg: 420 } (was 240): a 33-character full name plus the caret did not fit
              // in 240 at 0.9rem, so the CSS end-ellipsis stacked a second
              // ellipsis on top of truncateMiddle's (bug #200). Sized for the
              // 44-character FULL_NAME_TRUNCATION budget above. Only from lg up: at
              // narrow widths the bar also carries OrgSwitcher + email, and a
              // wider wrapper cannot shrink below its content, so xs keeps 240
              // (paired with NARROW_NAME_TRUNCATION).
              maxWidth: { xs: 240, lg: 420 },
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: [
              r && !s.some((j) => j.id === r.id) && /* @__PURE__ */ f.jsx(
                gn,
                {
                  value: r.id,
                  style: { display: "none" },
                  children: r.name || r.id
                },
                r.id
              ),
              s.map((j) => /* @__PURE__ */ f.jsx(gn, { value: j.id, children: Rr(j) ? /* @__PURE__ */ f.jsxs(Te, { sx: { display: "flex", flexDirection: "column" }, children: [
                /* @__PURE__ */ f.jsx("span", { children: Rr(j) }),
                /* @__PURE__ */ f.jsx(Te, { component: "span", sx: { fontSize: "0.75rem", color: "text.secondary" }, children: j.name || j.id })
              ] }) : j.name || j.id }, j.id)),
              u && n && /* @__PURE__ */ f.jsxs(Te, { component: "li", children: [
                /* @__PURE__ */ f.jsx(pi, { sx: { my: 0.5 } }),
                /* @__PURE__ */ f.jsx(
                  Te,
                  {
                    onClick: (j) => j.stopPropagation(),
                    onKeyDown: (j) => {
                      j.key !== "Escape" && j.stopPropagation();
                    },
                    sx: { px: 2, py: 0.5 },
                    children: /* @__PURE__ */ f.jsx(
                      Ts,
                      {
                        "data-testid": "show-all-shows-toggle",
                        control: /* @__PURE__ */ f.jsx(
                          Is,
                          {
                            size: "small",
                            checked: l,
                            onChange: (j) => c(j.target.checked),
                            inputProps: { "aria-label": "Show all past shows" }
                          }
                        ),
                        label: "Show all past shows",
                        sx: { mr: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8rem" } }
                      }
                    )
                  }
                )
              ] }, "show-all-shows-toggle-row")
            ]
          }
        ),
        u && !n && /* @__PURE__ */ f.jsx(
          Ts,
          {
            "data-testid": "show-all-shows-toggle",
            control: /* @__PURE__ */ f.jsx(
              Is,
              {
                size: "small",
                checked: l,
                onChange: (j) => c(j.target.checked),
                inputProps: { "aria-label": "Show all past shows" },
                sx: {
                  "& .MuiSwitch-switchBase": { color: "rgba(255,255,255,0.75)" },
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#fff" },
                  "& .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.5)"
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.9)"
                  }
                }
              }
            ),
            label: "Show all past shows",
            sx: {
              color: "inherit",
              ml: 0.5,
              mr: 0,
              "& .MuiFormControlLabel-label": { fontSize: "0.75rem" }
            }
          }
        )
      ]
    }
  );
}, Vi = Tn({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), du = (e, n) => typeof n == "string" && n.includes(":") ? n : `${e}:${n}`, hu = (e) => {
  if (!e) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const n = Li(e), s = n["custom:super"] ?? n.super, i = s === "true" || s === !0, t = new Set(
      Array.isArray(n.permissions) ? n.permissions : []
    );
    return { isSuper: i, permissions: t };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, $d = ({ appNamespace: e, children: n }) => {
  var r;
  const i = (r = Tt().user) == null ? void 0 : r.access_token, t = Vt(() => {
    const { isSuper: a, permissions: o } = hu(i);
    return { appNamespace: e, isSuper: a, permissions: o };
  }, [e, i]);
  return /* @__PURE__ */ f.jsx(Vi.Provider, { value: t, children: n });
}, Bd = (e) => {
  const { appNamespace: n, isSuper: s, permissions: i } = Cn(Vi);
  return s ? !0 : i.has(du(n, e));
}, yn = (e) => typeof e == "string" ? e.trim() : "", Hi = (e) => yn(e == null ? void 0 : e.firstName) || yn(e == null ? void 0 : e.given_name), fu = (e) => yn(e == null ? void 0 : e.lastName) || yn(e == null ? void 0 : e.family_name), zi = (e) => yn(e == null ? void 0 : e.email);
function pu(e) {
  return e ? [Hi(e), fu(e)].filter(Boolean).join(" ") || zi(e) : "";
}
function Jd(e) {
  return e ? Hi(e) || zi(e) : "";
}
const vu = (e, n) => e.length > n ? `${e.slice(0, Math.max(0, n - 1))}…` : e;
function gu({ maxEmailChars: e = 28 }) {
  var o;
  const s = ((o = Tt().user) == null ? void 0 : o.profile) || {}, i = (s.given_name || "").trim(), t = pu(s), r = (s.email || "").trim(), a = i || (r ? vu(r, e) : "");
  return a ? /* @__PURE__ */ f.jsx(Yn, { title: t || r, children: /* @__PURE__ */ f.jsx(
    bn,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: a
    }
  ) }) : null;
}
const mu = ({ accountOrgsUrl: e } = {}) => {
  const { orgs: n, activeOrgId: s, setActiveOrgId: i, isSuper: t } = ns(), { t: r } = po("common");
  return t && (!n || n.length === 0) ? /* @__PURE__ */ f.jsx(
    Te,
    {
      "data-testid": "org-switcher-empty",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: /* @__PURE__ */ f.jsx(
        jr,
        {
          ...e ? { component: "a", href: e, clickable: !0 } : {},
          size: "small",
          icon: /* @__PURE__ */ f.jsx(
            Cs,
            {
              fontSize: "small",
              sx: { color: "inherit !important" }
            }
          ),
          label: e ? r(
            "orgSwitcher.noOrgsEnabledLink",
            "No orgs enabled for switching — manage in Account"
          ) : r("orgSwitcher.noOrgsEnabled", "No orgs enabled for switching"),
          sx: {
            color: "inherit",
            bgcolor: "rgba(255, 255, 255, 0.18)",
            fontWeight: 600,
            ...e && {
              textDecoration: "underline",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.28)" }
            }
          }
        }
      )
    }
  ) : !n || n.length <= 1 ? null : /* @__PURE__ */ f.jsxs(
    Te,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        t && /* @__PURE__ */ f.jsx(
          jr,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ f.jsx(
              Cs,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ f.jsx(fo, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ f.jsx(
          _i,
          {
            value: s || "",
            onChange: (a) => i(a.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (a) => {
              const o = n.find((l) => l.id === a), u = o ? o.name : "";
              return /* @__PURE__ */ f.jsx(
                "span",
                {
                  title: u,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: Gi(u)
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: n.map((a) => /* @__PURE__ */ f.jsx(gn, { value: a.id, children: a.name }, a.id))
          }
        )
      ]
    }
  );
};
function qd({ onLogout: e, brandLogo: n = null, accountOrgsUrl: s }) {
  var l;
  const { mode: i, setMode: t } = Si(), { orgs: r, activeOrgId: a } = ns(), o = ((l = r.find((c) => c.id === a)) == null ? void 0 : l.name) || null, u = [
    {
      icon: i === "dark" ? /* @__PURE__ */ f.jsx(Ti, {}) : /* @__PURE__ */ f.jsx(Ii, {}),
      text: i === "dark" ? "Light mode" : "Dark mode",
      onClick: () => t(i === "dark" ? "light" : "dark")
    },
    {
      icon: /* @__PURE__ */ f.jsx(Ci, {}),
      text: "Sign out",
      onClick: e
    }
  ];
  return /* @__PURE__ */ f.jsx(
    Ro,
    {
      sx: { backgroundColor: xt.darkGrey, color: "#fff" },
      brandLogo: n,
      rightContent: /* @__PURE__ */ f.jsxs(
        Te,
        {
          "data-testid": "gate-header",
          sx: { display: "flex", alignItems: "center", gap: 1.5 },
          children: [
            /* @__PURE__ */ f.jsx(mu, { accountOrgsUrl: s }),
            o && /* @__PURE__ */ f.jsx(
              bn,
              {
                "data-testid": "gate-active-org-name",
                variant: "body2",
                sx: { color: "inherit", opacity: 0.9, whiteSpace: "nowrap" },
                children: o
              }
            ),
            /* @__PURE__ */ f.jsx(gu, {}),
            /* @__PURE__ */ f.jsx(So, { menuItems: u })
          ]
        }
      )
    }
  );
}
const $i = "common-fe.mockAuth", Bi = Tn(null), bu = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function yu() {
  try {
    const e = localStorage.getItem($i);
    return e ? JSON.parse(e) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function Su(e) {
  try {
    localStorage.setItem($i, JSON.stringify(e));
  } catch {
  }
}
function Wd({ children: e, defaultUser: n = bu }) {
  const [s, i] = J(yu);
  xe(() => {
    Su(s);
  }, [s]);
  const t = ut(
    (o) => {
      i({ signedIn: !0, user: o ?? n });
    },
    [n]
  ), r = ut(() => {
    i({ signedIn: !1, user: null });
  }, []), a = Vt(
    () => ({
      isAuthenticated: s.signedIn,
      user: s.user,
      signIn: t,
      signOut: r
    }),
    [s, t, r]
  );
  return /* @__PURE__ */ f.jsx(Bi.Provider, { value: a, children: e });
}
function Ji() {
  const e = Cn(Bi);
  if (!e)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return e;
}
function Zd({ children: e, loginPath: n = "/login" }) {
  const { isAuthenticated: s } = Ji(), i = lo();
  return s ? e : /* @__PURE__ */ f.jsx(xi, { to: n, replace: !0, state: { from: i.pathname } });
}
const wu = "jaybill@foxvillage.com", Ru = "demo-password", xu = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function Yd({
  onSignIn: e,
  brandLogo: n,
  labels: s = {}
}) {
  const { signIn: i } = Ji(), [t, r] = J(wu), [a, o] = J(Ru), [u, l] = J(!1), c = { ...xu, ...s }, d = (m) => {
    m.preventDefault();
    const j = { email: t, displayName: t.split("@")[0] };
    e ? e(j) : i(j);
  }, h = n ?? yi;
  return /* @__PURE__ */ f.jsx(
    ae,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (m) => m.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ f.jsxs(
        Kn,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (m) => m.palette.mode === "dark" ? "#000" : "background.paper",
            color: (m) => m.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ f.jsx(
              ae,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ f.jsx(h, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ f.jsx(Ve, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: c.heading }),
            /* @__PURE__ */ f.jsx(
              Ve,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: c.subheading
              }
            ),
            /* @__PURE__ */ f.jsx(ae, { component: "form", onSubmit: d, children: /* @__PURE__ */ f.jsxs(zt, { spacing: 3, children: [
              /* @__PURE__ */ f.jsx(
                $t,
                {
                  label: c.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: t,
                  onChange: (m) => r(m.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ f.jsxs(ae, { children: [
                /* @__PURE__ */ f.jsx(
                  $t,
                  {
                    label: c.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: a,
                    onChange: (m) => o(m.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ f.jsxs(
                  zt,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ f.jsx(
                        mi,
                        {
                          control: /* @__PURE__ */ f.jsx(
                            bi,
                            {
                              size: "small",
                              checked: u,
                              onChange: (m) => l(m.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: c.showPassword
                        }
                      ),
                      /* @__PURE__ */ f.jsx(
                        xs,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: c.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ f.jsx(
                $e,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: c.submit
                }
              ),
              /* @__PURE__ */ f.jsxs(
                Ve,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    c.newUserPrompt,
                    " ",
                    /* @__PURE__ */ f.jsx(
                      xs,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: c.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var Fr = { d: (e, n) => {
  for (var s in n) Fr.o(n, s) && !Fr.o(e, s) && Object.defineProperty(e, s, { enumerable: !0, get: n[s] });
}, o: (e, n) => Object.prototype.hasOwnProperty.call(e, n) };
const le = (Ns = { default: () => Ei.default }, xr = {}, Fr.d(xr, Ns), xr);
var Ns, xr;
function qi(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function Mr(e, n, s) {
  return Mr = ss() ? Reflect.construct : function(i, t, r) {
    var a = [null];
    a.push.apply(a, t);
    var o = new (Function.bind.apply(i, a))();
    return r && wn(o, r.prototype), o;
  }, Mr.apply(null, arguments);
}
function Wn(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function Sn(e) {
  return Sn = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Sn(e);
}
function wn(e, n) {
  return wn = Object.setPrototypeOf || function(s, i) {
    return s.__proto__ = i, s;
  }, wn(e, n);
}
function Gr(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Gr = function(s) {
    if (s === null || (i = s, Function.toString.call(i).indexOf("[native code]") === -1)) return s;
    var i;
    if (typeof s != "function") throw new TypeError("Super expression must either be null or a function");
    if (n !== void 0) {
      if (n.has(s)) return n.get(s);
      n.set(s, t);
    }
    function t() {
      return Mr(s, arguments, Sn(this).constructor);
    }
    return t.prototype = Object.create(s.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), wn(t, s);
  }, Gr(e);
}
function ss() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ss = function() {
    return !!e;
  })();
}
var ce = "http://localhost".replace(/\/+$/, ""), Yt = function e(n) {
  var s, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ce, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : le.default;
  qi(this, e), Wn(this, "basePath", void 0), Wn(this, "axios", void 0), Wn(this, "configuration", void 0), this.basePath = i, this.axios = t, n && (this.configuration = n, this.basePath = (s = n.basePath) !== null && s !== void 0 ? s : i);
}, _u = function() {
  function e(n, s) {
    var i;
    return qi(this, e), Wn(i = function(t, r, a) {
      return r = Sn(r), o = t, !(u = ss() ? Reflect.construct(r, a || [], Sn(t).constructor) : r.apply(t, a)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, e, [s]), "field", void 0), i.field = n, i.name = "RequiredError", i;
  }
  return function(n, s) {
    if (typeof s != "function" && s !== null) throw new TypeError("Super expression must either be null or a function");
    n.prototype = Object.create(s && s.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), s && wn(n, s);
  }(e, Gr(Error)), e;
}(), fe = {};
function Ls(e, n, s, i, t, r, a) {
  try {
    var o = e[r](a), u = o.value;
  } catch (l) {
    return void s(l);
  }
  o.done ? n(u) : Promise.resolve(u).then(i, t);
}
function Iu(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
var pe = "https://example.com", ie = function(e, n, s) {
  if (s == null) throw new _u(n, "Required parameter ".concat(n, " was null or undefined when calling ").concat(e, "."));
}, Re = function(e, n) {
  return (s = function() {
    var i, t;
    return function(r, a) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(m) {
        return function(j) {
          return function(S) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, S[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & S[0] ? u.return : S[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, S[1])).done) return l;
              switch (u = 0, l && (S = [2 & S[0], l.value]), S[0]) {
                case 0:
                case 1:
                  l = S;
                  break;
                case 4:
                  return c.label++, { value: S[1], done: !1 };
                case 5:
                  c.label++, u = S[1], S = [0];
                  continue;
                case 7:
                  S = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || S[0] !== 6 && S[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (S[0] === 3 && (!l || S[1] > l[0] && S[1] < l[3])) {
                    c.label = S[1];
                    break;
                  }
                  if (S[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = S;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(S);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              S = a.call(r, c);
            } catch (F) {
              S = [6, F], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & S[0]) throw S[1];
            return { value: S[0] ? S[1] : void 0, done: !0 };
          }([m, j]);
        };
      }
    }(this, function(r) {
      switch (r.label) {
        case 0:
          return n && n.accessToken ? typeof n.accessToken != "function" ? [3, 2] : [4, n.accessToken()] : [3, 5];
        case 1:
          return t = r.sent(), [3, 4];
        case 2:
          return [4, n.accessToken];
        case 3:
          t = r.sent(), r.label = 4;
        case 4:
          i = t, e.Authorization = "Bearer " + i, r.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var i = this, t = arguments;
    return new Promise(function(r, a) {
      var o = s.apply(i, t);
      function u(c) {
        Ls(o, r, a, u, l, "next", c);
      }
      function l(c) {
        Ls(o, r, a, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var s;
};
function Vr(e, n) {
  var s, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  n != null && ((n === void 0 ? "undefined" : (s = n) && typeof Symbol < "u" && s.constructor === Symbol ? "symbol" : typeof s) == "object" ? Array.isArray(n) ? n.forEach(function(t) {
    return Vr(e, t, i);
  }) : Object.keys(n).forEach(function(t) {
    return Vr(e, n[t], "".concat(i).concat(i !== "" ? "." : "").concat(t));
  }) : e.has(i) ? e.append(i, n) : e.set(i, n));
}
var ve = function(e) {
  for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) s[i - 1] = arguments[i];
  var t = new URLSearchParams(e.search);
  Vr(t, s), e.search = t.toString();
}, at = function(e, n, s) {
  var i = typeof e != "string";
  return (i && s && s.isJsonMime ? s.isJsonMime(n.headers["Content-Type"]) : i) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, ge = function(e) {
  return e.pathname + e.search + e.hash;
}, me = function(e, n, s, i) {
  return function() {
    var t, r, a, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s, l = (r = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, m = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (m = m.concat(Object.getOwnPropertySymbols(h).filter(function(j) {
          return Object.getOwnPropertyDescriptor(h, j).enumerable;
        }))), m.forEach(function(j) {
          Iu(c, j, h[j]);
        });
      }
      return c;
    }({}, e.options), a = (a = { url: (o.defaults.baseURL ? "" : (t = i == null ? void 0 : i.basePath) !== null && t !== void 0 ? t : u) + e.url }) != null ? a : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(a)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(a)).forEach(function(c) {
      Object.defineProperty(r, c, Object.getOwnPropertyDescriptor(a, c));
    }), r);
    return o.request(l);
  };
};
function Ds(e, n, s, i, t, r, a) {
  try {
    var o = e[r](a), u = o.value;
  } catch (l) {
    return void s(l);
  }
  o.done ? n(u) : Promise.resolve(u).then(i, t);
}
function z(e) {
  return function() {
    var n = this, s = arguments;
    return new Promise(function(i, t) {
      var r = e.apply(n, s);
      function a(u) {
        Ds(r, i, t, a, o, "next", u);
      }
      function o(u) {
        Ds(r, i, t, a, o, "throw", u);
      }
      a(void 0);
    });
  };
}
function Kt(e, n, s) {
  return n = nr(n), i = e, !(t = Wi() ? Reflect.construct(n, s || [], nr(e).constructor) : n.apply(e, s)) || ((r = t) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) != "object" && typeof t != "function" ? function(a) {
    if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }(i) : t;
  var i, t, r;
}
function Qt(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function Tu(e, n) {
  for (var s = 0; s < n.length; s++) {
    var i = n[s];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function Xt(e, n, s) {
  return n && Tu(e.prototype, n), e;
}
function Cu(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function nr(e) {
  return nr = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, nr(e);
}
function en(e, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && Hr(e, n);
}
function V(e) {
  for (var n = 1; n < arguments.length; n++) {
    var s = arguments[n] != null ? arguments[n] : {}, i = Object.keys(s);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(s).filter(function(t) {
      return Object.getOwnPropertyDescriptor(s, t).enumerable;
    }))), i.forEach(function(t) {
      Cu(e, t, s[t]);
    });
  }
  return e;
}
function Hr(e, n) {
  return Hr = Object.setPrototypeOf || function(s, i) {
    return s.__proto__ = i, s;
  }, Hr(e, n);
}
function Wi() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wi = function() {
    return !!e;
  })();
}
function $(e, n) {
  var s, i, t, r = { label: 0, sent: function() {
    if (1 & t[0]) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(u) {
    return function(l) {
      return function(c) {
        if (s) throw new TypeError("Generator is already executing.");
        for (; a && (a = 0, c[0] && (r = 0)), r; ) try {
          if (s = 1, i && (t = 2 & c[0] ? i.return : c[0] ? i.throw || ((t = i.return) && t.call(i), 0) : i.next) && !(t = t.call(i, c[1])).done) return t;
          switch (i = 0, t && (c = [2 & c[0], t.value]), c[0]) {
            case 0:
            case 1:
              t = c;
              break;
            case 4:
              return r.label++, { value: c[1], done: !1 };
            case 5:
              r.label++, i = c[1], c = [0];
              continue;
            case 7:
              c = r.ops.pop(), r.trys.pop();
              continue;
            default:
              if (!((t = (t = r.trys).length > 0 && t[t.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                r = 0;
                continue;
              }
              if (c[0] === 3 && (!t || c[1] > t[0] && c[1] < t[3])) {
                r.label = c[1];
                break;
              }
              if (c[0] === 6 && r.label < t[1]) {
                r.label = t[1], t = c;
                break;
              }
              if (t && r.label < t[2]) {
                r.label = t[2], r.ops.push(c);
                break;
              }
              t[2] && r.ops.pop(), r.trys.pop();
              continue;
          }
          c = n.call(e, r);
        } catch (d) {
          c = [6, d], i = 0;
        } finally {
          s = t = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var Eu = function(e) {
  return { publicScoreSheetsConfigGet: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return z(function() {
      var s, i, t, r, a;
      return $(this, function(o) {
        return s = new URL("/public/score-sheets/config", pe), e && (i = e.baseOptions), t = V({ method: "GET" }, i, n), r = {}, ve(s, {}), a = i && i.headers ? i.headers : {}, t.headers = V({}, r, a, n.headers), [2, { url: ge(s), options: t }];
      });
    })();
  }, publicScoreSheetsRequestPost: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        return ie("publicScoreSheetsRequestPost", "publicScoreSheetsRequestPostRequest", n), i = new URL("/public/score-sheets/request", pe), e && (t = e.baseOptions), r = V({ method: "POST" }, t, s), o = {}, (a = {})["Content-Type"] = "application/json", ve(i, o), u = t && t.headers ? t.headers : {}, r.headers = V({}, a, u, s.headers), r.data = at(n, r, e), [2, { url: ge(i), options: r }];
      });
    })();
  }, publicScoreSheetsTokenGet: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        return ie("publicScoreSheetsTokenGet", "token", n), i = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), o = {}, ve(t, {}), u = r && r.headers ? r.headers : {}, a.headers = V({}, o, u, s.headers), [2, { url: ge(t), options: a }];
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(n, s, i) {
    var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        return ie("publicSheetsRequestIdRideIdVariantUrlGet", "requestId", n), ie("publicSheetsRequestIdRideIdVariantUrlGet", "rideId", s), ie("publicSheetsRequestIdRideIdVariantUrlGet", "variant", i), r = "/public/sheets/{requestId}/{rideId}/{variant}/url".replace("{requestId}", encodeURIComponent(String(n))).replace("{rideId}", encodeURIComponent(String(s))).replace("{variant}", encodeURIComponent(String(i))), a = new URL(r, pe), e && (o = e.baseOptions), u = V({ method: "GET" }, o, t), l = {}, ve(a, {}), c = o && o.headers ? o.headers : {}, u.headers = V({}, l, c, t.headers), [2, { url: ge(a), options: u }];
      });
    })();
  } };
}, Dn = function(e) {
  var n = Eu(e);
  return { publicScoreSheetsConfigGet: function(s) {
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.publicScoreSheetsConfigGet(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = fe["DefaultApi.publicScoreSheetsConfigGet"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return me(r, le.default, ce, e)(c, u || d);
            }];
        }
      });
    })();
  }, publicScoreSheetsRequestPost: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.publicScoreSheetsRequestPost(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["DefaultApi.publicScoreSheetsRequestPost"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, publicScoreSheetsTokenGet: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.publicScoreSheetsTokenGet(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["DefaultApi.publicScoreSheetsTokenGet"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, publicSheetsRequestIdRideIdVariantUrlGet: function(s, i, t, r) {
    return z(function() {
      var a, o, u, l, c, d;
      return $(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, n.publicSheetsRequestIdRideIdVariantUrlGet(s, i, t, r)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = fe["DefaultApi.publicSheetsRequestIdRideIdVariantUrlGet"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return me(u, le.default, ce, e)(m, d || j);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Qt(this, n), Kt(this, n, arguments);
  }
  return en(n, e), Xt(n, [{ key: "publicScoreSheetsConfigGet", value: function(s) {
    var i = this;
    return Dn(this.configuration).publicScoreSheetsConfigGet(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "publicScoreSheetsRequestPost", value: function(s, i) {
    var t = this;
    return Dn(this.configuration).publicScoreSheetsRequestPost(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "publicScoreSheetsTokenGet", value: function(s, i) {
    var t = this;
    return Dn(this.configuration).publicScoreSheetsTokenGet(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "publicSheetsRequestIdRideIdVariantUrlGet", value: function(s, i, t, r) {
    var a = this;
    return Dn(this.configuration).publicSheetsRequestIdRideIdVariantUrlGet(s, i, t, r).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }]), n;
})(Yt);
var Ou = function(e) {
  return { correctUsefClass: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("correctUsefClass", "classId", n), ie("correctUsefClass", "uploadUsefClassRequest", s), t = "/federation/usef/classes/{classId}/correct".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, deleteUsefClass: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("deleteUsefClass", "classId", n), ie("deleteUsefClass", "deleteUsefClassRequest", s), t = "/federation/usef/classes/{classId}/delete".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, finalizeUsefClass: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("finalizeUsefClass", "classId", n), ie("finalizeUsefClass", "deleteUsefClassRequest", s), t = "/federation/usef/classes/{classId}/finalize".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, getFederationClassAudit: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getFederationClassAudit", "classId", n), i = "/federation/classes/{classId}/audit".replace("{classId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, getFederationShowAudit: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getFederationShowAudit", "showId", n), i = "/federation/shows/{showId}/audit".replace("{showId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, getFederationShowState: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getFederationShowState", "showId", n), i = "/federation/shows/{showId}/state".replace("{showId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getUsefDeadlineStatus", "competitionEndDate", n), t = new URL("/federation/usef/deadline", pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, i), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), n !== void 0 && (u.competitionEndDate = n), s !== void 0 && (u.showId = s), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, i.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, listUsefDressageSections: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return ie("listUsefDressageSections", "compYear", n), i = new URL("/federation/usef/sections", pe), e && (t = e.baseOptions), r = V({ method: "GET" }, t, s), o = {}, [4, Re(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.compYear = n), ve(i, o), u = t && t.headers ? t.headers : {}, r.headers = V({}, a, u, s.headers), [2, { url: ge(i), options: r }];
        }
      });
    })();
  }, listUsefDressageTests: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return ie("listUsefDressageTests", "testYear", n), i = new URL("/federation/usef/tests", pe), e && (t = e.baseOptions), r = V({ method: "GET" }, t, s), o = {}, [4, Re(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.testYear = n), ve(i, o), u = t && t.headers ? t.headers : {}, r.headers = V({}, a, u, s.headers), [2, { url: ge(i), options: r }];
        }
      });
    })();
  }, markClassForRepublish: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("markClassForRepublish", "classId", n), ie("markClassForRepublish", "markClassForRepublishRequest", s), t = "/federation/usef/classes/{classId}/mark-for-republish".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, previewClassResult: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("previewClassResult", "classId", n), i = "/federation/classes/{classId}/preview".replace("{classId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, previewShowResults: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("previewShowResults", "showId", n), i = "/federation/shows/{showId}/preview".replace("{showId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, publishUsdfShow: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("publishUsdfShow", "showId", n), t = "/federation/usdf/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, publishUsefShow: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("publishUsefShow", "showId", n), ie("publishUsefShow", "publishUsefShowRequest", s), t = "/federation/usef/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, submitUsefShow: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("submitUsefShow", "showId", n), ie("submitUsefShow", "submitUsefShowRequest", s), t = "/federation/usef/shows/{showId}/submit".replace("{showId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, uploadUsefClass: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("uploadUsefClass", "classId", n), ie("uploadUsefClass", "uploadUsefClassRequest", s), t = "/federation/usef/classes/{classId}/upload".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  } };
}, Be = function(e) {
  var n = Ou(e);
  return { correctUsefClass: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.correctUsefClass(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.correctUsefClass"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, deleteUsefClass: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.deleteUsefClass(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.deleteUsefClass"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, finalizeUsefClass: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.finalizeUsefClass(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.finalizeUsefClass"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, getFederationClassAudit: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getFederationClassAudit(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.getFederationClassAudit"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getFederationShowAudit: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getFederationShowAudit(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.getFederationShowAudit"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getFederationShowState: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getFederationShowState(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.getFederationShowState"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.getUsefDeadlineStatus(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.getUsefDeadlineStatus"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, listUsefDressageSections: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listUsefDressageSections(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.listUsefDressageSections"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, listUsefDressageTests: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listUsefDressageTests(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.listUsefDressageTests"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, markClassForRepublish: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.markClassForRepublish(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.markClassForRepublish"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, previewClassResult: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.previewClassResult(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.previewClassResult"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, previewShowResults: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.previewShowResults(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["FederationApi.previewShowResults"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, publishUsdfShow: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.publishUsdfShow(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.publishUsdfShow"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, publishUsefShow: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.publishUsefShow(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.publishUsefShow"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, submitUsefShow: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.submitUsefShow(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.submitUsefShow"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, uploadUsefClass: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.uploadUsefClass(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["FederationApi.uploadUsefClass"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Qt(this, n), Kt(this, n, arguments);
  }
  return en(n, e), Xt(n, [{ key: "correctUsefClass", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).correctUsefClass(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "deleteUsefClass", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).deleteUsefClass(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "finalizeUsefClass", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).finalizeUsefClass(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "getFederationClassAudit", value: function(s, i) {
    var t = this;
    return Be(this.configuration).getFederationClassAudit(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getFederationShowAudit", value: function(s, i) {
    var t = this;
    return Be(this.configuration).getFederationShowAudit(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getFederationShowState", value: function(s, i) {
    var t = this;
    return Be(this.configuration).getFederationShowState(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getUsefDeadlineStatus", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).getUsefDeadlineStatus(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "listUsefDressageSections", value: function(s, i) {
    var t = this;
    return Be(this.configuration).listUsefDressageSections(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listUsefDressageTests", value: function(s, i) {
    var t = this;
    return Be(this.configuration).listUsefDressageTests(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "markClassForRepublish", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).markClassForRepublish(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "previewClassResult", value: function(s, i) {
    var t = this;
    return Be(this.configuration).previewClassResult(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "previewShowResults", value: function(s, i) {
    var t = this;
    return Be(this.configuration).previewShowResults(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "publishUsdfShow", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).publishUsdfShow(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "publishUsefShow", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).publishUsefShow(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "submitUsefShow", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).submitUsefShow(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "uploadUsefClass", value: function(s, i, t) {
    var r = this;
    return Be(this.configuration).uploadUsefClass(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Yt);
var ku = function(e) {
  return { getHealth: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return z(function() {
      var s, i, t, r, a;
      return $(this, function(o) {
        return s = new URL("/health", pe), e && (i = e.baseOptions), t = V({ method: "GET" }, i, n), r = {}, ve(s, {}), a = i && i.headers ? i.headers : {}, t.headers = V({}, r, a, n.headers), [2, { url: ge(s), options: t }];
      });
    })();
  } };
}, Au = function(e) {
  var n = ku(e);
  return { getHealth: function(s) {
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.getHealth(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = fe["HealthApi.getHealth"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return me(r, le.default, ce, e)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Qt(this, n), Kt(this, n, arguments);
  }
  return en(n, e), Xt(n, [{ key: "getHealth", value: function(s) {
    var i = this;
    return Au(this.configuration).getHealth(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }]), n;
})(Yt);
var Pu = function(e) {
  return { createReportRun: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("createReportRun", "id", n), t = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  }, listReports: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/reports", pe), e && (t = e.baseOptions), r = V({ method: "GET" }, t, s), o = {}, [4, Re(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.domain = n), ve(i, o), u = t && t.headers ? t.headers : {}, r.headers = V({}, a, u, s.headers), [2, { url: ge(i), options: r }];
        }
      });
    })();
  } };
}, Fs = function(e) {
  var n = Pu(e);
  return { createReportRun: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.createReportRun(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["ReportsApi.createReportRun"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  }, listReports: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listReports(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["ReportsApi.listReports"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  } };
}, ju = function(e) {
  function n() {
    return Qt(this, n), Kt(this, n, arguments);
  }
  return en(n, e), Xt(n, [{ key: "createReportRun", value: function(s, i, t) {
    var r = this;
    return Fs(this.configuration).createReportRun(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "listReports", value: function(s, i) {
    var t = this;
    return Fs(this.configuration).listReports(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
}(Yt), Uu = function(e) {
  return { getScorePageLink: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getScorePageLink", "rideId", n), i = "/score-sheets/rides/{rideId}/link".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, getScoreSheetStatus: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getScoreSheetStatus", "rideId", n), i = "/score-sheets/rides/{rideId}/status".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, resendScoreSheet: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return z(function() {
      var t, r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return ie("resendScoreSheet", "rideId", n), t = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, pe), e && (a = e.baseOptions), o = V({ method: "POST" }, a, i), l = {}, [4, Re(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", ve(r, l), c = a && a.headers ? a.headers : {}, o.headers = V({}, u, c, i.headers), o.data = at(s, o, e), [2, { url: ge(r), options: o }];
        }
      });
    })();
  } };
}, _r = function(e) {
  var n = Uu(e);
  return { getScorePageLink: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getScorePageLink(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["RiderSheetsApi.getScorePageLink"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetStatus: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getScoreSheetStatus(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["RiderSheetsApi.getScoreSheetStatus"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, resendScoreSheet: function(s, i, t) {
    return z(function() {
      var r, a, o, u, l, c;
      return $(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.resendScoreSheet(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = fe["RiderSheetsApi.resendScoreSheet"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return me(o, le.default, ce, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Qt(this, n), Kt(this, n, arguments);
  }
  return en(n, e), Xt(n, [{ key: "getScorePageLink", value: function(s, i) {
    var t = this;
    return _r(this.configuration).getScorePageLink(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getScoreSheetStatus", value: function(s, i) {
    var t = this;
    return _r(this.configuration).getScoreSheetStatus(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "resendScoreSheet", value: function(s, i, t) {
    var r = this;
    return _r(this.configuration).resendScoreSheet(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Yt);
var Nu = function(e) {
  return { clearRuns: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/runs", pe), e && (t = e.baseOptions), r = V({ method: "DELETE" }, t, s), o = {}, [4, Re(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.reportId = n), ve(i, o), u = t && t.headers ? t.headers : {}, r.headers = V({}, a, u, s.headers), [2, { url: ge(i), options: r }];
        }
      });
    })();
  }, deleteRun: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("deleteRun", "id", n), i = "/runs/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "DELETE" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, getRun: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return ie("getRun", "id", n), i = "/runs/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, pe), e && (r = e.baseOptions), a = V({ method: "GET" }, r, s), u = {}, [4, Re(o = {}, e)];
          case 1:
            return c.sent(), ve(t, u), l = r && r.headers ? r.headers : {}, a.headers = V({}, o, l, s.headers), [2, { url: ge(t), options: a }];
        }
      });
    })();
  }, listRuns: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return z(function() {
      var i, t, r, a, o, u;
      return $(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/runs", pe), e && (t = e.baseOptions), r = V({ method: "GET" }, t, s), o = {}, [4, Re(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.reportId = n), ve(i, o), u = t && t.headers ? t.headers : {}, r.headers = V({}, a, u, s.headers), [2, { url: ge(i), options: r }];
        }
      });
    })();
  } };
}, Fn = function(e) {
  var n = Nu(e);
  return { clearRuns: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.clearRuns(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["RunsApi.clearRuns"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteRun: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteRun(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["RunsApi.deleteRun"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRun: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getRun(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["RunsApi.getRun"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  }, listRuns: function(s, i) {
    return z(function() {
      var t, r, a, o, u, l;
      return $(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listRuns(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = fe["RunsApi.listRuns"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return me(a, le.default, ce, e)(d, l || h);
            }];
        }
      });
    })();
  } };
}, Lu = function(e) {
  function n() {
    return Qt(this, n), Kt(this, n, arguments);
  }
  return en(n, e), Xt(n, [{ key: "clearRuns", value: function(s, i) {
    var t = this;
    return Fn(this.configuration).clearRuns(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteRun", value: function(s, i) {
    var t = this;
    return Fn(this.configuration).deleteRun(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getRun", value: function(s, i) {
    var t = this;
    return Fn(this.configuration).getRun(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listRuns", value: function(s, i) {
    var t = this;
    return Fn(this.configuration).listRuns(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
}(Yt);
function Du(e, n) {
  for (var s = 0; s < n.length; s++) {
    var i = n[s];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function vt(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function Ms(e) {
  for (var n = 1; n < arguments.length; n++) {
    var s = arguments[n] != null ? arguments[n] : {}, i = Object.keys(s);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(s).filter(function(t) {
      return Object.getOwnPropertyDescriptor(s, t).enumerable;
    }))), i.forEach(function(t) {
      vt(e, t, s[t]);
    });
  }
  return e;
}
var Fu = function() {
  function e() {
    var i, t, r, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), vt(this, "apiKey", void 0), vt(this, "username", void 0), vt(this, "password", void 0), vt(this, "accessToken", void 0), vt(this, "basePath", void 0), vt(this, "serverIndex", void 0), vt(this, "baseOptions", void 0), vt(this, "formDataCtor", void 0), this.apiKey = a.apiKey, this.username = a.username, this.password = a.password, this.accessToken = a.accessToken, this.basePath = a.basePath, this.serverIndex = a.serverIndex, this.baseOptions = (t = Ms({}, a.baseOptions), r = (r = { headers: Ms({}, (i = a.baseOptions) === null || i === void 0 ? void 0 : i.headers) }) != null ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(r)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(r, o));
    }), t), this.formDataCtor = a.formDataCtor;
  }
  var n, s;
  return n = e, (s = [{ key: "isJsonMime", value: function(i) {
    var t = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return i !== null && (t.test(i) || i.toLowerCase() === "application/json-patch+json");
  } }]) && Du(n.prototype, s), e;
}();
function Mu() {
  var i;
  const e = Tt(), { activeOrgId: n } = ns(), s = (i = e.user) == null ? void 0 : i.access_token;
  return ut(
    (t) => ({
      basePath: t,
      accessToken: s,
      baseOptions: n ? { headers: { "X-Org-Id": n } } : void 0
    }),
    [s, n]
  );
}
function Gu(e) {
  const n = Mu();
  return Vt(() => {
    const s = new Fu(n(e));
    return {
      reports: new ju(s),
      runs: new Lu(s)
    };
  }, [n, e]);
}
function Ht(e) {
  var s;
  const n = e == null ? void 0 : e.data;
  if (!n || n.status !== "success") {
    const i = ((s = n == null ? void 0 : n.data) == null ? void 0 : s.message) || (n == null ? void 0 : n.code) || "Request failed";
    throw new Error(i);
  }
  return n.data;
}
const Vu = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, Hu = (e) => (e == null ? void 0 : e.name) ?? "";
function zu({
  api: e,
  domain: n,
  onSelect: s,
  selectedId: i,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: t,
  labels: r = {},
  resolveReportName: a = Hu
}) {
  const o = { ...Vu, ...r }, [u, l] = J([]), [c, d] = J(!0), [h, m] = J(null), j = rt(!1);
  return xe(() => {
    if (j.current || !t || u.length === 0) return;
    const S = u.find((F) => F.id === t);
    S && (j.current = !0, s == null || s(S));
  }, [u, t, s]), xe(() => {
    let S = !1;
    return d(!0), m(null), e.reports.listReports(n).then((F) => {
      S || l(Ht(F) || []);
    }).catch((F) => {
      S || m(F.message || o.error);
    }).finally(() => {
      S || d(!1);
    }), () => {
      S = !0;
    };
  }, [e, n, o.error]), c ? /* @__PURE__ */ f.jsx(ae, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ f.jsx(En, { "data-testid": "report-list-loading" }) }) : h ? /* @__PURE__ */ f.jsx(mn, { severity: "error", children: h }) : u.length === 0 ? /* @__PURE__ */ f.jsx(Ve, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ f.jsx(Ma, { "data-testid": "report-list", children: u.map((S) => /* @__PURE__ */ f.jsx(
    Ga,
    {
      selected: S.id === i,
      onClick: () => s == null ? void 0 : s(S),
      children: /* @__PURE__ */ f.jsx(
        Va,
        {
          primary: a(S),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    S.id
  )) });
}
function $u(e) {
  return e.default !== void 0 ? e.default : e.type === "boolean" ? !1 : "";
}
const on = (e) => e !== "" && e !== void 0 && e !== null, Bu = {
  submit: "Run report",
  required: "Required"
}, Ju = (e, n, s) => (s == null ? void 0 : s.title) || n;
function qu({
  def: e,
  onSubmit: n,
  submitting: s = !1,
  labels: i = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: t = {},
  fieldRenderers: r = {},
  resolveParamLabel: a = Ju,
  // #1995 — when true AND every required param is already supplied by
  // `context` (a full deep-link, e.g. RideEditor's "Score Sheet Report"
  // button), submit automatically the first time that becomes true instead
  // of making the admin click "Run report" on a form with nothing left to
  // fill in. Guarded to fire at most once per mounted `def`.
  autoSubmit: o = !1
}) {
  var ue, de;
  const u = { ...Bu, ...i }, l = ((ue = e == null ? void 0 : e.paramsSchema) == null ? void 0 : ue.properties) || {}, c = ((de = e == null ? void 0 : e.paramsSchema) == null ? void 0 : de.required) || [], d = Object.entries(l).filter(([W]) => !on(t[W])), [h, m] = J(() => {
    const W = {};
    for (const [Se, Fe] of Object.entries(l))
      on(t[Se]) || (W[Se] = $u(Fe));
    return W;
  }), [j, S] = J(!1), F = (W, Se) => m((Fe) => ({ ...Fe, [W]: Se })), q = c.filter((W) => on(t[W]) ? !1 : !on(h[W])), B = () => {
    const W = {};
    for (const [Se, Fe] of Object.entries(l)) {
      if (on(t[Se])) {
        W[Se] = t[Se];
        continue;
      }
      const et = h[Se];
      et === "" && !c.includes(Se) || (W[Se] = Fe.type === "number" || Fe.type === "integer" ? Number(et) : et);
    }
    return W;
  }, be = (W) => {
    W.preventDefault(), S(!0), !(q.length > 0) && n(B());
  }, ee = rt(!1);
  return xe(() => {
    ee.current = !1;
  }, [e == null ? void 0 : e.id]), xe(() => {
    !o || ee.current || q.length > 0 || (ee.current = !0, n(B()));
  }, [o, q.length]), /* @__PURE__ */ f.jsx(ae, { component: "form", onSubmit: be, noValidate: !0, children: /* @__PURE__ */ f.jsxs(zt, { spacing: 2, children: [
    d.map(([W, Se]) => {
      const Fe = a(e, W, Se), et = c.includes(W), ct = j && et && q.includes(W), dt = r[W];
      if (dt)
        return /* @__PURE__ */ f.jsx(Aa, { children: dt({
          value: h[W],
          onChange: (Ie) => F(W, Ie),
          label: Fe,
          required: et,
          error: ct,
          disabled: s
        }) }, W);
      if (Se.type === "boolean")
        return /* @__PURE__ */ f.jsx(
          mi,
          {
            control: /* @__PURE__ */ f.jsx(
              bi,
              {
                color: "default",
                checked: !!h[W],
                onChange: (Ie) => F(W, Ie.target.checked)
              }
            ),
            label: Fe
          },
          W
        );
      if (Array.isArray(Se.enum))
        return /* @__PURE__ */ f.jsx(
          $t,
          {
            select: !0,
            label: Fe,
            required: et,
            error: ct,
            helperText: ct ? u.required : Se.description,
            value: h[W] ?? "",
            onChange: (Ie) => F(W, Ie.target.value),
            fullWidth: !0,
            children: Se.enum.map((Ie) => /* @__PURE__ */ f.jsx(Ha, { value: Ie, children: String(Ie) }, String(Ie)))
          },
          W
        );
      const qe = Se.type === "number" || Se.type === "integer";
      return /* @__PURE__ */ f.jsx(
        $t,
        {
          label: Fe,
          type: qe ? "number" : "text",
          required: et,
          error: ct,
          helperText: ct ? u.required : Se.description,
          value: h[W] ?? "",
          onChange: (Ie) => F(W, Ie.target.value),
          fullWidth: !0
        },
        W
      );
    }),
    /* @__PURE__ */ f.jsx(ae, { children: /* @__PURE__ */ f.jsx($e, { type: "submit", variant: "contained", loading: s, children: u.submit }) })
  ] }) });
}
const Wu = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), Zu = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function Yu(e) {
  if (!e) return "";
  const n = new Date(e);
  return isNaN(n.getTime()) ? e : n.toLocaleString();
}
const Ku = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, Qu = (e) => e;
function Xu({
  api: e,
  onView: n,
  onDelete: s,
  refreshKey: i = 0,
  labels: t = {},
  resolveReportName: r = Qu
}) {
  const a = { ...Ku, ...t }, [o, u] = J([]), [l, c] = J(!0), [d, h] = J(null), m = rt(null), j = ut(async () => {
    try {
      const S = await e.runs.listRuns();
      u(Ht(S) || []), h(null);
    } catch (S) {
      h(S.message || a.error);
    } finally {
      c(!1);
    }
  }, [e, a.error]);
  return xe(() => {
    j();
  }, [j, i]), xe(() => {
    if (!o.some((F) => Wu.has(F.status))) {
      m.current && clearInterval(m.current), m.current = null;
      return;
    }
    return m.current || (m.current = setInterval(j, 4e3)), () => {
      m.current && (clearInterval(m.current), m.current = null);
    };
  }, [o, j]), l ? /* @__PURE__ */ f.jsx(ae, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ f.jsx(En, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ f.jsx(mn, { severity: "error", children: d }) : o.length === 0 ? /* @__PURE__ */ f.jsx(Ve, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ f.jsxs(za, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ f.jsx($a, { children: /* @__PURE__ */ f.jsxs(_s, { children: [
      /* @__PURE__ */ f.jsx(yt, { children: a.colReport }),
      /* @__PURE__ */ f.jsx(yt, { children: a.colRequested }),
      /* @__PURE__ */ f.jsx(yt, { children: a.colStatus }),
      /* @__PURE__ */ f.jsx(yt, { align: "right", children: a.colActions })
    ] }) }),
    /* @__PURE__ */ f.jsx(Ba, { children: o.map((S) => /* @__PURE__ */ f.jsxs(_s, { "data-testid": `run-row-${S.id}`, children: [
      /* @__PURE__ */ f.jsx(yt, { sx: { color: "text.primary" }, children: r(S.reportId) }),
      /* @__PURE__ */ f.jsx(yt, { sx: { color: "text.primary" }, children: Yu(S.createdAt) }),
      /* @__PURE__ */ f.jsx(yt, { children: /* @__PURE__ */ f.jsx(
        gi,
        {
          size: "small",
          label: S.status,
          color: Zu[S.status] || "default"
        }
      ) }),
      /* @__PURE__ */ f.jsxs(yt, { align: "right", children: [
        /* @__PURE__ */ f.jsx(
          $e,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: S.status !== "COMPLETE",
            onClick: () => n == null ? void 0 : n(S),
            children: a.view
          }
        ),
        s && /* @__PURE__ */ f.jsx(
          Xn,
          {
            size: "small",
            color: "inherit",
            "aria-label": a.delete,
            title: a.delete,
            sx: { ml: 1 },
            onClick: () => s(S),
            children: /* @__PURE__ */ f.jsx(go, { fontSize: "small" })
          }
        )
      ] })
    ] }, S.id)) })
  ] });
}
const el = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function tl({ api: e, runId: n, height: s = 600, labels: i = {} }) {
  const t = { ...el, ...i }, [r, a] = J(null), [o, u] = J(!0), [l, c] = J(null);
  return xe(() => {
    if (!n) return;
    let d = !1;
    return u(!0), c(null), e.runs.getRun(n).then((h) => {
      if (d) return;
      const m = Ht(h);
      if (m.status !== "COMPLETE" || !m.artifactUrls) {
        c(m.status === "FAILED" ? t.failed : t.notReady);
        return;
      }
      a(m.artifactUrls);
    }).catch((h) => {
      d || c(h.message || t.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [e, n, t.error, t.failed, t.notReady]), n ? o ? /* @__PURE__ */ f.jsx(ae, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ f.jsx(En, { "data-testid": "report-viewer-loading" }) }) : l ? /* @__PURE__ */ f.jsx(mn, { severity: "error", children: l }) : r ? /* @__PURE__ */ f.jsxs(zt, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ f.jsxs(zt, { direction: "row", spacing: 1, children: [
      r.pdf && /* @__PURE__ */ f.jsx($e, { variant: "outlined", href: r.pdf, target: "_blank", rel: "noopener", children: t.openPdf }),
      r.html && /* @__PURE__ */ f.jsx($e, { variant: "text", href: r.html, target: "_blank", rel: "noopener", children: t.openHtml })
    ] }),
    r.html && /* @__PURE__ */ f.jsx(
      ae,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: t.preview,
        src: r.html,
        sx: { width: "100%", height: s, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const nl = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, rl = (e) => (e == null ? void 0 : e.name) ?? (e == null ? void 0 : e.id) ?? "", sl = (e, n, s) => (s == null ? void 0 : s.title) || n;
function Gs(e) {
  const n = document.createElement("a");
  n.href = e, n.target = "_blank", n.rel = "noopener", n.download = "", document.body.appendChild(n), n.click(), n.remove();
}
function Kd({
  basePath: e,
  domain: n,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: s,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: i = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: t = {},
  paramsFieldRenderers: r = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: a,
  // #1995 — when true, a deep-linked def whose required params are already
  // fully supplied by `paramsContext` runs immediately (skipping the manual
  // "Run report" click) instead of just being pre-filled. See
  // ReportParamsForm's `autoSubmit` for the fire-once guard.
  autoRun: o = !1,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: u = rl,
  resolveParamLabel: l = sl
}) {
  var jn, Un;
  const c = { ...nl, ...i }, d = Gu(e), [h, m] = J(null), [j, S] = J(!1), [F, q] = J(null), [B, be] = J(0), [ee, ue] = J(""), [de, W] = J(null), [Se, Fe] = J({});
  xe(() => {
    let Ce = !1;
    return d.reports.listReports(n).then((Me) => {
      if (Ce) return;
      const tt = {};
      for (const ht of Ht(Me) || []) tt[ht.id] = ht;
      Fe(tt);
    }).catch(() => {
    }), () => {
      Ce = !0;
    };
  }, [d, n]);
  const et = (Ce) => {
    var Me;
    return u({ id: Ce, name: (Me = Se[Ce]) == null ? void 0 : Me.name });
  }, [ct, dt] = J(!1), [qe, Ie] = J(null), [we, Pt] = J(null), jt = rt(!1), tn = rt(!1), On = async (Ce) => {
    if (h) {
      tn.current = !0, S(!0), q(null);
      try {
        const Me = Ht(await d.reports.createReportRun(h.id, { params: Ce }));
        be((tt) => tt + 1), m(null), jt.current = !1, Pt(Me), Ie(Me.id);
      } catch (Me) {
        q(Me.message || c.failedToStart);
      } finally {
        S(!1);
      }
    }
  };
  xe(() => {
    if (!qe) return;
    let Ce = !1, Me;
    const tt = async () => {
      var ht, Ct;
      try {
        const ft = Ht(await d.runs.getRun(qe));
        if (Ce) return;
        if (Pt(ft), ft.status === "COMPLETE") {
          be((dr) => dr + 1);
          const Et = ((ht = ft.artifactUrls) == null ? void 0 : ht.pdf) || ((Ct = ft.artifactUrls) == null ? void 0 : Ct.html);
          Et && !jt.current && (jt.current = !0, Gs(Et));
          return;
        }
        if (ft.status === "FAILED") {
          be((Et) => Et + 1);
          return;
        }
        Me = setTimeout(tt, 3e3);
      } catch {
        Ce || Pt((ft) => ({ ...ft || {}, status: "FAILED" }));
      }
    };
    return Me = setTimeout(tt, 1200), () => {
      Ce = !0, clearTimeout(Me);
    };
  }, [qe, d]);
  const [kn, nn] = J(!1), An = async () => {
    if (!(typeof window < "u" && !window.confirm(c.clearConfirm))) {
      nn(!0);
      try {
        await d.runs.clearRuns(), be((Ce) => Ce + 1);
      } finally {
        nn(!1);
      }
    }
  }, Pn = async (Ce) => {
    await d.runs.deleteRun(Ce.id), be((Me) => Me + 1);
  };
  return /* @__PURE__ */ f.jsxs(ae, { children: [
    /* @__PURE__ */ f.jsx(Ve, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: s ?? c.title }),
    /* @__PURE__ */ f.jsxs(ae, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ f.jsx(ae, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ f.jsx(Kn, { variant: "outlined", children: /* @__PURE__ */ f.jsxs(Qn, { children: [
        /* @__PURE__ */ f.jsx(Ve, { variant: "subtitle1", sx: { color: "text.primary" }, children: c.availableReports }),
        /* @__PURE__ */ f.jsx(
          zu,
          {
            api: d,
            domain: n,
            selectedId: h == null ? void 0 : h.id,
            autoSelectId: a,
            onSelect: m,
            labels: { empty: c.noReports, error: c.failedToLoadReports },
            resolveReportName: u
          }
        ),
        /* @__PURE__ */ f.jsx(
          $e,
          {
            fullWidth: !0,
            variant: "text",
            color: "inherit",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => dt(!0),
            children: c.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ f.jsx(ae, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: h && /* @__PURE__ */ f.jsx(Kn, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ f.jsxs(Qn, { children: [
        /* @__PURE__ */ f.jsx(Ve, { variant: "subtitle1", sx: { color: "text.primary" }, children: u(h) }),
        /* @__PURE__ */ f.jsx(Ja, { sx: { my: 1 } }),
        F && /* @__PURE__ */ f.jsx(mn, { severity: "error", sx: { mb: 2 }, children: F }),
        /* @__PURE__ */ f.jsx(
          qu,
          {
            def: h,
            onSubmit: On,
            submitting: j,
            autoSubmit: o && !tn.current && (h == null ? void 0 : h.id) === a,
            labels: { submit: c.runReport, required: c.required },
            context: t,
            fieldRenderers: typeof r == "function" ? r(h) : r,
            resolveParamLabel: l
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ f.jsxs(Jn, { open: ct, onClose: () => dt(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ f.jsx(br, { children: c.runHistory }),
      /* @__PURE__ */ f.jsx(qn, { children: /* @__PURE__ */ f.jsx(
        Xu,
        {
          api: d,
          refreshKey: B,
          onView: (Ce) => W(Ce.id),
          onDelete: Pn,
          labels: {
            empty: c.noRuns,
            error: c.failedToLoadRuns,
            colReport: c.colReport,
            colRequested: c.colRequested,
            colStatus: c.colStatus,
            colActions: c.colActions,
            view: c.view,
            delete: c.delete
          },
          resolveReportName: et
        }
      ) }),
      /* @__PURE__ */ f.jsxs(Pr, { children: [
        /* @__PURE__ */ f.jsx($e, { color: "error", onClick: An, disabled: kn, children: c.clearHistory }),
        /* @__PURE__ */ f.jsx($e, { color: "inherit", onClick: () => dt(!1), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ f.jsxs(Jn, { open: !!de, onClose: () => W(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ f.jsx(br, { children: c.reportDialogTitle }),
      /* @__PURE__ */ f.jsx(qn, { children: /* @__PURE__ */ f.jsx(
        tl,
        {
          api: d,
          runId: de,
          labels: {
            failed: c.runFailed,
            notReady: c.runNotReady,
            error: c.failedToLoadReport,
            openPdf: c.openPdf,
            openHtml: c.openHtml,
            preview: c.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ f.jsxs(Jn, { open: !!qe, onClose: () => Ie(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ f.jsx(br, { children: (we == null ? void 0 : we.status) === "COMPLETE" ? c.runningDoneTitle : (we == null ? void 0 : we.status) === "FAILED" ? c.runningFailedTitle : c.runningTitle }),
      /* @__PURE__ */ f.jsx(qn, { children: (we == null ? void 0 : we.status) === "FAILED" ? /* @__PURE__ */ f.jsx(mn, { severity: "error", children: c.runFailed }) : (we == null ? void 0 : we.status) === "COMPLETE" ? /* @__PURE__ */ f.jsx(Ve, { sx: { color: "text.primary" }, children: c.runningDoneMessage }) : /* @__PURE__ */ f.jsxs(ae, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ f.jsx(En, { size: 26, color: "inherit" }),
        /* @__PURE__ */ f.jsx(Ve, { sx: { color: "text.primary" }, children: c.runningMessage })
      ] }) }),
      /* @__PURE__ */ f.jsxs(Pr, { children: [
        (we == null ? void 0 : we.status) === "COMPLETE" && (((jn = we.artifactUrls) == null ? void 0 : jn.pdf) || ((Un = we.artifactUrls) == null ? void 0 : Un.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ f.jsx(
          $e,
          {
            variant: "contained",
            onClick: () => Gs(we.artifactUrls.pdf || we.artifactUrls.html),
            children: c.download
          }
        ),
        /* @__PURE__ */ f.jsx($e, { color: "inherit", onClick: () => Ie(null), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ f.jsx(
      qa,
      {
        open: !!ee,
        autoHideDuration: 5e3,
        onClose: () => ue(""),
        message: ee
      }
    )
  ] });
}
var fn = {};
function Ir(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
fn.d = (e, n) => {
  for (var s in n) fn.o(n, s) && !fn.o(e, s) && Object.defineProperty(e, s, { enumerable: !0, get: n[s] });
}, fn.o = (e, n) => Object.prototype.hasOwnProperty.call(e, n);
var Zi = ["E", "H", "C", "M", "B"], un = { PENDING: "PENDING", ENTERING_RING: "ENTERING_RING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, il = { SCRATCHED: "Scratched", EXCUSED: "Excused", ELIMINATED: "Eliminated", NO_SHOW: "No Show" }, is = { BLOOD: "BLOOD", LAMENESS: "LAMENESS", MEETING_REQUESTED: "MEETING_REQUESTED" }, pn = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, al = 0, Bt = 10, cr = 0.5, Tr = { RIDE_INTRO_DETAILED: "ride-intro-detailed", POST_RIDE_SCORE: "post-ride-score", END_OF_CLASS_RESULT: "end-of-class-result" }, Mn;
Ir(Mn = {}, Tr.RIDE_INTRO_DETAILED, ["classNumberName", "testName", "entryIdentity", "riderLocation", "horseBio", "ownerInfo"]), Ir(Mn, Tr.POST_RIDE_SCORE, ["classNumberName", "testName", "entryIdentity", "scoreHero", "termReason", "currentRank", "divisionRank", "perJudgeBreakout", "qr"]), Ir(Mn, Tr.END_OF_CLASS_RESULT, ["classNumberName", "judgesPositions", "rankedList", "resultLayout", "sponsor", "qr"]);
var ol = "Withdrawn / retired", Vs = { RULE: "rule", MANUAL: "manual" }, ul = { CLASS_RIDE_MISMATCH: "CLASS_RIDE_MISMATCH", DSHB_NAME_MISMATCH: "DSHB_NAME_MISMATCH" }, A = Object.freeze({ ALREADY_AUTHORITATIVE: "already_authoritative", ALREADY_EXCUSED: "already_excused", ALREADY_MAPPED: "already_mapped", ALREADY_NO_SHOW: "already_no_show", AMBIGUOUS_USEF_COMP_ID: "ambiguous_usef_comp_id", BATCH_TOO_LARGE: "batch_too_large", CLASS_NOT_FOUND: "class_not_found", COMPOSITE_JUDGE_NOT_FOUND: "composite_judge_not_found", CONCURRENT_MODIFICATION: "concurrent_modification", DEFAULT_VIEW_REQUIRED: "default_view_required", DEFAULT_VIEW_UNDELETABLE: "default_view_undeletable", DUPLICATE_JUDGE: "duplicate_judge", DUPLICATE_SCORE_SHEET: "duplicate_score_sheet", DUPLICATE_SLUG: "duplicate_slug", ELIMINATION_CHANGE_NEEDS_SHEET_EDIT: "elimination_change_needs_sheet_edit", ENV_NOT_ALLOWED: "env_not_allowed", FORBIDDEN: "forbidden", INSUFFICIENT_CONTRAST: "insufficient_contrast", INVALID_ACTION: "invalid_action", INVALID_ASPECT_RATIO: "invalid_aspect_ratio", INVALID_BODY: "invalid_body", INVALID_IMAGE_TYPE: "invalid_image_type", INVALID_JUDGE: "invalid_judge", INVALID_MIRROR_TARGET: "invalid_mirror_target", INVALID_MODE_TYPE: "invalid_mode_type", INVALID_MOVEMENT_NUMBER: "invalid_movement_number", INVALID_MOVEMENT_OVERRIDE: "invalid_movement_override", INVALID_PATH: "invalid_path", INVALID_PIN: "invalid_pin", INVALID_PLACING_VIEW: "invalid_placing_view", INVALID_RIDE: "invalid_ride", INVALID_SHAPE: "invalid_shape", INVALID_SIGNATURE: "invalid_signature", INVALID_SLUG: "invalid_slug", INVALID_SPONSOR: "invalid_sponsor", INVALID_STATUS: "invalid_status", INVALID_STATUS_ENTRY: "invalid_status_entry", INVALID_TERM_REASON: "invalid_term_reason", INVALID_TIMEZONE: "invalid_timezone", INVALID_TYPE: "invalid_type", JUDGE_NOT_FOUND: "judge_not_found", JUDGE_NOT_ON_PANEL: "judge_not_on_panel", LIVE_GUARD: "live_guard", LOGO_TOO_LARGE: "logo_too_large", LOGO_TOO_SMALL: "logo_too_small", MARKS_CONFIRMED_FROZEN: "marks_confirmed_frozen", MARKS_NOT_CONFIRMED: "marks_not_confirmed", MIRROR_CYCLE: "mirror_cycle", MISSING_ACTION: "missing_action", MISSING_PARAMS: "missing_params", MISSING_QUERY_PARAM: "missing_query_param", MISSING_SHOW_ID: "missing_show_id", MISSING_SIGNATURE: "missing_signature", MISSING_TARGET: "missing_target", NO_CONFLICT: "no_conflict", NO_CONTENDER: "no_contender", NO_DRAFT: "no_draft", NO_SCRIBE_IDENTITY: "no_scribe_identity", NOT_ASSIGNED: "not_assigned", NOT_CHAMPIONSHIP_CLASS: "not_championship_class", NOT_ENTITLED: "not_entitled", NOT_EXCUSED: "not_excused", NOT_FINAL: "not_final", NOT_FOUND: "not_found", NOT_MANUAL: "not_manual", NOT_NO_SHOW: "not_no_show", NOT_PANEL_SHEET: "not_panel_sheet", NOT_PRESIDING_JUDGE: "not_presiding_judge", NOT_RELEASABLE: "not_releasable", NOT_UNFILLED_SLOT: "not_unfilled_slot", PANEL_NOT_FULLY_SIGNED: "panel_not_fully_signed", PLACED_CLASS_LOCKED: "placed_class_locked", PRIMARY_JUDGE_NOT_FOUND: "primary_judge_not_found", PROD_REFUSED: "prod_refused", REASON_REQUIRED: "reason_required", RIDE_SCRATCHED: "ride_scratched", RIDE_TERMINATED: "ride_terminated", ROUTE_NOT_FOUND: "route_not_found", RUNNING_REQUIRES_CLASS: "running_requires_class", SAME_CLASS: "same_class", SAME_RIDE: "same_ride", SECONDARY_JUDGE_NOT_FOUND: "secondary_judge_not_found", SELF_MAPPING: "self_mapping", SHEET_COMPLETED: "sheet_completed", SHEET_EDITING: "sheet_editing", SHEET_INCOMPLETE: "sheet_incomplete", SHEET_NOT_EDITING: "sheet_not_editing", SHEET_NOT_FROZEN: "sheet_not_frozen", SHOW_NOT_FOUND: "show_not_found", SOURCE_IS_PLACEHOLDER: "source_is_placeholder", SOURCE_NOT_FOUND: "source_not_found", SOURCE_NOT_PLACED: "source_not_placed", STALE_WRITE: "stale_write", TARGET_ALREADY_SCORED: "target_already_scored", TARGET_IS_MANUAL: "target_is_manual", TARGET_NOT_FOUND: "target_not_found", TERM_REASON_CONFLICT: "term_reason_conflict", TEST_MISMATCH: "test_mismatch", TEXT_REQUIRED: "text_required", UNEXPECTED_ERROR: "unexpected_error", UNKNOWN_MODE: "unknown_mode", UNSUPPORTED_SUBJECT_TYPE: "unsupported_subject_type", VALIDATION_ERROR: "validation_error", VALIDATION_FAILED: "validation_failed", VIEW_NOT_FOUND: "view_not_found", WRONG_ORG: "wrong_org", YEAR_MISMATCH: "year_mismatch" });
new Set(Object.values(A));
function P(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function ln(e) {
  return e == null || e === "" ? "another status" : String(e).toLowerCase().split(/[_\s]+/).filter(Boolean).map(function(n) {
    return n.charAt(0).toUpperCase() + n.slice(1);
  }).join(" ");
}
function Gn(e) {
  var n, s = [], i = !0, t = !1, r = void 0;
  try {
    for (var a, o = (Array.isArray(e) ? e : [])[Symbol.iterator](); !(i = (a = o.next()).done); i = !0) {
      var u = a.value, l = String(u).replace(/^\//, "").split(/[/.[\]]/)[0].replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").toLowerCase().replace(/\s+ids?$/, "").trim();
      l && !s.includes(l) && s.push(l);
    }
  } catch (c) {
    t = !0, r = c;
  } finally {
    try {
      i || o.return == null || o.return();
    } finally {
      if (t) throw r;
    }
  }
  return s.length <= 1 ? (n = s[0]) !== null && n !== void 0 ? n : "" : "".concat(s.slice(0, -1).join(", "), " and ").concat(s[s.length - 1]);
}
var k, Lt = "Reload the page and try again.";
Object.freeze((P(k = {}, A.ALREADY_AUTHORITATIVE, { default: "This sheet is already the authoritative one for this seat. There is nothing to switch." }), P(k, A.ALREADY_EXCUSED, { default: "This ride is already marked Excused. There is nothing more to do here." }), P(k, A.ALREADY_MAPPED, { default: "This combined judge already has its two judges set. Edit the existing pairing instead of adding a new one." }), P(k, A.ALREADY_NO_SHOW, { default: "This ride is already marked No Show. There is nothing more to do here." }), P(k, A.AMBIGUOUS_USEF_COMP_ID, { default: "More than one show uses this USEF competition number. Add the show year to the scoreboard link to pick the right one." }), P(k, A.BATCH_TOO_LARGE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).max;
  return "That is more than ".concat(e, " placings to save at once. Save them in smaller groups.");
} }), P(k, A.CLASS_NOT_FOUND, { default: "That class could not be found for this show. Check the link, or choose the class again from the class list." }), P(k, A.COMPOSITE_JUDGE_NOT_FOUND, { default: "The combined judge you picked is not on this show's judge list. Reload the judge list and pick again." }), P(k, A.CONCURRENT_MODIFICATION, { default: "Someone else changed this scoresheet after you opened it. Reload the sheet to see their changes, then make yours again.", commit: "Someone else changed this scoresheet after you opened it. Reload the sheet to see their changes, then save your edit again.", restore: "Someone else changed this scoresheet after you opened it. Reload the audit trail to see their changes, then try the restore again.", stationReconcile: "This station was reconciled again after you last looked. Reload the review and try again." }), P(k, A.DEFAULT_VIEW_REQUIRED, { default: "Every show needs a default scoreboard view, and this is the only one. Make another view the default first, then change this one." }), P(k, A.DEFAULT_VIEW_UNDELETABLE, { default: "This is the show's default scoreboard view, so it cannot be deleted while other views exist. Make another view the default first, then delete this one." }), P(k, A.DUPLICATE_JUDGE, { default: "The two judges in a combined judge must be different people. Pick a different second judge." }), P(k, A.DUPLICATE_SCORE_SHEET, { default: "This judge already has a scoresheet for this ride. Open that sheet instead of starting a new one." }), P(k, A.DUPLICATE_SLUG, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).slug;
  return 'Another scoreboard view on this show already uses the web address "'.concat(e, '". Choose a different one.');
} }), P(k, A.ELIMINATION_CHANGE_NEEDS_SHEET_EDIT, { default: "Applying this value would add or remove an elimination on the sheet, which can't be done from the review queue. Keep the current value here, then make the change on the sheet itself." }), P(k, A.ENV_NOT_ALLOWED, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).allowed;
  return "Resetting the demo data only works on these servers: ".concat(e, ". This server is not one of them.");
} }), P(k, A.FORBIDDEN, { default: "You do not have permission to do that. Ask the show office if you need it.", superAdmin: "Only a Fox Village administrator can change this. Ask Fox Village support if it needs changing.", instance: "Your account cannot change this scoring station's setup. Ask Fox Village support if it needs changing.", showOfficeOnly: "Only the show office can make that status change. Ask the show office to make it for you.", otherOrg: "This show belongs to a different organization. Switch to that organization, or check that you picked the right show.", alertOwner: "Only the person who raised this alert, or the show office, can clear it. Ask one of them to clear it." }), P(k, A.INSUFFICIENT_CONTRAST, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).parts;
  return "The text color is too hard to read against the ".concat(e, ". Pick a darker or lighter text color, or change that color.");
} }), P(k, A.INVALID_ACTION, { default: "That choice is not available for this review item. Reload the review list and pick one of the options shown." }), P(k, A.INVALID_ASPECT_RATIO, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width, s = e.height;
  return "That picture is ".concat(n, " by ").concat(s, " pixels, which is the wrong shape. Crop it to the shape you picked and upload it again.");
}, square: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width, s = e.height;
  return "That picture is ".concat(n, " by ").concat(s, " pixels, but a square image has to be as wide as it is tall. Crop it to a square and upload it again.");
}, wide: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width, s = e.height;
  return "That picture is ".concat(n, " by ").concat(s, " pixels, but a wide image has to be about five times as wide as it is tall. Crop it to that shape and upload it again.");
} }), P(k, A.INVALID_BODY, { default: "Some of what was sent was missing or in the wrong form. ".concat(Lt), listMissing: "The list of rides or classes to work on was missing or empty. ".concat(Lt), tooMany: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).max;
  return "That is more than ".concat(e, " items to load at once. Load fewer at a time.");
}, placingsMissing: "There were no placings to save. Set at least one placing, then save again." }), P(k, A.INVALID_IMAGE_TYPE, { default: "That file is not a picture we can use. Upload a PNG, GIF, or JPEG image.", pngOrJpegOnly: "This picture has to be a PNG or JPEG. Save it in one of those formats and upload it again.", damaged: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).kind;
  return "That ".concat(e, " picture looks damaged and could not be read. Save it again and upload the new copy.");
} }), P(k, A.INVALID_JUDGE, { default: "One of the judges you picked is not on this show's judge list. Reload the page and pick the judges again." }), P(k, A.INVALID_MIRROR_TARGET, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).view;
  return 'The view to copy from ("'.concat(e, `") is not one of this show's scoreboard views. Pick a view from this show's list.`);
} }), P(k, A.INVALID_MODE_TYPE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).modeType;
  return '"'.concat(e, '" is not a kind of scoreboard screen we know. Pick a screen type from the list.');
} }), P(k, A.INVALID_MOVEMENT_NUMBER, { default: "The movement number has to be a whole number. Enter it again without letters or decimals." }), P(k, A.INVALID_MOVEMENT_OVERRIDE, { default: "That movement change would leave the test sheet in a form that cannot be scored, for example two movements with the same number. Check the section and movement number, then save again." }), P(k, A.INVALID_PATH, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.fileLabel, s = e.path;
  return "The ".concat(n, ' path "').concat(s, '" is not valid. Fix the path and save again.');
}, wrongEnding: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.fileLabel, s = e.path, i = e.ending;
  return "The ".concat(n, ' path "').concat(s, '" has to end in "').concat(i, '". Fix the path and save again.');
}, parentFolder: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.fileLabel, s = e.path;
  return "The ".concat(n, ' path "').concat(s, '" cannot step up a folder with "..". Enter the full path to the file and save again.');
}, hiddenCharacter: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.fileLabel, s = e.path;
  return "The ".concat(n, ' path "').concat(s, '" contains a hidden character that is not allowed. Retype the path and save again.');
} }), P(k, A.INVALID_PIN, { default: "The scribe unlock PIN has to be 4 to 8 digits, numbers only. Enter a new PIN, or clear it to turn the PIN off." }), P(k, A.INVALID_PLACING_VIEW, { default: "That default placing view is not one of the available choices. Pick one from the list, or clear it to use the standard view." }), P(k, A.INVALID_RIDE, { default: "One of the rides in these placings is not in this class. Reload the class and set the placings again." }), P(k, A.INVALID_SHAPE, { default: "The logo shape has to be square or wide. Pick one and upload again." }), P(k, A.INVALID_SIGNATURE, { default: "The signature did not come through as a picture. Clear the signature box, have the judge sign again, and save." }), P(k, A.INVALID_SLUG, { default: "The web address for this view can only use lowercase letters, numbers, and hyphens. Change it and save again." }), P(k, A.INVALID_SPONSOR, { default: "The sponsor you picked is not in this show's sponsor list. Reload the page and pick the sponsor again." }), P(k, A.INVALID_STATUS, { default: "That is not a ride status the scoring system knows. ".concat(Lt) }), P(k, A.INVALID_STATUS_ENTRY, { default: "Every ride in this update needs a ride and a known status. Reload the page and set the statuses again." }), P(k, A.INVALID_TERM_REASON, { default: "That is not a reason the scoring system knows for ending a ride. Reload the page and pick the reason again from the list." }), P(k, A.INVALID_TIMEZONE, { default: "The venue time zone was not recognized. Enter a whole-hour offset such as GMT-4, a zone name such as America/Chicago, or clear it." }), P(k, A.INVALID_TYPE, { default: "That is not a kind of alert the scoring system knows. Reload the page and pick the alert again." }), P(k, A.JUDGE_NOT_FOUND, { default: "That judge is not on this show's judge list any more. Reload the judge list and try again." }), P(k, A.JUDGE_NOT_ON_PANEL, { default: "That judge is not on this class's panel. Pick a judge from this class's panel." }), P(k, A.LIVE_GUARD, { default: "Resetting the demo data is switched off on a live scoring server. Use the demo server instead." }), P(k, A.LOGO_TOO_LARGE, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.sizeMb, s = e.maxMb;
  return "That picture is ".concat(n, " MB, and the limit is ").concat(s, " MB. Make it smaller and upload it again.");
} }), P(k, A.LOGO_TOO_SMALL, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width, s = e.height, i = e.minPx;
  return "That picture is only ".concat(n, " by ").concat(s, " pixels, and its longest side needs to be at least ").concat(i, " pixels. Upload a bigger version.");
} }), P(k, A.MARKS_CONFIRMED_FROZEN, { default: "The marks on this sheet are confirmed and locked, so only the remarks can still be changed. To change a mark, ask the show office to unlock the sheet." }), P(k, A.MARKS_NOT_CONFIRMED, { default: "The class's marks have not been confirmed yet. Confirm the marks first, then the panel can sign." }), P(k, A.MIRROR_CYCLE, { default: "A scoreboard view cannot copy itself. Pick a different view to copy from.", loop: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.view, s = e.maxDepth;
  return 'Copying "'.concat(n, '" would make views copy each other in a loop, or chain more than ').concat(s, " views together. Pick a view that shows its own content.");
} }), P(k, A.MISSING_ACTION, { default: "No choice was picked for this review item. Pick an option and try again." }), P(k, A.MISSING_PARAMS, { default: "The page did not say which show to use. Reload the page, or pick the show again.", showAndRing: "The page did not say which show and ring to use. Pick the show and ring again." }), P(k, A.MISSING_QUERY_PARAM, { default: "The page did not say which show to use. Reload the page, or pick the show again.", showAndRing: "The page did not say which show and ring to use. Pick the show and ring again.", rideFilter: "Looking up rides needs a class, show, rider, horse, or review filter. Pick one and search again.", rideOrJudge: "Looking up scoresheets needs a ride or a judge. Pick one and try again." }), P(k, A.MISSING_SHOW_ID, { default: "The page did not say which show to use. Reload the page, or pick the show again." }), P(k, A.MISSING_SIGNATURE, { default: "The judge needs to sign this sheet before it can be completed. Have the judge sign, then complete the sheet again.", notOnFile: "That judge has no signature on file for this show. Ask the show office to add the judge's signature, then try again.", namedJudgeNotOnFile: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).judgeName;
  return "".concat(e, " has no signature on file for this show. Ask the show office to add it, then try again.");
}, combinedJudgeUnresolved: "One of the two judges behind this combined judge could not be found. Ask the show office to check the combined judge setup, then try again." }), P(k, A.MISSING_TARGET, { default: "No ride was picked to move this sheet to. Pick the ride, then try again." }), P(k, A.NO_CONFLICT, { default: "This sheet has no stale-write conflict waiting to be resolved. Reload the review queue and try again." }), P(k, A.NO_CONTENDER, { default: "This seat has no other sheet to compare against. Reload the ride and try again." }), P(k, A.NO_DRAFT, { default: "There are no unsaved edits on this sheet to work with. Reload the sheet to see what was saved." }), P(k, A.NO_SCRIBE_IDENTITY, { default: "This tablet is not signed in as a scribe. Sign in again, then try again." }), P(k, A.NOT_ASSIGNED, { default: "You aren't assigned to scribe this class. Ask the show office to assign you to this judge, then try again.", ride: "You aren't assigned to scribe this ride. Ask the show office to assign you, then try again." }), P(k, A.NOT_CHAMPIONSHIP_CLASS, { default: "This class is not a championship class, so its spots cannot be filled from other classes. Pick a championship class.", target: "The class you are filling is not a championship class. Pick a ride in a championship class." }), P(k, A.NOT_EXCUSED, { default: "This ride is not marked Excused, so there is nothing to undo. Reload the ride to see its current status." }), P(k, A.NOT_FINAL, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).status;
  return "This ride cannot be placed yet because it is still ".concat(ln(e).toLowerCase(), ". Every judge's sheet for the ride has to be signed first.");
} }), P(k, A.NOT_FOUND, { default: "That record could not be found. ".concat(Lt), ride: "This ride could not be found. It may have been removed, so reload the class list and open it again.", scoreSheet: "This scoresheet is no longer on the server. Go back to the class list and open the ride again.", class: "This class could not be found. It may have been removed, so reload the class list and pick it again.", classNoRides: "This class has no rides yet, so there is nothing to place. Check the class's rides, then try again.", test: "The dressage test for this ride could not be found. Ask the show office to check which test the class uses.", catalogTest: "That test is not in the test catalog. Check the test name, or ask Fox Village support to add it.", person: "This person could not be found. They may have been removed, so reload the list and try again.", horse: "This horse could not be found. It may have been removed, so reload the list and try again.", show: "This show could not be found. Check that you are in the right organization, then pick the show again.", view: "This scoreboard view could not be found. It may have been deleted, so reload the list of views.", sponsor: "This sponsor could not be found. It may have been deleted, so reload the list of sponsors.", theme: "This theme could not be found. It may have been deleted, so reload the list of themes.", asset: "This picture could not be found. It may have been deleted, so reload the page and upload it again.", alert: "This alert could not be found. It may already have been cleared, so reload the ride to check.", reviewItem: "This review item could not be found. It may already have been handled, so reload the review list.", version: "That version is no longer in this sheet's audit trail. Reload the audit trail and pick a version from the current list.", judgePairing: "This combined judge pairing could not be found. It may have been removed, so reload the judge list.", movement: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).movementNumber;
  return "Movement ".concat(e, " is not on this ride's test sheet. Reload the sheet and pick a movement that is listed.");
} }), P(k, A.NOT_MANUAL, { default: "Only a ride that was added by hand can be matched to a real ride this way. Pick a ride that was added by hand." }), P(k, A.NOT_NO_SHOW, { default: "This ride is not marked No Show, so there is nothing to undo. Reload the ride to see its current status." }), P(k, A.NOT_PANEL_SHEET, { default: "This sheet is not scored by a judging panel, so it does not use panel signing. Use Complete & Sign instead." }), P(k, A.NOT_PRESIDING_JUDGE, { default: "Only the judge at C can do that. Ask the judge at C to do it.", markNoShow: "Only the judge at C can mark this ride No Show. Ask the judge at C to do it.", undoNoShow: "Only the judge at C can undo this ride's No Show. Ask the judge at C to do it.", markExcused: "Only the judge at C can mark this ride Excused. Ask the judge at C to do it.", undoExcused: "Only the judge at C can undo this ride's Excused mark. Ask the judge at C to do it." }), P(k, A.NOT_RELEASABLE, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.blocking, s = e.total;
  return "".concat(n, " of ").concat(s, " rides in this class are not finished, because not every judge's sheet is signed yet. Finish judging those rides, then save the placings.");
} }), P(k, A.NOT_UNFILLED_SLOT, { default: "That ride is not an empty championship spot. Pick an empty spot to fill." }), P(k, A.PANEL_NOT_FULLY_SIGNED, { default: "Not every judge on the panel has signed yet. Have the remaining judges sign, then complete the sheet." }), P(k, A.PLACED_CLASS_LOCKED, { default: "This class's placings are already set and locked. Ask someone with permission to override placed classes to change them." }), P(k, A.PRIMARY_JUDGE_NOT_FOUND, { default: "The first judge you picked is not on this show's judge list. Reload the judge list and pick again." }), P(k, A.PROD_REFUSED, { default: "Resetting the demo data is never allowed on the live production server. Use the demo server instead." }), P(k, A.REASON_REQUIRED, { default: "Enter a reason before saving. The reason is kept in the sheet's history.", unlock: "Enter a reason for unlocking this sheet. The reason is kept in the sheet's history.", commit: "Enter a reason for this edit before saving it. The reason is kept in the sheet's history.", restore: "Enter a reason for restoring this version. The reason is kept in the sheet's history." }), P(k, A.RIDE_SCRATCHED, { default: "This ride has been scratched, so it can't be scored. Pick another ride from the class list." }), P(k, A.RIDE_TERMINATED, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).termReason;
  return "This ride ended as ".concat(ln(e), ", so it cannot be placed. Leave it out of the placings.");
}, batch: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).count;
  return "".concat(e, " of the rides in these placings ended early and cannot be placed. Leave them out and save again.");
} }), P(k, A.ROUTE_NOT_FOUND, { default: "This app asked the scoring server for something it doesn't have. Reload the app, and if it keeps happening tell the show office." }), P(k, A.RUNNING_REQUIRES_CLASS, { default: "To mark the ring as running, pick the class that is in the ring. Choose a class, then try again." }), P(k, A.SAME_CLASS, { default: "The ride to fill from has to come from a different class that qualifies for this championship. Pick a ride from a qualifying class." }), P(k, A.SAME_RIDE, { default: "The ride you picked is the same ride this sheet is already on. Pick a different ride." }), P(k, A.SECONDARY_JUDGE_NOT_FOUND, { default: "The second judge you picked is not on this show's judge list. Reload the judge list and pick again." }), P(k, A.SELF_MAPPING, { default: "A combined judge cannot be paired with itself. Pick two other judges." }), P(k, A.SHEET_COMPLETED, { default: "This sheet has already been signed and is locked, so changes can't be saved to it. Ask the show office to unlock it if something needs fixing." }), P(k, A.SHEET_EDITING, { default: "This sheet has an edit in progress. Commit or discard that edit first, then restore the version." }), P(k, A.SHEET_INCOMPLETE, { default: "This sheet still has a blank movement or collective mark. Fill in every mark, then try again.", confirm: "This sheet cannot be confirmed yet because a movement or collective mark is blank. Fill in every mark, then confirm again.", complete: "This sheet cannot be completed yet because a movement or collective mark is blank. Fill in every mark, then complete it again.", commit: "This edit cannot be saved because a movement or collective mark is blank. Fill in every mark, then save again." }), P(k, A.SHEET_NOT_EDITING, { default: "This sheet is not unlocked for editing. Unlock it first, then make the change." }), P(k, A.SHEET_NOT_FROZEN, { default: "This sheet is not locked, so there is nothing to unlock. Make your changes directly." }), P(k, A.SHOW_NOT_FOUND, { default: "This show could not be found. Check the show link, or pick the show again from the list." }), P(k, A.SOURCE_IS_PLACEHOLDER, { default: "The ride you are filling from is itself an empty championship spot. Pick a real ride from a qualifying class." }), P(k, A.SOURCE_NOT_FOUND, { default: "The ride you are filling from could not be found. Reload the class and pick it again." }), P(k, A.SOURCE_NOT_PLACED, { default: "The ride you are filling from has not been placed in its class yet. Place that class first, then fill the championship." }), P(k, A.STALE_WRITE, { default: "Someone else saved a change to this scoresheet after you loaded it. Reload the sheet to see their change, then make yours again." }), P(k, A.TARGET_ALREADY_SCORED, { default: "The ride you picked already has a sheet from the same judge. Pick a different ride, or ask the show office to sort out the extra sheet." }), P(k, A.TARGET_IS_MANUAL, { default: "The ride you picked was also added by hand. Pick a ride that came from the show's entries." }), P(k, A.TARGET_NOT_FOUND, { default: "The ride you picked could not be found. Reload the class and pick it again." }), P(k, A.TERM_REASON_CONFLICT, { default: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.existing, s = e.incoming;
  return s ? "This ride is already marked ".concat(ln(n), ", so it can't also be marked ").concat(ln(s), ". Ask the show office to clear the earlier status first.") : "This ride is already marked ".concat(ln(n), ". Ask the show office to clear that status first.");
} }), P(k, A.TEST_MISMATCH, { default: "This sheet was scored on a different test than the ride you picked. Pick a ride in a class that uses the same test.", attach: "This sheet was scored on a different test than the ride you picked, so it cannot be attached. Pick a ride in a class that uses the same test.", move: "This sheet was scored on a different test than the ride you picked, so it cannot be moved there. Pick a ride in a class that uses the same test." }), P(k, A.TEXT_REQUIRED, { default: "The note is empty. Type the note, then save." }), P(k, A.UNEXPECTED_ERROR, { default: "The scoring server couldn't accept that request. Try again, and if it keeps happening tell the show office.", server: "The scoring server hit a problem. Try again in a moment, and if it keeps happening tell the show office." }), P(k, A.UNKNOWN_MODE, { default: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).mode;
  return 'That screen ("'.concat(e, `") is not one of this view's screens. Reload the view and pick one of its screens.`);
} }), P(k, A.UNSUPPORTED_SUBJECT_TYPE, { default: "This kind of review item is not handled from the review list. Open the ride itself and resolve it there." }), P(k, A.VALIDATION_ERROR, { default: "Some of what was entered is missing or not in the right form. Check what you entered and try again.", fields: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fields;
  return Gn(e) ? "Some of what was sent wasn't in a form the server accepts. Check the ".concat(Gn(e), " and try again.") : "Some of what was sent wasn't in a form the server accepts. ".concat(Lt);
}, sheetFields: function() {
  var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fields;
  return Gn(e) ? "Some of what was entered on this sheet wasn't in a form the server accepts. Check the ".concat(Gn(e), " and try again.") : "Some of what was entered on this sheet wasn't in a form the server accepts. ".concat(Lt);
}, catalogTest: "The updated test does not fit the rules every test sheet has to follow. Check the listed problems, then save again.", judgePairing: "A combined judge needs the combined judge and both of its judges. Pick all three, then save.", seat: "The page did not say which show and scribe seat to use. Reload the page and try again.", held: "The failed change was missing details it needs to be held for review. Reload the page and try again.", placing: "A placing has to be a whole number of 0 or more, or left blank. Fix the placing and save again.", ringStatus: "The ring update was missing the show, the ring, or the ring status. Pick all three and try again.", viewFields: "A scoreboard view needs a show, a name, and a web address. Fill them in, then save.", sponsorFields: "A sponsor needs a name, a display name, or a logo. Add at least one, then save.", themeName: "A theme needs a name. Enter one, then save.", image: "No picture was attached. Choose a picture, then upload again." }), P(k, A.VALIDATION_FAILED, { default: "Pick at least one scribe account to assign in the demo data. Then run the reset again." }), P(k, A.VIEW_NOT_FOUND, { default: "This scoreboard view could not be found. Check the scoreboard link, or ask the show office for the right one." }), P(k, A.WRONG_ORG, { default: "Resetting the demo data only works while you are in the demo organization. Switch to it, then try again." }), P(k, A.YEAR_MISMATCH, { default: "That show is not from the year given in the scoreboard link. Check the year in the link." }), P(k, A.NOT_ENTITLED, { default: "Your organization does not have the scoring app turned on. Ask Fox Village support to turn it on." }), k));
function Cr(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function Yi(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : cr;
  if (typeof e != "number" || !Number.isFinite(e)) return null;
  var s = Math.round(e / n) * n, i = Math.round(1e3 * s) / 1e3;
  return i < 0 ? 0 : i > Bt ? Bt : i;
}
function Ki(e) {
  var n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).suppressShorthand, s = n !== void 0 && n;
  if (e == null) return null;
  var i = String(e).trim();
  if (i === "") return null;
  var t = Number(i);
  return Number.isFinite(t) ? /\./.test(i) || t >= 0 && t <= Bt ? t : !s && t > Bt && t <= 100 ? t / 10 : t : null;
}
function ll(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : cr, s = Ki(e);
  return s === null ? null : Yi(s, n);
}
var Vn;
Cr(Vn = {}, pn.POINTS, [{ points: 2 }, { points: 4 }, { eliminate: !0 }]), Cr(Vn, pn.PERCENT_SENIOR, [{ percent: 2 }, { eliminate: !0 }]), Cr(Vn, pn.PERCENT_YOUTH, [{ percent: 0.5 }, { percent: 1 }, { eliminate: !0 }]);
function Ze(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
var Je, Ye = { PERCENTAGE: "PERCENTAGE", COLLECTIVE_MARKS: "COLLECTIVE_MARKS", YOUNG_HORSE_AVERAGE: "YOUNG_HORSE_AVERAGE", YOUNG_HORSE_SUBMISSION: "YOUNG_HORSE_SUBMISSION", FEI_CHILDREN_TECHNICAL: "FEI_CHILDREN_TECHNICAL", FEI_CHILDREN_MEDIAN: "FEI_CHILDREN_MEDIAN", FREESTYLE_ARTISTIC: "FREESTYLE_ARTISTIC", FREESTYLE_HARMONY: "FREESTYLE_HARMONY", FREESTYLE_CHOREOGRAPHY: "FREESTYLE_CHOREOGRAPHY", MOVEMENT_TOTALS: "MOVEMENT_TOTALS", UNRESOLVED: "UNRESOLVED", JUDGE_ENTERED: "JUDGE_ENTERED", RIDE_OFF_REQUIRED: "RIDE_OFF_REQUIRED", DSHB_JUDGE_ENTERED: "DSHB_JUDGE_ENTERED", DSHB_UNRESOLVED: "DSHB_UNRESOLVED" };
Ze(Je = {}, Ye.PERCENTAGE, "DR123.3"), Ze(Je, Ye.COLLECTIVE_MARKS, "DR123.3"), Ze(Je, Ye.YOUNG_HORSE_AVERAGE, "DR123.3 (Young Horse exception)"), Ze(Je, Ye.YOUNG_HORSE_SUBMISSION, "DR123.3 (Young Horse exception)"), Ze(Je, Ye.FEI_CHILDREN_TECHNICAL, "DR123.3 (FEI Children exception)"), Ze(Je, Ye.FEI_CHILDREN_MEDIAN, "DR123.3 (FEI Children exception)"), Ze(Je, Ye.FREESTYLE_ARTISTIC, "DR129.5"), Ze(Je, Ye.FREESTYLE_HARMONY, "DR129.5"), Ze(Je, Ye.FREESTYLE_CHOREOGRAPHY, "DR129.5"), Ze(Je, Ye.MOVEMENT_TOTALS, "DR211.4"), Ze(Je, Ye.UNRESOLVED, "DR123.3"), Ze(Je, Ye.JUDGE_ENTERED, "DR133.1.k / DR133.2.g.4"), Ze(Je, Ye.RIDE_OFF_REQUIRED, "DR133.2.g.5"), Ze(Je, Ye.DSHB_JUDGE_ENTERED, "DR210.5 / DR204.2.c"), Ze(Je, Ye.DSHB_UNRESOLVED, "DR211.4");
var kt = { PENDING: un.PENDING, ENTERING_RING: un.ENTERING_RING, IN_PROGRESS: un.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: un.COMPLETED, FINAL: "FINAL", SCRATCHED: un.SCRATCHED }, cl = [ol, "Withdrawal", "Withdrawn", "Withdraw"];
new Set(cl.map(dl));
function dl(e) {
  return typeof e == "string" ? e.trim().toLowerCase().replace(/[^a-z0-9]/g, "") : "";
}
var oe, Hs;
(function(e) {
  e.assertEqual = (n) => {
  }, e.assertIs = function(n) {
  }, e.assertNever = function(n) {
    throw new Error();
  }, e.arrayToEnum = (n) => {
    const s = {};
    for (const i of n) s[i] = i;
    return s;
  }, e.getValidEnumValues = (n) => {
    const s = e.objectKeys(n).filter((t) => typeof n[n[t]] != "number"), i = {};
    for (const t of s) i[t] = n[t];
    return e.objectValues(i);
  }, e.objectValues = (n) => e.objectKeys(n).map(function(s) {
    return n[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const s = [];
    for (const i in n) Object.prototype.hasOwnProperty.call(n, i) && s.push(i);
    return s;
  }, e.find = (n, s) => {
    for (const i of n) if (s(i)) return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && Number.isFinite(n) && Math.floor(n) === n, e.joinValues = function(n, s = " | ") {
    return n.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }, e.jsonStringifyReplacer = (n, s) => typeof s == "bigint" ? s.toString() : s;
})(oe || (oe = {})), function(e) {
  e.mergeShapes = (n, s) => ({ ...n, ...s });
}(Hs || (Hs = {}));
const G = oe.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), wt = (e) => {
  switch (typeof e) {
    case "undefined":
      return G.undefined;
    case "string":
      return G.string;
    case "number":
      return Number.isNaN(e) ? G.nan : G.number;
    case "boolean":
      return G.boolean;
    case "function":
      return G.function;
    case "bigint":
      return G.bigint;
    case "symbol":
      return G.symbol;
    case "object":
      return Array.isArray(e) ? G.array : e === null ? G.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? G.promise : typeof Map < "u" && e instanceof Map ? G.map : typeof Set < "u" && e instanceof Set ? G.set : typeof Date < "u" && e instanceof Date ? G.date : G.object;
    default:
      return G.unknown;
  }
}, N = oe.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class bt extends Error {
  get errors() {
    return this.issues;
  }
  constructor(n) {
    super(), this.issues = [], this.addIssue = (i) => {
      this.issues = [...this.issues, i];
    }, this.addIssues = (i = []) => {
      this.issues = [...this.issues, ...i];
    };
    const s = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, s) : this.__proto__ = s, this.name = "ZodError", this.issues = n;
  }
  format(n) {
    const s = n || function(r) {
      return r.message;
    }, i = { _errors: [] }, t = (r) => {
      for (const a of r.issues) if (a.code === "invalid_union") a.unionErrors.map(t);
      else if (a.code === "invalid_return_type") t(a.returnTypeError);
      else if (a.code === "invalid_arguments") t(a.argumentsError);
      else if (a.path.length === 0) i._errors.push(s(a));
      else {
        let o = i, u = 0;
        for (; u < a.path.length; ) {
          const l = a.path[u];
          u === a.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(s(a))) : o[l] = o[l] || { _errors: [] }, o = o[l], u++;
        }
      }
    };
    return t(this), i;
  }
  static assert(n) {
    if (!(n instanceof bt)) throw new Error(`Not a ZodError: ${n}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, oe.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(n = (s) => s.message) {
    const s = {}, i = [];
    for (const t of this.issues) if (t.path.length > 0) {
      const r = t.path[0];
      s[r] = s[r] || [], s[r].push(n(t));
    } else i.push(n(t));
    return { formErrors: i, fieldErrors: s };
  }
  get formErrors() {
    return this.flatten();
  }
}
bt.create = (e) => new bt(e);
const zr = (e, n) => {
  let s;
  switch (e.code) {
    case N.invalid_type:
      s = e.received === G.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
      break;
    case N.invalid_literal:
      s = `Invalid literal value, expected ${JSON.stringify(e.expected, oe.jsonStringifyReplacer)}`;
      break;
    case N.unrecognized_keys:
      s = `Unrecognized key(s) in object: ${oe.joinValues(e.keys, ", ")}`;
      break;
    case N.invalid_union:
      s = "Invalid input";
      break;
    case N.invalid_union_discriminator:
      s = `Invalid discriminator value. Expected ${oe.joinValues(e.options)}`;
      break;
    case N.invalid_enum_value:
      s = `Invalid enum value. Expected ${oe.joinValues(e.options)}, received '${e.received}'`;
      break;
    case N.invalid_arguments:
      s = "Invalid function arguments";
      break;
    case N.invalid_return_type:
      s = "Invalid function return type";
      break;
    case N.invalid_date:
      s = "Invalid date";
      break;
    case N.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (s = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (s = `${s} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? s = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? s = `Invalid input: must end with "${e.validation.endsWith}"` : oe.assertNever(e.validation) : s = e.validation !== "regex" ? `Invalid ${e.validation}` : "Invalid";
      break;
    case N.too_small:
      s = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
      break;
    case N.too_big:
      s = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
      break;
    case N.custom:
      s = "Invalid input";
      break;
    case N.invalid_intersection_types:
      s = "Intersection results could not be merged";
      break;
    case N.not_multiple_of:
      s = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case N.not_finite:
      s = "Number must be finite";
      break;
    default:
      s = n.defaultError, oe.assertNever(e);
  }
  return { message: s };
};
let hl = zr;
var H;
(function(e) {
  e.errToObj = (n) => typeof n == "string" ? { message: n } : n || {}, e.toString = (n) => typeof n == "string" ? n : n == null ? void 0 : n.message;
})(H || (H = {}));
function L(e, n) {
  const s = hl, i = ((t) => {
    const { data: r, path: a, errorMaps: o, issueData: u } = t, l = [...a, ...u.path || []], c = { ...u, path: l };
    if (u.message !== void 0) return { ...u, path: l, message: u.message };
    let d = "";
    const h = o.filter((m) => !!m).slice().reverse();
    for (const m of h) d = m(c, { data: r, defaultError: d }).message;
    return { ...u, path: l, message: d };
  })({ issueData: n, data: e.data, path: e.path, errorMaps: [e.common.contextualErrorMap, e.schemaErrorMap, s, s === zr ? void 0 : zr].filter((t) => !!t) });
  e.common.issues.push(i);
}
class Ke {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(n, s) {
    const i = [];
    for (const t of s) {
      if (t.status === "aborted") return Q;
      t.status === "dirty" && n.dirty(), i.push(t.value);
    }
    return { status: n.value, value: i };
  }
  static async mergeObjectAsync(n, s) {
    const i = [];
    for (const t of s) {
      const r = await t.key, a = await t.value;
      i.push({ key: r, value: a });
    }
    return Ke.mergeObjectSync(n, i);
  }
  static mergeObjectSync(n, s) {
    const i = {};
    for (const t of s) {
      const { key: r, value: a } = t;
      if (r.status === "aborted" || a.status === "aborted") return Q;
      r.status === "dirty" && n.dirty(), a.status === "dirty" && n.dirty(), r.value === "__proto__" || a.value === void 0 && !t.alwaysSet || (i[r.value] = a.value);
    }
    return { status: n.value, value: i };
  }
}
const Q = Object.freeze({ status: "aborted" }), $r = (e) => ({ status: "dirty", value: e }), st = (e) => ({ status: "valid", value: e }), zs = (e) => e.status === "aborted", $s = (e) => e.status === "dirty", Jt = (e) => e.status === "valid", rr = (e) => typeof Promise < "u" && e instanceof Promise;
class lt {
  constructor(n, s, i, t) {
    this._cachedPath = [], this.parent = n, this.data = s, this._path = i, this._key = t;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Bs = (e, n) => {
  if (Jt(n)) return { success: !0, data: n.value };
  if (!e.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const s = new bt(e.common.issues);
    return this._error = s, this._error;
  } };
};
function X(e) {
  if (!e) return {};
  const { errorMap: n, invalid_type_error: s, required_error: i, description: t } = e;
  if (n && (s || i)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return n ? { errorMap: n, description: t } : { errorMap: (r, a) => {
    const { message: o } = e;
    return r.code === "invalid_enum_value" ? { message: o ?? a.defaultError } : a.data === void 0 ? { message: o ?? i ?? a.defaultError } : r.code !== "invalid_type" ? { message: a.defaultError } : { message: o ?? s ?? a.defaultError };
  }, description: t };
}
class re {
  get description() {
    return this._def.description;
  }
  _getType(n) {
    return wt(n.data);
  }
  _getOrReturnCtx(n, s) {
    return s || { common: n.parent.common, data: n.data, parsedType: wt(n.data), schemaErrorMap: this._def.errorMap, path: n.path, parent: n.parent };
  }
  _processInputParams(n) {
    return { status: new Ke(), ctx: { common: n.parent.common, data: n.data, parsedType: wt(n.data), schemaErrorMap: this._def.errorMap, path: n.path, parent: n.parent } };
  }
  _parseSync(n) {
    const s = this._parse(n);
    if (rr(s)) throw new Error("Synchronous parse encountered promise.");
    return s;
  }
  _parseAsync(n) {
    const s = this._parse(n);
    return Promise.resolve(s);
  }
  parse(n, s) {
    const i = this.safeParse(n, s);
    if (i.success) return i.data;
    throw i.error;
  }
  safeParse(n, s) {
    const i = { common: { issues: [], async: (s == null ? void 0 : s.async) ?? !1, contextualErrorMap: s == null ? void 0 : s.errorMap }, path: (s == null ? void 0 : s.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: n, parsedType: wt(n) }, t = this._parseSync({ data: n, path: i.path, parent: i });
    return Bs(i, t);
  }
  "~validate"(n) {
    var i, t;
    const s = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: n, parsedType: wt(n) };
    if (!this["~standard"].async) try {
      const r = this._parseSync({ data: n, path: [], parent: s });
      return Jt(r) ? { value: r.value } : { issues: s.common.issues };
    } catch (r) {
      (t = (i = r == null ? void 0 : r.message) == null ? void 0 : i.toLowerCase()) != null && t.includes("encountered") && (this["~standard"].async = !0), s.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: n, path: [], parent: s }).then((r) => Jt(r) ? { value: r.value } : { issues: s.common.issues });
  }
  async parseAsync(n, s) {
    const i = await this.safeParseAsync(n, s);
    if (i.success) return i.data;
    throw i.error;
  }
  async safeParseAsync(n, s) {
    const i = { common: { issues: [], contextualErrorMap: s == null ? void 0 : s.errorMap, async: !0 }, path: (s == null ? void 0 : s.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: n, parsedType: wt(n) }, t = this._parse({ data: n, path: i.path, parent: i }), r = await (rr(t) ? t : Promise.resolve(t));
    return Bs(i, r);
  }
  refine(n, s) {
    const i = (t) => typeof s == "string" || s === void 0 ? { message: s } : typeof s == "function" ? s(t) : s;
    return this._refinement((t, r) => {
      const a = n(t), o = () => r.addIssue({ code: N.custom, ...i(t) });
      return typeof Promise < "u" && a instanceof Promise ? a.then((u) => !!u || (o(), !1)) : !!a || (o(), !1);
    });
  }
  refinement(n, s) {
    return this._refinement((i, t) => !!n(i) || (t.addIssue(typeof s == "function" ? s(i, t) : s), !1));
  }
  _refinement(n) {
    return new Mt({ schema: this, typeName: Y.ZodEffects, effect: { type: "refinement", refinement: n } });
  }
  superRefine(n) {
    return this._refinement(n);
  }
  constructor(n) {
    this.spa = this.safeParseAsync, this._def = n, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (s) => this["~validate"](s) };
  }
  optional() {
    return It.create(this, this._def);
  }
  nullable() {
    return Zt.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ot.create(this);
  }
  promise() {
    return or.create(this, this._def);
  }
  or(n) {
    return ir.create([this, n], this._def);
  }
  and(n) {
    return ar.create(this, n, this._def);
  }
  transform(n) {
    return new Mt({ ...X(this._def), schema: this, typeName: Y.ZodEffects, effect: { type: "transform", transform: n } });
  }
  default(n) {
    const s = typeof n == "function" ? n : () => n;
    return new Wr({ ...X(this._def), innerType: this, defaultValue: s, typeName: Y.ZodDefault });
  }
  brand() {
    return new Pl({ typeName: Y.ZodBranded, type: this, ...X(this._def) });
  }
  catch(n) {
    const s = typeof n == "function" ? n : () => n;
    return new Zr({ ...X(this._def), innerType: this, catchValue: s, typeName: Y.ZodCatch });
  }
  describe(n) {
    return new this.constructor({ ...this._def, description: n });
  }
  pipe(n) {
    return os.create(this, n);
  }
  readonly() {
    return Yr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const fl = /^c[^\s-]{8,}$/i, pl = /^[0-9a-z]+$/, vl = /^[0-9A-HJKMNP-TV-Z]{26}$/i, gl = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ml = /^[a-z0-9_-]{21}$/i, bl = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, yl = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Sl = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let Er;
const wl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Rl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, xl = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, _l = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Il = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Tl = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Qi = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Cl = new RegExp(`^${Qi}$`);
function Xi(e) {
  let n = "[0-5]\\d";
  return e.precision ? n = `${n}\\.\\d{${e.precision}}` : e.precision == null && (n = `${n}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${n})${e.precision ? "+" : "?"}`;
}
function El(e) {
  let n = `${Qi}T${Xi(e)}`;
  const s = [];
  return s.push(e.local ? "Z?" : "Z"), e.offset && s.push("([+-]\\d{2}:?\\d{2})"), n = `${n}(${s.join("|")})`, new RegExp(`^${n}$`);
}
function Ol(e, n) {
  if (!bl.test(e)) return !1;
  try {
    const [s] = e.split(".");
    if (!s) return !1;
    const i = s.replace(/-/g, "+").replace(/_/g, "/").padEnd(s.length + (4 - s.length % 4) % 4, "="), t = JSON.parse(atob(i));
    return !(typeof t != "object" || t === null || "typ" in t && (t == null ? void 0 : t.typ) !== "JWT" || !t.alg || n && t.alg !== n);
  } catch {
    return !1;
  }
}
function kl(e, n) {
  return !(n !== "v4" && n || !Rl.test(e)) || !(n !== "v6" && n || !_l.test(e));
}
class mt extends re {
  _parse(n) {
    if (this._def.coerce && (n.data = String(n.data)), this._getType(n) !== G.string) {
      const a = this._getOrReturnCtx(n);
      return L(a, { code: N.invalid_type, expected: G.string, received: a.parsedType }), Q;
    }
    const s = new Ke();
    let i;
    for (const a of this._def.checks) if (a.kind === "min") n.data.length < a.value && (i = this._getOrReturnCtx(n, i), L(i, { code: N.too_small, minimum: a.value, type: "string", inclusive: !0, exact: !1, message: a.message }), s.dirty());
    else if (a.kind === "max") n.data.length > a.value && (i = this._getOrReturnCtx(n, i), L(i, { code: N.too_big, maximum: a.value, type: "string", inclusive: !0, exact: !1, message: a.message }), s.dirty());
    else if (a.kind === "length") {
      const o = n.data.length > a.value, u = n.data.length < a.value;
      (o || u) && (i = this._getOrReturnCtx(n, i), o ? L(i, { code: N.too_big, maximum: a.value, type: "string", inclusive: !0, exact: !0, message: a.message }) : u && L(i, { code: N.too_small, minimum: a.value, type: "string", inclusive: !0, exact: !0, message: a.message }), s.dirty());
    } else if (a.kind === "email") Sl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "email", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "emoji") Er || (Er = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), Er.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "emoji", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "uuid") gl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "uuid", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "nanoid") ml.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "nanoid", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "cuid") fl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "cuid", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "cuid2") pl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "cuid2", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "ulid") vl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "ulid", code: N.invalid_string, message: a.message }), s.dirty());
    else if (a.kind === "url") try {
      new URL(n.data);
    } catch {
      i = this._getOrReturnCtx(n, i), L(i, { validation: "url", code: N.invalid_string, message: a.message }), s.dirty();
    }
    else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "regex", code: N.invalid_string, message: a.message }), s.dirty())) : a.kind === "trim" ? n.data = n.data.trim() : a.kind === "includes" ? n.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(n, i), L(i, { code: N.invalid_string, validation: { includes: a.value, position: a.position }, message: a.message }), s.dirty()) : a.kind === "toLowerCase" ? n.data = n.data.toLowerCase() : a.kind === "toUpperCase" ? n.data = n.data.toUpperCase() : a.kind === "startsWith" ? n.data.startsWith(a.value) || (i = this._getOrReturnCtx(n, i), L(i, { code: N.invalid_string, validation: { startsWith: a.value }, message: a.message }), s.dirty()) : a.kind === "endsWith" ? n.data.endsWith(a.value) || (i = this._getOrReturnCtx(n, i), L(i, { code: N.invalid_string, validation: { endsWith: a.value }, message: a.message }), s.dirty()) : a.kind === "datetime" ? El(a).test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { code: N.invalid_string, validation: "datetime", message: a.message }), s.dirty()) : a.kind === "date" ? Cl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { code: N.invalid_string, validation: "date", message: a.message }), s.dirty()) : a.kind === "time" ? new RegExp(`^${Xi(a)}$`).test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { code: N.invalid_string, validation: "time", message: a.message }), s.dirty()) : a.kind === "duration" ? yl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "duration", code: N.invalid_string, message: a.message }), s.dirty()) : a.kind === "ip" ? (t = n.data, ((r = a.version) !== "v4" && r || !wl.test(t)) && (r !== "v6" && r || !xl.test(t)) && (i = this._getOrReturnCtx(n, i), L(i, { validation: "ip", code: N.invalid_string, message: a.message }), s.dirty())) : a.kind === "jwt" ? Ol(n.data, a.alg) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "jwt", code: N.invalid_string, message: a.message }), s.dirty()) : a.kind === "cidr" ? kl(n.data, a.version) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "cidr", code: N.invalid_string, message: a.message }), s.dirty()) : a.kind === "base64" ? Il.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "base64", code: N.invalid_string, message: a.message }), s.dirty()) : a.kind === "base64url" ? Tl.test(n.data) || (i = this._getOrReturnCtx(n, i), L(i, { validation: "base64url", code: N.invalid_string, message: a.message }), s.dirty()) : oe.assertNever(a);
    var t, r;
    return { status: s.value, value: n.data };
  }
  _regex(n, s, i) {
    return this.refinement((t) => n.test(t), { validation: s, code: N.invalid_string, ...H.errToObj(i) });
  }
  _addCheck(n) {
    return new mt({ ...this._def, checks: [...this._def.checks, n] });
  }
  email(n) {
    return this._addCheck({ kind: "email", ...H.errToObj(n) });
  }
  url(n) {
    return this._addCheck({ kind: "url", ...H.errToObj(n) });
  }
  emoji(n) {
    return this._addCheck({ kind: "emoji", ...H.errToObj(n) });
  }
  uuid(n) {
    return this._addCheck({ kind: "uuid", ...H.errToObj(n) });
  }
  nanoid(n) {
    return this._addCheck({ kind: "nanoid", ...H.errToObj(n) });
  }
  cuid(n) {
    return this._addCheck({ kind: "cuid", ...H.errToObj(n) });
  }
  cuid2(n) {
    return this._addCheck({ kind: "cuid2", ...H.errToObj(n) });
  }
  ulid(n) {
    return this._addCheck({ kind: "ulid", ...H.errToObj(n) });
  }
  base64(n) {
    return this._addCheck({ kind: "base64", ...H.errToObj(n) });
  }
  base64url(n) {
    return this._addCheck({ kind: "base64url", ...H.errToObj(n) });
  }
  jwt(n) {
    return this._addCheck({ kind: "jwt", ...H.errToObj(n) });
  }
  ip(n) {
    return this._addCheck({ kind: "ip", ...H.errToObj(n) });
  }
  cidr(n) {
    return this._addCheck({ kind: "cidr", ...H.errToObj(n) });
  }
  datetime(n) {
    return typeof n == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: n }) : this._addCheck({ kind: "datetime", precision: (n == null ? void 0 : n.precision) === void 0 ? null : n == null ? void 0 : n.precision, offset: (n == null ? void 0 : n.offset) ?? !1, local: (n == null ? void 0 : n.local) ?? !1, ...H.errToObj(n == null ? void 0 : n.message) });
  }
  date(n) {
    return this._addCheck({ kind: "date", message: n });
  }
  time(n) {
    return typeof n == "string" ? this._addCheck({ kind: "time", precision: null, message: n }) : this._addCheck({ kind: "time", precision: (n == null ? void 0 : n.precision) === void 0 ? null : n == null ? void 0 : n.precision, ...H.errToObj(n == null ? void 0 : n.message) });
  }
  duration(n) {
    return this._addCheck({ kind: "duration", ...H.errToObj(n) });
  }
  regex(n, s) {
    return this._addCheck({ kind: "regex", regex: n, ...H.errToObj(s) });
  }
  includes(n, s) {
    return this._addCheck({ kind: "includes", value: n, position: s == null ? void 0 : s.position, ...H.errToObj(s == null ? void 0 : s.message) });
  }
  startsWith(n, s) {
    return this._addCheck({ kind: "startsWith", value: n, ...H.errToObj(s) });
  }
  endsWith(n, s) {
    return this._addCheck({ kind: "endsWith", value: n, ...H.errToObj(s) });
  }
  min(n, s) {
    return this._addCheck({ kind: "min", value: n, ...H.errToObj(s) });
  }
  max(n, s) {
    return this._addCheck({ kind: "max", value: n, ...H.errToObj(s) });
  }
  length(n, s) {
    return this._addCheck({ kind: "length", value: n, ...H.errToObj(s) });
  }
  nonempty(n) {
    return this.min(1, H.errToObj(n));
  }
  trim() {
    return new mt({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new mt({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new mt({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((n) => n.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((n) => n.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((n) => n.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((n) => n.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((n) => n.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((n) => n.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((n) => n.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((n) => n.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((n) => n.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((n) => n.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((n) => n.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((n) => n.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((n) => n.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((n) => n.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((n) => n.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((n) => n.kind === "base64url");
  }
  get minLength() {
    let n = null;
    for (const s of this._def.checks) s.kind === "min" && (n === null || s.value > n) && (n = s.value);
    return n;
  }
  get maxLength() {
    let n = null;
    for (const s of this._def.checks) s.kind === "max" && (n === null || s.value < n) && (n = s.value);
    return n;
  }
}
function Al(e, n) {
  const s = (e.toString().split(".")[1] || "").length, i = (n.toString().split(".")[1] || "").length, t = s > i ? s : i;
  return Number.parseInt(e.toFixed(t).replace(".", "")) % Number.parseInt(n.toFixed(t).replace(".", "")) / 10 ** t;
}
mt.create = (e) => new mt({ checks: [], typeName: Y.ZodString, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...X(e) });
class qt extends re {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(n) {
    if (this._def.coerce && (n.data = Number(n.data)), this._getType(n) !== G.number) {
      const t = this._getOrReturnCtx(n);
      return L(t, { code: N.invalid_type, expected: G.number, received: t.parsedType }), Q;
    }
    let s;
    const i = new Ke();
    for (const t of this._def.checks) t.kind === "int" ? oe.isInteger(n.data) || (s = this._getOrReturnCtx(n, s), L(s, { code: N.invalid_type, expected: "integer", received: "float", message: t.message }), i.dirty()) : t.kind === "min" ? (t.inclusive ? n.data < t.value : n.data <= t.value) && (s = this._getOrReturnCtx(n, s), L(s, { code: N.too_small, minimum: t.value, type: "number", inclusive: t.inclusive, exact: !1, message: t.message }), i.dirty()) : t.kind === "max" ? (t.inclusive ? n.data > t.value : n.data >= t.value) && (s = this._getOrReturnCtx(n, s), L(s, { code: N.too_big, maximum: t.value, type: "number", inclusive: t.inclusive, exact: !1, message: t.message }), i.dirty()) : t.kind === "multipleOf" ? Al(n.data, t.value) !== 0 && (s = this._getOrReturnCtx(n, s), L(s, { code: N.not_multiple_of, multipleOf: t.value, message: t.message }), i.dirty()) : t.kind === "finite" ? Number.isFinite(n.data) || (s = this._getOrReturnCtx(n, s), L(s, { code: N.not_finite, message: t.message }), i.dirty()) : oe.assertNever(t);
    return { status: i.value, value: n.data };
  }
  gte(n, s) {
    return this.setLimit("min", n, !0, H.toString(s));
  }
  gt(n, s) {
    return this.setLimit("min", n, !1, H.toString(s));
  }
  lte(n, s) {
    return this.setLimit("max", n, !0, H.toString(s));
  }
  lt(n, s) {
    return this.setLimit("max", n, !1, H.toString(s));
  }
  setLimit(n, s, i, t) {
    return new qt({ ...this._def, checks: [...this._def.checks, { kind: n, value: s, inclusive: i, message: H.toString(t) }] });
  }
  _addCheck(n) {
    return new qt({ ...this._def, checks: [...this._def.checks, n] });
  }
  int(n) {
    return this._addCheck({ kind: "int", message: H.toString(n) });
  }
  positive(n) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: H.toString(n) });
  }
  negative(n) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: H.toString(n) });
  }
  nonpositive(n) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: H.toString(n) });
  }
  nonnegative(n) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: H.toString(n) });
  }
  multipleOf(n, s) {
    return this._addCheck({ kind: "multipleOf", value: n, message: H.toString(s) });
  }
  finite(n) {
    return this._addCheck({ kind: "finite", message: H.toString(n) });
  }
  safe(n) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: H.toString(n) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: H.toString(n) });
  }
  get minValue() {
    let n = null;
    for (const s of this._def.checks) s.kind === "min" && (n === null || s.value > n) && (n = s.value);
    return n;
  }
  get maxValue() {
    let n = null;
    for (const s of this._def.checks) s.kind === "max" && (n === null || s.value < n) && (n = s.value);
    return n;
  }
  get isInt() {
    return !!this._def.checks.find((n) => n.kind === "int" || n.kind === "multipleOf" && oe.isInteger(n.value));
  }
  get isFinite() {
    let n = null, s = null;
    for (const i of this._def.checks) {
      if (i.kind === "finite" || i.kind === "int" || i.kind === "multipleOf") return !0;
      i.kind === "min" ? (s === null || i.value > s) && (s = i.value) : i.kind === "max" && (n === null || i.value < n) && (n = i.value);
    }
    return Number.isFinite(s) && Number.isFinite(n);
  }
}
qt.create = (e) => new qt({ checks: [], typeName: Y.ZodNumber, coerce: (e == null ? void 0 : e.coerce) || !1, ...X(e) });
class Rn extends re {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(n) {
    if (this._def.coerce) try {
      n.data = BigInt(n.data);
    } catch {
      return this._getInvalidInput(n);
    }
    if (this._getType(n) !== G.bigint) return this._getInvalidInput(n);
    let s;
    const i = new Ke();
    for (const t of this._def.checks) t.kind === "min" ? (t.inclusive ? n.data < t.value : n.data <= t.value) && (s = this._getOrReturnCtx(n, s), L(s, { code: N.too_small, type: "bigint", minimum: t.value, inclusive: t.inclusive, message: t.message }), i.dirty()) : t.kind === "max" ? (t.inclusive ? n.data > t.value : n.data >= t.value) && (s = this._getOrReturnCtx(n, s), L(s, { code: N.too_big, type: "bigint", maximum: t.value, inclusive: t.inclusive, message: t.message }), i.dirty()) : t.kind === "multipleOf" ? n.data % t.value !== BigInt(0) && (s = this._getOrReturnCtx(n, s), L(s, { code: N.not_multiple_of, multipleOf: t.value, message: t.message }), i.dirty()) : oe.assertNever(t);
    return { status: i.value, value: n.data };
  }
  _getInvalidInput(n) {
    const s = this._getOrReturnCtx(n);
    return L(s, { code: N.invalid_type, expected: G.bigint, received: s.parsedType }), Q;
  }
  gte(n, s) {
    return this.setLimit("min", n, !0, H.toString(s));
  }
  gt(n, s) {
    return this.setLimit("min", n, !1, H.toString(s));
  }
  lte(n, s) {
    return this.setLimit("max", n, !0, H.toString(s));
  }
  lt(n, s) {
    return this.setLimit("max", n, !1, H.toString(s));
  }
  setLimit(n, s, i, t) {
    return new Rn({ ...this._def, checks: [...this._def.checks, { kind: n, value: s, inclusive: i, message: H.toString(t) }] });
  }
  _addCheck(n) {
    return new Rn({ ...this._def, checks: [...this._def.checks, n] });
  }
  positive(n) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: H.toString(n) });
  }
  negative(n) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: H.toString(n) });
  }
  nonpositive(n) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: H.toString(n) });
  }
  nonnegative(n) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: H.toString(n) });
  }
  multipleOf(n, s) {
    return this._addCheck({ kind: "multipleOf", value: n, message: H.toString(s) });
  }
  get minValue() {
    let n = null;
    for (const s of this._def.checks) s.kind === "min" && (n === null || s.value > n) && (n = s.value);
    return n;
  }
  get maxValue() {
    let n = null;
    for (const s of this._def.checks) s.kind === "max" && (n === null || s.value < n) && (n = s.value);
    return n;
  }
}
Rn.create = (e) => new Rn({ checks: [], typeName: Y.ZodBigInt, coerce: (e == null ? void 0 : e.coerce) ?? !1, ...X(e) });
class Br extends re {
  _parse(n) {
    if (this._def.coerce && (n.data = !!n.data), this._getType(n) !== G.boolean) {
      const s = this._getOrReturnCtx(n);
      return L(s, { code: N.invalid_type, expected: G.boolean, received: s.parsedType }), Q;
    }
    return st(n.data);
  }
}
Br.create = (e) => new Br({ typeName: Y.ZodBoolean, coerce: (e == null ? void 0 : e.coerce) || !1, ...X(e) });
class sr extends re {
  _parse(n) {
    if (this._def.coerce && (n.data = new Date(n.data)), this._getType(n) !== G.date) {
      const t = this._getOrReturnCtx(n);
      return L(t, { code: N.invalid_type, expected: G.date, received: t.parsedType }), Q;
    }
    if (Number.isNaN(n.data.getTime())) return L(this._getOrReturnCtx(n), { code: N.invalid_date }), Q;
    const s = new Ke();
    let i;
    for (const t of this._def.checks) t.kind === "min" ? n.data.getTime() < t.value && (i = this._getOrReturnCtx(n, i), L(i, { code: N.too_small, message: t.message, inclusive: !0, exact: !1, minimum: t.value, type: "date" }), s.dirty()) : t.kind === "max" ? n.data.getTime() > t.value && (i = this._getOrReturnCtx(n, i), L(i, { code: N.too_big, message: t.message, inclusive: !0, exact: !1, maximum: t.value, type: "date" }), s.dirty()) : oe.assertNever(t);
    return { status: s.value, value: new Date(n.data.getTime()) };
  }
  _addCheck(n) {
    return new sr({ ...this._def, checks: [...this._def.checks, n] });
  }
  min(n, s) {
    return this._addCheck({ kind: "min", value: n.getTime(), message: H.toString(s) });
  }
  max(n, s) {
    return this._addCheck({ kind: "max", value: n.getTime(), message: H.toString(s) });
  }
  get minDate() {
    let n = null;
    for (const s of this._def.checks) s.kind === "min" && (n === null || s.value > n) && (n = s.value);
    return n != null ? new Date(n) : null;
  }
  get maxDate() {
    let n = null;
    for (const s of this._def.checks) s.kind === "max" && (n === null || s.value < n) && (n = s.value);
    return n != null ? new Date(n) : null;
  }
}
sr.create = (e) => new sr({ checks: [], coerce: (e == null ? void 0 : e.coerce) || !1, typeName: Y.ZodDate, ...X(e) });
class Js extends re {
  _parse(n) {
    if (this._getType(n) !== G.symbol) {
      const s = this._getOrReturnCtx(n);
      return L(s, { code: N.invalid_type, expected: G.symbol, received: s.parsedType }), Q;
    }
    return st(n.data);
  }
}
Js.create = (e) => new Js({ typeName: Y.ZodSymbol, ...X(e) });
class qs extends re {
  _parse(n) {
    if (this._getType(n) !== G.undefined) {
      const s = this._getOrReturnCtx(n);
      return L(s, { code: N.invalid_type, expected: G.undefined, received: s.parsedType }), Q;
    }
    return st(n.data);
  }
}
qs.create = (e) => new qs({ typeName: Y.ZodUndefined, ...X(e) });
class Ws extends re {
  _parse(n) {
    if (this._getType(n) !== G.null) {
      const s = this._getOrReturnCtx(n);
      return L(s, { code: N.invalid_type, expected: G.null, received: s.parsedType }), Q;
    }
    return st(n.data);
  }
}
Ws.create = (e) => new Ws({ typeName: Y.ZodNull, ...X(e) });
class Zs extends re {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(n) {
    return st(n.data);
  }
}
Zs.create = (e) => new Zs({ typeName: Y.ZodAny, ...X(e) });
class Ys extends re {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(n) {
    return st(n.data);
  }
}
Ys.create = (e) => new Ys({ typeName: Y.ZodUnknown, ...X(e) });
class _t extends re {
  _parse(n) {
    const s = this._getOrReturnCtx(n);
    return L(s, { code: N.invalid_type, expected: G.never, received: s.parsedType }), Q;
  }
}
_t.create = (e) => new _t({ typeName: Y.ZodNever, ...X(e) });
class Ks extends re {
  _parse(n) {
    if (this._getType(n) !== G.undefined) {
      const s = this._getOrReturnCtx(n);
      return L(s, { code: N.invalid_type, expected: G.void, received: s.parsedType }), Q;
    }
    return st(n.data);
  }
}
Ks.create = (e) => new Ks({ typeName: Y.ZodVoid, ...X(e) });
class ot extends re {
  _parse(n) {
    const { ctx: s, status: i } = this._processInputParams(n), t = this._def;
    if (s.parsedType !== G.array) return L(s, { code: N.invalid_type, expected: G.array, received: s.parsedType }), Q;
    if (t.exactLength !== null) {
      const a = s.data.length > t.exactLength.value, o = s.data.length < t.exactLength.value;
      (a || o) && (L(s, { code: a ? N.too_big : N.too_small, minimum: o ? t.exactLength.value : void 0, maximum: a ? t.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: t.exactLength.message }), i.dirty());
    }
    if (t.minLength !== null && s.data.length < t.minLength.value && (L(s, { code: N.too_small, minimum: t.minLength.value, type: "array", inclusive: !0, exact: !1, message: t.minLength.message }), i.dirty()), t.maxLength !== null && s.data.length > t.maxLength.value && (L(s, { code: N.too_big, maximum: t.maxLength.value, type: "array", inclusive: !0, exact: !1, message: t.maxLength.message }), i.dirty()), s.common.async) return Promise.all([...s.data].map((a, o) => t.type._parseAsync(new lt(s, a, s.path, o)))).then((a) => Ke.mergeArray(i, a));
    const r = [...s.data].map((a, o) => t.type._parseSync(new lt(s, a, s.path, o)));
    return Ke.mergeArray(i, r);
  }
  get element() {
    return this._def.type;
  }
  min(n, s) {
    return new ot({ ...this._def, minLength: { value: n, message: H.toString(s) } });
  }
  max(n, s) {
    return new ot({ ...this._def, maxLength: { value: n, message: H.toString(s) } });
  }
  length(n, s) {
    return new ot({ ...this._def, exactLength: { value: n, message: H.toString(s) } });
  }
  nonempty(n) {
    return this.min(1, n);
  }
}
function Ft(e) {
  if (e instanceof De) {
    const n = {};
    for (const s in e.shape) {
      const i = e.shape[s];
      n[s] = It.create(Ft(i));
    }
    return new De({ ...e._def, shape: () => n });
  }
  return e instanceof ot ? new ot({ ...e._def, type: Ft(e.element) }) : e instanceof It ? It.create(Ft(e.unwrap())) : e instanceof Zt ? Zt.create(Ft(e.unwrap())) : e instanceof At ? At.create(e.items.map((n) => Ft(n))) : e;
}
ot.create = (e, n) => new ot({ type: e, minLength: null, maxLength: null, exactLength: null, typeName: Y.ZodArray, ...X(n) });
class De extends re {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const n = this._def.shape(), s = oe.objectKeys(n);
    return this._cached = { shape: n, keys: s }, this._cached;
  }
  _parse(n) {
    if (this._getType(n) !== G.object) {
      const u = this._getOrReturnCtx(n);
      return L(u, { code: N.invalid_type, expected: G.object, received: u.parsedType }), Q;
    }
    const { status: s, ctx: i } = this._processInputParams(n), { shape: t, keys: r } = this._getCached(), a = [];
    if (!(this._def.catchall instanceof _t && this._def.unknownKeys === "strip")) for (const u in i.data) r.includes(u) || a.push(u);
    const o = [];
    for (const u of r) {
      const l = t[u], c = i.data[u];
      o.push({ key: { status: "valid", value: u }, value: l._parse(new lt(i, c, i.path, u)), alwaysSet: u in i.data });
    }
    if (this._def.catchall instanceof _t) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const l of a) o.push({ key: { status: "valid", value: l }, value: { status: "valid", value: i.data[l] } });
      else if (u === "strict") a.length > 0 && (L(i, { code: N.unrecognized_keys, keys: a }), s.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const l of a) {
        const c = i.data[l];
        o.push({ key: { status: "valid", value: l }, value: u._parse(new lt(i, c, i.path, l)), alwaysSet: l in i.data });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const l of o) {
        const c = await l.key, d = await l.value;
        u.push({ key: c, value: d, alwaysSet: l.alwaysSet });
      }
      return u;
    }).then((u) => Ke.mergeObjectSync(s, u)) : Ke.mergeObjectSync(s, o);
  }
  get shape() {
    return this._def.shape();
  }
  strict(n) {
    return H.errToObj, new De({ ...this._def, unknownKeys: "strict", ...n !== void 0 ? { errorMap: (s, i) => {
      var r, a;
      const t = ((a = (r = this._def).errorMap) == null ? void 0 : a.call(r, s, i).message) ?? i.defaultError;
      return s.code === "unrecognized_keys" ? { message: H.errToObj(n).message ?? t } : { message: t };
    } } : {} });
  }
  strip() {
    return new De({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new De({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(n) {
    return new De({ ...this._def, shape: () => ({ ...this._def.shape(), ...n }) });
  }
  merge(n) {
    return new De({ unknownKeys: n._def.unknownKeys, catchall: n._def.catchall, shape: () => ({ ...this._def.shape(), ...n._def.shape() }), typeName: Y.ZodObject });
  }
  setKey(n, s) {
    return this.augment({ [n]: s });
  }
  catchall(n) {
    return new De({ ...this._def, catchall: n });
  }
  pick(n) {
    const s = {};
    for (const i of oe.objectKeys(n)) n[i] && this.shape[i] && (s[i] = this.shape[i]);
    return new De({ ...this._def, shape: () => s });
  }
  omit(n) {
    const s = {};
    for (const i of oe.objectKeys(this.shape)) n[i] || (s[i] = this.shape[i]);
    return new De({ ...this._def, shape: () => s });
  }
  deepPartial() {
    return Ft(this);
  }
  partial(n) {
    const s = {};
    for (const i of oe.objectKeys(this.shape)) {
      const t = this.shape[i];
      n && !n[i] ? s[i] = t : s[i] = t.optional();
    }
    return new De({ ...this._def, shape: () => s });
  }
  required(n) {
    const s = {};
    for (const i of oe.objectKeys(this.shape)) if (n && !n[i]) s[i] = this.shape[i];
    else {
      let t = this.shape[i];
      for (; t instanceof It; ) t = t._def.innerType;
      s[i] = t;
    }
    return new De({ ...this._def, shape: () => s });
  }
  keyof() {
    return ea(oe.objectKeys(this.shape));
  }
}
De.create = (e, n) => new De({ shape: () => e, unknownKeys: "strip", catchall: _t.create(), typeName: Y.ZodObject, ...X(n) }), De.strictCreate = (e, n) => new De({ shape: () => e, unknownKeys: "strict", catchall: _t.create(), typeName: Y.ZodObject, ...X(n) }), De.lazycreate = (e, n) => new De({ shape: e, unknownKeys: "strip", catchall: _t.create(), typeName: Y.ZodObject, ...X(n) });
class ir extends re {
  _parse(n) {
    const { ctx: s } = this._processInputParams(n), i = this._def.options;
    if (s.common.async) return Promise.all(i.map(async (t) => {
      const r = { ...s, common: { ...s.common, issues: [] }, parent: null };
      return { result: await t._parseAsync({ data: s.data, path: s.path, parent: r }), ctx: r };
    })).then(function(t) {
      for (const a of t) if (a.result.status === "valid") return a.result;
      for (const a of t) if (a.result.status === "dirty") return s.common.issues.push(...a.ctx.common.issues), a.result;
      const r = t.map((a) => new bt(a.ctx.common.issues));
      return L(s, { code: N.invalid_union, unionErrors: r }), Q;
    });
    {
      let t;
      const r = [];
      for (const o of i) {
        const u = { ...s, common: { ...s.common, issues: [] }, parent: null }, l = o._parseSync({ data: s.data, path: s.path, parent: u });
        if (l.status === "valid") return l;
        l.status !== "dirty" || t || (t = { result: l, ctx: u }), u.common.issues.length && r.push(u.common.issues);
      }
      if (t) return s.common.issues.push(...t.ctx.common.issues), t.result;
      const a = r.map((o) => new bt(o));
      return L(s, { code: N.invalid_union, unionErrors: a }), Q;
    }
  }
  get options() {
    return this._def.options;
  }
}
function Jr(e, n) {
  const s = wt(e), i = wt(n);
  if (e === n) return { valid: !0, data: e };
  if (s === G.object && i === G.object) {
    const t = oe.objectKeys(n), r = oe.objectKeys(e).filter((o) => t.indexOf(o) !== -1), a = { ...e, ...n };
    for (const o of r) {
      const u = Jr(e[o], n[o]);
      if (!u.valid) return { valid: !1 };
      a[o] = u.data;
    }
    return { valid: !0, data: a };
  }
  if (s === G.array && i === G.array) {
    if (e.length !== n.length) return { valid: !1 };
    const t = [];
    for (let r = 0; r < e.length; r++) {
      const a = Jr(e[r], n[r]);
      if (!a.valid) return { valid: !1 };
      t.push(a.data);
    }
    return { valid: !0, data: t };
  }
  return s === G.date && i === G.date && +e == +n ? { valid: !0, data: e } : { valid: !1 };
}
ir.create = (e, n) => new ir({ options: e, typeName: Y.ZodUnion, ...X(n) });
class ar extends re {
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n), t = (r, a) => {
      if (zs(r) || zs(a)) return Q;
      const o = Jr(r.value, a.value);
      return o.valid ? (($s(r) || $s(a)) && s.dirty(), { status: s.value, value: o.data }) : (L(i, { code: N.invalid_intersection_types }), Q);
    };
    return i.common.async ? Promise.all([this._def.left._parseAsync({ data: i.data, path: i.path, parent: i }), this._def.right._parseAsync({ data: i.data, path: i.path, parent: i })]).then(([r, a]) => t(r, a)) : t(this._def.left._parseSync({ data: i.data, path: i.path, parent: i }), this._def.right._parseSync({ data: i.data, path: i.path, parent: i }));
  }
}
ar.create = (e, n, s) => new ar({ left: e, right: n, typeName: Y.ZodIntersection, ...X(s) });
class At extends re {
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n);
    if (i.parsedType !== G.array) return L(i, { code: N.invalid_type, expected: G.array, received: i.parsedType }), Q;
    if (i.data.length < this._def.items.length) return L(i, { code: N.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), Q;
    !this._def.rest && i.data.length > this._def.items.length && (L(i, { code: N.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), s.dirty());
    const t = [...i.data].map((r, a) => {
      const o = this._def.items[a] || this._def.rest;
      return o ? o._parse(new lt(i, r, i.path, a)) : null;
    }).filter((r) => !!r);
    return i.common.async ? Promise.all(t).then((r) => Ke.mergeArray(s, r)) : Ke.mergeArray(s, t);
  }
  get items() {
    return this._def.items;
  }
  rest(n) {
    return new At({ ...this._def, rest: n });
  }
}
At.create = (e, n) => {
  if (!Array.isArray(e)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new At({ items: e, typeName: Y.ZodTuple, rest: null, ...X(n) });
};
class as extends re {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n);
    if (i.parsedType !== G.object) return L(i, { code: N.invalid_type, expected: G.object, received: i.parsedType }), Q;
    const t = [], r = this._def.keyType, a = this._def.valueType;
    for (const o in i.data) t.push({ key: r._parse(new lt(i, o, i.path, o)), value: a._parse(new lt(i, i.data[o], i.path, o)), alwaysSet: o in i.data });
    return i.common.async ? Ke.mergeObjectAsync(s, t) : Ke.mergeObjectSync(s, t);
  }
  get element() {
    return this._def.valueType;
  }
  static create(n, s, i) {
    return new as(s instanceof re ? { keyType: n, valueType: s, typeName: Y.ZodRecord, ...X(i) } : { keyType: mt.create(), valueType: n, typeName: Y.ZodRecord, ...X(s) });
  }
}
class Qs extends re {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n);
    if (i.parsedType !== G.map) return L(i, { code: N.invalid_type, expected: G.map, received: i.parsedType }), Q;
    const t = this._def.keyType, r = this._def.valueType, a = [...i.data.entries()].map(([o, u], l) => ({ key: t._parse(new lt(i, o, i.path, [l, "key"])), value: r._parse(new lt(i, u, i.path, [l, "value"])) }));
    if (i.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of a) {
          const l = await u.key, c = await u.value;
          if (l.status === "aborted" || c.status === "aborted") return Q;
          l.status !== "dirty" && c.status !== "dirty" || s.dirty(), o.set(l.value, c.value);
        }
        return { status: s.value, value: o };
      });
    }
    {
      const o = /* @__PURE__ */ new Map();
      for (const u of a) {
        const l = u.key, c = u.value;
        if (l.status === "aborted" || c.status === "aborted") return Q;
        l.status !== "dirty" && c.status !== "dirty" || s.dirty(), o.set(l.value, c.value);
      }
      return { status: s.value, value: o };
    }
  }
}
Qs.create = (e, n, s) => new Qs({ valueType: n, keyType: e, typeName: Y.ZodMap, ...X(s) });
class xn extends re {
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n);
    if (i.parsedType !== G.set) return L(i, { code: N.invalid_type, expected: G.set, received: i.parsedType }), Q;
    const t = this._def;
    t.minSize !== null && i.data.size < t.minSize.value && (L(i, { code: N.too_small, minimum: t.minSize.value, type: "set", inclusive: !0, exact: !1, message: t.minSize.message }), s.dirty()), t.maxSize !== null && i.data.size > t.maxSize.value && (L(i, { code: N.too_big, maximum: t.maxSize.value, type: "set", inclusive: !0, exact: !1, message: t.maxSize.message }), s.dirty());
    const r = this._def.valueType;
    function a(u) {
      const l = /* @__PURE__ */ new Set();
      for (const c of u) {
        if (c.status === "aborted") return Q;
        c.status === "dirty" && s.dirty(), l.add(c.value);
      }
      return { status: s.value, value: l };
    }
    const o = [...i.data.values()].map((u, l) => r._parse(new lt(i, u, i.path, l)));
    return i.common.async ? Promise.all(o).then((u) => a(u)) : a(o);
  }
  min(n, s) {
    return new xn({ ...this._def, minSize: { value: n, message: H.toString(s) } });
  }
  max(n, s) {
    return new xn({ ...this._def, maxSize: { value: n, message: H.toString(s) } });
  }
  size(n, s) {
    return this.min(n, s).max(n, s);
  }
  nonempty(n) {
    return this.min(1, n);
  }
}
xn.create = (e, n) => new xn({ valueType: e, minSize: null, maxSize: null, typeName: Y.ZodSet, ...X(n) });
class Xs extends re {
  get schema() {
    return this._def.getter();
  }
  _parse(n) {
    const { ctx: s } = this._processInputParams(n);
    return this._def.getter()._parse({ data: s.data, path: s.path, parent: s });
  }
}
Xs.create = (e, n) => new Xs({ getter: e, typeName: Y.ZodLazy, ...X(n) });
class qr extends re {
  _parse(n) {
    if (n.data !== this._def.value) {
      const s = this._getOrReturnCtx(n);
      return L(s, { received: s.data, code: N.invalid_literal, expected: this._def.value }), Q;
    }
    return { status: "valid", value: n.data };
  }
  get value() {
    return this._def.value;
  }
}
function ea(e, n) {
  return new Wt({ values: e, typeName: Y.ZodEnum, ...X(n) });
}
qr.create = (e, n) => new qr({ value: e, typeName: Y.ZodLiteral, ...X(n) });
class Wt extends re {
  _parse(n) {
    if (typeof n.data != "string") {
      const s = this._getOrReturnCtx(n), i = this._def.values;
      return L(s, { expected: oe.joinValues(i), received: s.parsedType, code: N.invalid_type }), Q;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(n.data)) {
      const s = this._getOrReturnCtx(n), i = this._def.values;
      return L(s, { received: s.data, code: N.invalid_enum_value, options: i }), Q;
    }
    return st(n.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const n = {};
    for (const s of this._def.values) n[s] = s;
    return n;
  }
  get Values() {
    const n = {};
    for (const s of this._def.values) n[s] = s;
    return n;
  }
  get Enum() {
    const n = {};
    for (const s of this._def.values) n[s] = s;
    return n;
  }
  extract(n, s = this._def) {
    return Wt.create(n, { ...this._def, ...s });
  }
  exclude(n, s = this._def) {
    return Wt.create(this.options.filter((i) => !n.includes(i)), { ...this._def, ...s });
  }
}
Wt.create = ea;
class ei extends re {
  _parse(n) {
    const s = oe.getValidEnumValues(this._def.values), i = this._getOrReturnCtx(n);
    if (i.parsedType !== G.string && i.parsedType !== G.number) {
      const t = oe.objectValues(s);
      return L(i, { expected: oe.joinValues(t), received: i.parsedType, code: N.invalid_type }), Q;
    }
    if (this._cache || (this._cache = new Set(oe.getValidEnumValues(this._def.values))), !this._cache.has(n.data)) {
      const t = oe.objectValues(s);
      return L(i, { received: i.data, code: N.invalid_enum_value, options: t }), Q;
    }
    return st(n.data);
  }
  get enum() {
    return this._def.values;
  }
}
ei.create = (e, n) => new ei({ values: e, typeName: Y.ZodNativeEnum, ...X(n) });
class or extends re {
  unwrap() {
    return this._def.type;
  }
  _parse(n) {
    const { ctx: s } = this._processInputParams(n);
    if (s.parsedType !== G.promise && s.common.async === !1) return L(s, { code: N.invalid_type, expected: G.promise, received: s.parsedType }), Q;
    const i = s.parsedType === G.promise ? s.data : Promise.resolve(s.data);
    return st(i.then((t) => this._def.type.parseAsync(t, { path: s.path, errorMap: s.common.contextualErrorMap })));
  }
}
or.create = (e, n) => new or({ type: e, typeName: Y.ZodPromise, ...X(n) });
class Mt extends re {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Y.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n), t = this._def.effect || null, r = { addIssue: (a) => {
      L(i, a), a.fatal ? s.abort() : s.dirty();
    }, get path() {
      return i.path;
    } };
    if (r.addIssue = r.addIssue.bind(r), t.type === "preprocess") {
      const a = t.transform(i.data, r);
      if (i.common.async) return Promise.resolve(a).then(async (o) => {
        if (s.value === "aborted") return Q;
        const u = await this._def.schema._parseAsync({ data: o, path: i.path, parent: i });
        return u.status === "aborted" ? Q : u.status === "dirty" || s.value === "dirty" ? $r(u.value) : u;
      });
      {
        if (s.value === "aborted") return Q;
        const o = this._def.schema._parseSync({ data: a, path: i.path, parent: i });
        return o.status === "aborted" ? Q : o.status === "dirty" || s.value === "dirty" ? $r(o.value) : o;
      }
    }
    if (t.type === "refinement") {
      const a = (o) => {
        const u = t.refinement(o, r);
        if (i.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (i.common.async === !1) {
        const o = this._def.schema._parseSync({ data: i.data, path: i.path, parent: i });
        return o.status === "aborted" ? Q : (o.status === "dirty" && s.dirty(), a(o.value), { status: s.value, value: o.value });
      }
      return this._def.schema._parseAsync({ data: i.data, path: i.path, parent: i }).then((o) => o.status === "aborted" ? Q : (o.status === "dirty" && s.dirty(), a(o.value).then(() => ({ status: s.value, value: o.value }))));
    }
    if (t.type === "transform") {
      if (i.common.async === !1) {
        const a = this._def.schema._parseSync({ data: i.data, path: i.path, parent: i });
        if (!Jt(a)) return Q;
        const o = t.transform(a.value, r);
        if (o instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: s.value, value: o };
      }
      return this._def.schema._parseAsync({ data: i.data, path: i.path, parent: i }).then((a) => Jt(a) ? Promise.resolve(t.transform(a.value, r)).then((o) => ({ status: s.value, value: o })) : Q);
    }
    oe.assertNever(t);
  }
}
Mt.create = (e, n, s) => new Mt({ schema: e, typeName: Y.ZodEffects, effect: n, ...X(s) }), Mt.createWithPreprocess = (e, n, s) => new Mt({ schema: n, effect: { type: "preprocess", transform: e }, typeName: Y.ZodEffects, ...X(s) });
class It extends re {
  _parse(n) {
    return this._getType(n) === G.undefined ? st(void 0) : this._def.innerType._parse(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
It.create = (e, n) => new It({ innerType: e, typeName: Y.ZodOptional, ...X(n) });
class Zt extends re {
  _parse(n) {
    return this._getType(n) === G.null ? st(null) : this._def.innerType._parse(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Zt.create = (e, n) => new Zt({ innerType: e, typeName: Y.ZodNullable, ...X(n) });
class Wr extends re {
  _parse(n) {
    const { ctx: s } = this._processInputParams(n);
    let i = s.data;
    return s.parsedType === G.undefined && (i = this._def.defaultValue()), this._def.innerType._parse({ data: i, path: s.path, parent: s });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Wr.create = (e, n) => new Wr({ innerType: e, typeName: Y.ZodDefault, defaultValue: typeof n.default == "function" ? n.default : () => n.default, ...X(n) });
class Zr extends re {
  _parse(n) {
    const { ctx: s } = this._processInputParams(n), i = { ...s, common: { ...s.common, issues: [] } }, t = this._def.innerType._parse({ data: i.data, path: i.path, parent: { ...i } });
    return rr(t) ? t.then((r) => ({ status: "valid", value: r.status === "valid" ? r.value : this._def.catchValue({ get error() {
      return new bt(i.common.issues);
    }, input: i.data }) })) : { status: "valid", value: t.status === "valid" ? t.value : this._def.catchValue({ get error() {
      return new bt(i.common.issues);
    }, input: i.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Zr.create = (e, n) => new Zr({ innerType: e, typeName: Y.ZodCatch, catchValue: typeof n.catch == "function" ? n.catch : () => n.catch, ...X(n) });
class ti extends re {
  _parse(n) {
    if (this._getType(n) !== G.nan) {
      const s = this._getOrReturnCtx(n);
      return L(s, { code: N.invalid_type, expected: G.nan, received: s.parsedType }), Q;
    }
    return { status: "valid", value: n.data };
  }
}
ti.create = (e) => new ti({ typeName: Y.ZodNaN, ...X(e) });
class Pl extends re {
  _parse(n) {
    const { ctx: s } = this._processInputParams(n), i = s.data;
    return this._def.type._parse({ data: i, path: s.path, parent: s });
  }
  unwrap() {
    return this._def.type;
  }
}
class os extends re {
  _parse(n) {
    const { status: s, ctx: i } = this._processInputParams(n);
    if (i.common.async) return (async () => {
      const t = await this._def.in._parseAsync({ data: i.data, path: i.path, parent: i });
      return t.status === "aborted" ? Q : t.status === "dirty" ? (s.dirty(), $r(t.value)) : this._def.out._parseAsync({ data: t.value, path: i.path, parent: i });
    })();
    {
      const t = this._def.in._parseSync({ data: i.data, path: i.path, parent: i });
      return t.status === "aborted" ? Q : t.status === "dirty" ? (s.dirty(), { status: "dirty", value: t.value }) : this._def.out._parseSync({ data: t.value, path: i.path, parent: i });
    }
  }
  static create(n, s) {
    return new os({ in: n, out: s, typeName: Y.ZodPipeline });
  }
}
class Yr extends re {
  _parse(n) {
    const s = this._def.innerType._parse(n), i = (t) => (Jt(t) && (t.value = Object.freeze(t.value)), t);
    return rr(s) ? s.then((t) => i(t)) : i(s);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var Y;
Yr.create = (e, n) => new Yr({ innerType: e, typeName: Y.ZodReadonly, ...X(n) }), function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
}(Y || (Y = {}));
const E = mt.create, K = qt.create, Xe = Br.create, Ge = (_t.create, ot.create), ne = De.create, Hn = ir.create, ta = (ar.create, At.create, as.create), na = qr.create, _e = Wt.create;
or.create, It.create, Zt.create;
var ra = K().min(0).max(Bt).refine(function(e) {
  return Math.abs(Math.round(10 * e) - 10 * e) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), sa = _e(["N", "C"]);
ne({ status: _e(["confirmed", "inferred", "unmapped"]), confidence: _e(["high", "medium", "low"]), signals: Ge(E()), confirmedBy: E().nullable(), confirmedAt: E().nullable(), source: _e(["reviewer", "auto"]) });
var ia = ne({ id: E().optional(), type: sa.default("N"), movementNumber: K().int().positive(), description: E(), directive: E().optional(), location: E().optional(), coefficient: K().min(0.01).max(10), section: _e(["technical", "artistic", "quality"]).optional() }), jl = ne({ id: E().optional(), type: sa.default("C"), movementNumber: K().int().positive(), name: E(), directive: E().optional(), coefficient: K().min(0.01).max(10) }), Ul = ia.extend({ displayOrder: K() }), Nl = ne({ added: Ge(Ul).default([]), removed: Ge(K().int().positive()).default([]) });
ne({ id: E(), fvdId: Hn([K(), E()]).nullable().optional(), source: _e(["catalog", "custom"]).optional(), testCode: E(), organization: E().optional(), level: E().optional(), testNumber: K().int().optional(), movements: Ge(ia), collectives: Ge(jl), purpose: E().optional(), introduce: E().optional(), errorRule: ne({ unit: _e(["points", "percent"]).optional(), first: Hn([K(), E()]).nullable().optional(), second: Hn([K(), E()]).nullable().optional(), third: Hn([K(), E()]).nullable().optional() }).nullable().optional(), collectivesLabel: E().default("Collective Marks"), commentMode: _e(["perMovement", "generalOnly"]).default("perMovement"), hasRideTiming: Xe().default(!0), sheetLayout: _e(["movement-grid", "class-grid"]).default("movement-grid"), observations: Ge(ne({ key: E(), group: E(), label: E(), optional: na(!0) })).default([]), panel: ne({ minJudges: K().int().positive(), maxJudges: K().int().positive(), consensus: Xe().default(!1), judgeFloor: K().int().positive().optional(), judgeFloorRule: E().optional() }).optional(), placing: ne({ source: _e(["computed", "judge-entered"]).default("computed"), tieBreak: _e(["standard", "none", "ride-off", "movement-totals"]).default("standard") }).optional(), publication: ne({ scoreSheet: _e(["public", "suppressed"]).default("public"), rule: E().optional() }).optional() });
var Ll = ne({ movementNumber: K().int().positive(), score: ra.optional().nullable(), remarks: E().max(500).optional(), flagged: Xe().default(!1), annotatedDirective: E().optional(), annotatedDescription: E().optional(), deductions: Ge(ne({ id: E(), reason: E(), points: K().positive() })).optional() }), Dl = ne({ score: ra.optional(), remarks: E().max(500).optional(), flagged: Xe().optional(), annotatedName: E().optional(), annotatedDirective: E().optional() }), Fl = ta(E().regex(/^\d+$/), Dl), Ml = ne({ id: E(), movementNumber: K().int().nullable().optional(), text: E().min(1).max(1e3), addedBy: E().nullable(), addedAt: E() });
ne({ id: E().optional(), rideId: E(), judgeId: E(), testId: E(), movementScores: Ge(Ll).default([]), collectives: Fl.default({}), annotations: Ge(Ml).default([]), annotatedPurpose: E().optional(), annotatedIntroduce: E().optional(), generalRemarks: E().max(2e3).optional(), entryTimeSeconds: K().nonnegative().optional(), totalPoints: K().optional(), maxPoints: K().optional(), percentage: K().nullable().optional(), observationMarks: ta(E(), K()).optional(), place: K().int().positive().nullable().optional(), technicalPoints: K().optional(), technicalMaxPoints: K().optional(), artisticPoints: K().optional(), artisticMaxPoints: K().optional(), qualityPoints: K().optional(), qualityMaxPoints: K().optional(), judgeSignature: E().optional(), signature: ne({ judgeId: E(), signatureHash: E(), signedAt: E() }).optional(), signatures: Ge(ne({ judgeId: E(), signatureHash: E(), signedAt: E() })).optional(), compositeSignatures: Ge(ne({ realJudgeId: E(), signatureHash: E(), signedAt: E() })).optional(), authoritative: Xe().optional(), contenderOf: E().nullable().optional(), contenderPending: E().optional(), createKey: E().optional(), provenance: ne({ origin: _e(["scribe", "admin", "fvd"]), author: E().nullable(), capturedAt: E(), device: E().nullable().optional() }).optional(), eliminations: Ge(ne({ id: E(), reason: E(), movementNumber: K().int().positive().nullable().optional(), fromError: Xe().optional() })).optional(), errors: Ge(ne({ id: E(), label: E(), points: K().nonnegative().optional(), percent: K().nonnegative().optional(), movementNumber: K().int().positive().nullable().optional(), amountSource: _e([Vs.RULE, Vs.MANUAL]).optional() })).optional(), marksConfirmedAt: E().optional(), marksConfirmedBy: E().optional(), timeFault: ne({ exceeded: Xe(), elapsedSeconds: K(), limitSeconds: K(), recordedAt: E() }).optional(), numericOnly: Xe().optional(), noSignatureNeeded: Xe().optional(), completedAt: E().optional(), version: K().int().nonnegative().optional() });
_e(Zi);
var ni = ne(Object.fromEntries(Zi.map(function(e) {
  return [e, Ge(E()).optional()];
})));
ne({ id: E(), showId: E(), testId: E().optional(), className: E(), scheduledTime: E(), ring: E().optional(), judgeAssignments: ni.optional(), judgeIds: Ge(E()).optional(), scribeAssignments: ni.optional(), qualityJudging: ne({ topology: _e(["two-judge", "technical-only"]), qualityPosition: _e(["E", "B"]).nullable().optional(), qualityJudge: E().nullable().optional() }).optional(), faultTimeLimitSeconds: K().int().positive().default(45), errorDeductionScheme: _e(Object.values(pn)).default(pn.POINTS), sectionJudgeAssignments: ne({ technical: E().nullable().optional(), quality: E().nullable().optional() }).optional(), walkTrotOnly: Xe().default(!1), hidden: Xe().optional(), hiddenAutoSetAt: E().optional(), order: K().optional(), testDisagreement: ne({ flagged: na(!0), signals: Ge(_e(Object.values(ul))).min(1) }).nullable().optional(), sponsorId: E().nullable().optional(), prize: E().nullable().optional() });
var Gl = ne({ id: E(), type: _e(Object.values(is)), raisedByScribeId: E().nullable(), raisedAt: E(), acknowledged: ne({ byScribeId: E().nullable(), at: E() }).nullable().optional() });
ne({ type: _e(Object.values(is)) });
var Vl = ne({ eventId: E(), type: _e(Object.values(is)), clearedByScribeId: E().nullable(), clearedAt: E() });
ne({ id: E(), classId: E(), testId: E().optional(), horseId: E(), riderId: E(), rideNumber: K().int().positive(), scheduledTime: E().optional(), status: E().optional(), percentage: K().optional(), priorScore: K().nullable().optional(), allSheetsCompletedAt: E().nullable().optional(), adminConfirmedAt: E().nullable().optional(), adminConfirmedBy: E().nullable().optional(), compositePercentage: K().nullable().optional(), placing: K().int().positive().nullable().optional(), isManual: Xe().optional(), needsReview: Xe().optional(), judgeIds: Ge(E()).optional(), competitorNumber: E().optional(), horseName: E().optional(), riderName: E().optional(), trainerId: E().optional(), resolvedIntoRideId: E().nullable().optional(), filledFromRideId: E().nullable().optional(), utilityEvents: Ge(Gl).optional(), utilityEventClears: Ge(Vl).optional(), movementOverride: Nl.optional(), placingStaleAt: E().nullable().optional(), fvdWriteBackBlockedByOverride: Xe().nullable().optional(), terminationReason: ne({ reason: _e(Object.values(il)), setAt: E(), setBy: E().nullable().optional(), source: E() }).nullable().optional() });
ne({ classId: E(), showId: E().optional(), scheduledTime: E().optional(), testId: E().optional(), competitorNumber: E().optional(), horseName: E().optional(), riderName: E().optional() });
ne({ id: E(), personType: _e(["RIDER", "JUDGE", "SCRIBE"]), firstName: E(), lastName: E(), usefId: E().optional(), usdfId: E().optional(), email: E().optional(), unlockCode: E().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: E().optional() });
ne({ id: E(), name: E(), breed: E().optional(), foalYear: K().int().optional(), usefId: E().optional(), usdfId: E().optional() });
const w = (ri = { default: () => Ei.default }, Or = {}, fn.d(Or, ri), Or);
var ri, Or;
function aa(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function Kr(e, n, s) {
  return Kr = us() ? Reflect.construct : function(i, t, r) {
    var a = [null];
    a.push.apply(a, t);
    var o = new (Function.bind.apply(i, a))();
    return r && In(o, r.prototype), o;
  }, Kr.apply(null, arguments);
}
function Zn(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function _n(e) {
  return _n = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _n(e);
}
function In(e, n) {
  return In = Object.setPrototypeOf || function(s, i) {
    return s.__proto__ = i, s;
  }, In(e, n);
}
function Qr(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Qr = function(s) {
    if (s === null || (i = s, Function.toString.call(i).indexOf("[native code]") === -1)) return s;
    var i;
    if (typeof s != "function") throw new TypeError("Super expression must either be null or a function");
    if (n !== void 0) {
      if (n.has(s)) return n.get(s);
      n.set(s, t);
    }
    function t() {
      return Kr(s, arguments, _n(this).constructor);
    }
    return t.prototype = Object.create(s.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), In(t, s);
  }, Qr(e);
}
function us() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (us = function() {
    return !!e;
  })();
}
var R = "http://localhost".replace(/\/+$/, ""), Oe = function e(n) {
  var s, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : R, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : w.default;
  aa(this, e), Zn(this, "basePath", void 0), Zn(this, "axios", void 0), Zn(this, "configuration", void 0), this.basePath = i, this.axios = t, n && (this.configuration = n, this.basePath = (s = n.basePath) !== null && s !== void 0 ? s : i);
}, Hl = function() {
  function e(n, s) {
    var i;
    return aa(this, e), Zn(i = function(t, r, a) {
      return r = _n(r), o = t, !(u = us() ? Reflect.construct(r, a || [], _n(t).constructor) : r.apply(t, a)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, e, [s]), "field", void 0), i.field = n, i.name = "RequiredError", i;
  }
  return function(n, s) {
    if (typeof s != "function" && s !== null) throw new TypeError("Super expression must either be null or a function");
    n.prototype = Object.create(s && s.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), s && In(n, s);
  }(e, Qr(Error)), e;
}(), x = {};
function si(e, n, s, i, t, r, a) {
  try {
    var o = e[r](a), u = o.value;
  } catch (l) {
    return void s(l);
  }
  o.done ? n(u) : Promise.resolve(u).then(i, t);
}
function zl(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
var _ = "https://example.com", y = function(e, n, s) {
  if (s == null) throw new Hl(n, "Required parameter ".concat(n, " was null or undefined when calling ").concat(e, "."));
}, O = function(e, n) {
  return (s = function() {
    var i, t;
    return function(r, a) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(m) {
        return function(j) {
          return function(S) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, S[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & S[0] ? u.return : S[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, S[1])).done) return l;
              switch (u = 0, l && (S = [2 & S[0], l.value]), S[0]) {
                case 0:
                case 1:
                  l = S;
                  break;
                case 4:
                  return c.label++, { value: S[1], done: !1 };
                case 5:
                  c.label++, u = S[1], S = [0];
                  continue;
                case 7:
                  S = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || S[0] !== 6 && S[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (S[0] === 3 && (!l || S[1] > l[0] && S[1] < l[3])) {
                    c.label = S[1];
                    break;
                  }
                  if (S[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = S;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(S);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              S = a.call(r, c);
            } catch (F) {
              S = [6, F], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & S[0]) throw S[1];
            return { value: S[0] ? S[1] : void 0, done: !0 };
          }([m, j]);
        };
      }
    }(this, function(r) {
      switch (r.label) {
        case 0:
          return n && n.accessToken ? typeof n.accessToken != "function" ? [3, 2] : [4, n.accessToken()] : [3, 5];
        case 1:
          return t = r.sent(), [3, 4];
        case 2:
          return [4, n.accessToken];
        case 3:
          t = r.sent(), r.label = 4;
        case 4:
          i = t, e.Authorization = "Bearer " + i, r.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var i = this, t = arguments;
    return new Promise(function(r, a) {
      var o = s.apply(i, t);
      function u(c) {
        si(o, r, a, u, l, "next", c);
      }
      function l(c) {
        si(o, r, a, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var s;
};
function Xr(e, n) {
  var s, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  n != null && ((n === void 0 ? "undefined" : (s = n) && typeof Symbol < "u" && s.constructor === Symbol ? "symbol" : typeof s) == "object" ? Array.isArray(n) ? n.forEach(function(t) {
    return Xr(e, t, i);
  }) : Object.keys(n).forEach(function(t) {
    return Xr(e, n[t], "".concat(i).concat(i !== "" ? "." : "").concat(t));
  }) : e.has(i) ? e.append(i, n) : e.set(i, n));
}
var I = function(e) {
  for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) s[i - 1] = arguments[i];
  var t = new URLSearchParams(e.search);
  Xr(t, s), e.search = t.toString();
}, M = function(e, n, s) {
  var i = typeof e != "string";
  return (i && s && s.isJsonMime ? s.isJsonMime(n.headers["Content-Type"]) : i) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, T = function(e) {
  return e.pathname + e.search + e.hash;
}, C = function(e, n, s, i) {
  return function() {
    var t, r, a, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s, l = (r = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, m = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (m = m.concat(Object.getOwnPropertySymbols(h).filter(function(j) {
          return Object.getOwnPropertyDescriptor(h, j).enumerable;
        }))), m.forEach(function(j) {
          zl(c, j, h[j]);
        });
      }
      return c;
    }({}, e.options), a = (a = { url: (o.defaults.baseURL ? "" : (t = i == null ? void 0 : i.basePath) !== null && t !== void 0 ? t : u) + e.url }) != null ? a : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(a)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(a)).forEach(function(c) {
      Object.defineProperty(r, c, Object.getOwnPropertyDescriptor(a, c));
    }), r);
    return o.request(l);
  };
};
function ii(e, n, s, i, t, r, a) {
  try {
    var o = e[r](a), u = o.value;
  } catch (l) {
    return void s(l);
  }
  o.done ? n(u) : Promise.resolve(u).then(i, t);
}
function v(e) {
  return function() {
    var n = this, s = arguments;
    return new Promise(function(i, t) {
      var r = e.apply(n, s);
      function a(u) {
        ii(r, i, t, a, o, "next", u);
      }
      function o(u) {
        ii(r, i, t, a, o, "throw", u);
      }
      a(void 0);
    });
  };
}
function ke(e, n, s) {
  return n = ur(n), i = e, !(t = oa() ? Reflect.construct(n, s || [], ur(e).constructor) : n.apply(e, s)) || ((r = t) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) != "object" && typeof t != "function" ? function(a) {
    if (a === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return a;
  }(i) : t;
  var i, t, r;
}
function Ae(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $l(e, n) {
  for (var s = 0; s < n.length; s++) {
    var i = n[s];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function Pe(e, n, s) {
  return n && $l(e.prototype, n), e;
}
function Bl(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function ur(e) {
  return ur = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ur(e);
}
function je(e, n) {
  if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && es(e, n);
}
function p(e) {
  for (var n = 1; n < arguments.length; n++) {
    var s = arguments[n] != null ? arguments[n] : {}, i = Object.keys(s);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(s).filter(function(t) {
      return Object.getOwnPropertyDescriptor(s, t).enumerable;
    }))), i.forEach(function(t) {
      Bl(e, t, s[t]);
    });
  }
  return e;
}
function es(e, n) {
  return es = Object.setPrototypeOf || function(s, i) {
    return s.__proto__ = i, s;
  }, es(e, n);
}
function oa() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (oa = function() {
    return !!e;
  })();
}
function g(e, n) {
  var s, i, t, r = { label: 0, sent: function() {
    if (1 & t[0]) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = o(0), a.throw = o(1), a.return = o(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function o(u) {
    return function(l) {
      return function(c) {
        if (s) throw new TypeError("Generator is already executing.");
        for (; a && (a = 0, c[0] && (r = 0)), r; ) try {
          if (s = 1, i && (t = 2 & c[0] ? i.return : c[0] ? i.throw || ((t = i.return) && t.call(i), 0) : i.next) && !(t = t.call(i, c[1])).done) return t;
          switch (i = 0, t && (c = [2 & c[0], t.value]), c[0]) {
            case 0:
            case 1:
              t = c;
              break;
            case 4:
              return r.label++, { value: c[1], done: !1 };
            case 5:
              r.label++, i = c[1], c = [0];
              continue;
            case 7:
              c = r.ops.pop(), r.trys.pop();
              continue;
            default:
              if (!((t = (t = r.trys).length > 0 && t[t.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                r = 0;
                continue;
              }
              if (c[0] === 3 && (!t || c[1] > t[0] && c[1] < t[3])) {
                r.label = c[1];
                break;
              }
              if (c[0] === 6 && r.label < t[1]) {
                r.label = t[1], t = c;
                break;
              }
              if (t && r.label < t[2]) {
                r.label = t[2], r.ops.push(c);
                break;
              }
              t[2] && r.ops.pop(), r.trys.pop();
              continue;
          }
          c = n.call(e, r);
        } catch (d) {
          c = [6, d], i = 0;
        } finally {
          s = t = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var Jl = function(e) {
  return { listBreaks: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("listBreaks", "showId", n), t = new URL("/break", _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, i), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), n !== void 0 && (u.showId = n), s !== void 0 && (u.ring = s), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, i.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  } };
}, ql = function(e) {
  var n = Jl(e);
  return { listBreaks: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.listBreaks(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["BreaksApi.listBreaks"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "listBreaks", value: function(s, i, t) {
    var r = this;
    return ql(this.configuration).listBreaks(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var Wl = function(e) {
  return { getCatalogTest: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getCatalogTest", "id", n), i = "/catalog/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listCatalog: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/catalog", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, patchCatalogTest: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("patchCatalogTest", "id", n), t = "/catalog/{id}".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PATCH" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, kr = function(e) {
  var n = Wl(e);
  return { getCatalogTest: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getCatalogTest(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["CatalogApi.getCatalogTest"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listCatalog: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listCatalog(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["CatalogApi.listCatalog"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, patchCatalogTest: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.patchCatalogTest(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["CatalogApi.patchCatalogTest"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getCatalogTest", value: function(s, i) {
    var t = this;
    return kr(this.configuration).getCatalogTest(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listCatalog", value: function(s) {
    var i = this;
    return kr(this.configuration).listCatalog(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "patchCatalogTest", value: function(s, i, t) {
    var r = this;
    return kr(this.configuration).patchCatalogTest(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var Zl = function(e) {
  return { getChampionshipFillOptions: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getChampionshipFillOptions", "classId", n), i = "/class/{classId}/championship-fill-options".replace("{classId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getClass: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getClass", "classId", n), i = "/class/{classId}".replace("{classId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listClasses: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("listClasses", "showId", n), t = new URL("/class", _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, i), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), n !== void 0 && (u.showId = n), s !== void 0 && (u.mine = s), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, i.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listClassesForShows: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("listClassesForShows", "listClassesForShowsRequest", n), i = new URL("/class/batch", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassDshbKindOverride", "classId", n), y("setClassDshbKindOverride", "setClassDshbKindOverrideRequest", s), t = "/class/{classId}/dshb-kind-override".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassErrorDeductionScheme", "classId", n), y("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", s), t = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassFaultTimeLimit", "classId", n), y("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", s), t = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassFriendlyName: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassFriendlyName", "classId", n), y("setClassFriendlyName", "setClassFriendlyNameRequest", s), t = "/class/{classId}/friendly-name".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassHidden: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassHidden", "classId", n), y("setClassHidden", "setClassHiddenRequest", s), t = "/class/{classId}/hidden".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassPaperEntry: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassPaperEntry", "classId", n), y("setClassPaperEntry", "setClassPaperEntryRequest", s), t = "/class/{classId}/paper-entry".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassQualityJudging: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassQualityJudging", "classId", n), y("setClassQualityJudging", "setClassQualityJudgingRequest", s), t = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassResultLayout: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassResultLayout", "classId", n), y("setClassResultLayout", "setClassResultLayoutRequest", s), t = "/class/{classId}/result-layout".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassScribeAssignment: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassScribeAssignment", "classId", n), y("setClassScribeAssignment", "setClassScribeAssignmentRequest", s), t = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassSectionJudgeAssignments", "classId", n), t = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassSkipUsefUpload", "classId", n), y("setClassSkipUsefUpload", "setClassSkipUsefUploadRequest", s), t = "/class/{classId}/skip-usef-upload".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassSponsorship: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassSponsorship", "classId", n), t = "/class/{classId}/sponsorship".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassWalkTrotOnly", "classId", n), y("setClassWalkTrotOnly", "setClassWalkTrotOnlyRequest", s), t = "/class/{classId}/walk-trot-only".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setRingScribeAssignments: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setRingScribeAssignments", "ring", n), y("setRingScribeAssignments", "setRingScribeAssignmentsRequest", s), t = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, He = function(e) {
  var n = Zl(e);
  return { getChampionshipFillOptions: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getChampionshipFillOptions(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ClassesApi.getChampionshipFillOptions"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getClass: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getClass(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ClassesApi.getClass"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listClasses: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.listClasses(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.listClasses"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, listClassesForShows: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listClassesForShows(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ClassesApi.listClassesForShows"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassDshbKindOverride(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassDshbKindOverride"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassErrorDeductionScheme(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassErrorDeductionScheme"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassFaultTimeLimit(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassFaultTimeLimit"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassFriendlyName: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassFriendlyName(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassFriendlyName"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassHidden: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassHidden(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassHidden"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassPaperEntry: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassPaperEntry(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassPaperEntry"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassQualityJudging(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassQualityJudging"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassResultLayout: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassResultLayout(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassResultLayout"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassScribeAssignment(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassScribeAssignment"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassSectionJudgeAssignments(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassSectionJudgeAssignments"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassSkipUsefUpload(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassSkipUsefUpload"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassSponsorship: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassSponsorship(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassSponsorship"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassWalkTrotOnly(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setClassWalkTrotOnly"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setRingScribeAssignments(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ClassesApi.setRingScribeAssignments"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getChampionshipFillOptions", value: function(s, i) {
    var t = this;
    return He(this.configuration).getChampionshipFillOptions(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getClass", value: function(s, i) {
    var t = this;
    return He(this.configuration).getClass(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listClasses", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).listClasses(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "listClassesForShows", value: function(s, i) {
    var t = this;
    return He(this.configuration).listClassesForShows(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "setClassDshbKindOverride", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassDshbKindOverride(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassErrorDeductionScheme(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassFaultTimeLimit(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassFriendlyName", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassFriendlyName(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassHidden", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassHidden(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassPaperEntry", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassPaperEntry(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassQualityJudging(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassResultLayout", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassResultLayout(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassScribeAssignment(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassSectionJudgeAssignments(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassSkipUsefUpload", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassSkipUsefUpload(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassSponsorship", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassSponsorship(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setClassWalkTrotOnly", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setClassWalkTrotOnly(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(s, i, t) {
    var r = this;
    return He(this.configuration).setRingScribeAssignments(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var Yl = function(e) {
  return { getDaysheetReconcileStatus: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getDaysheetReconcileStatus", "showId", n), i = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, reconcileDaysheet: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("reconcileDaysheet", "showId", n), i = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "POST" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  } };
}, ai = function(e) {
  var n = Yl(e);
  return { getDaysheetReconcileStatus: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getDaysheetReconcileStatus(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["DaySheetApi.getDaysheetReconcileStatus"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.reconcileDaysheet(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["DaySheetApi.reconcileDaysheet"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getDaysheetReconcileStatus", value: function(s, i) {
    var t = this;
    return ai(this.configuration).getDaysheetReconcileStatus(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(s, i) {
    var t = this;
    return ai(this.configuration).reconcileDaysheet(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
})(Oe);
var Kl = function(e) {
  return { reseedDemo: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("reseedDemo", "reseedDemoRequest", n), i = new URL("/demo/reseed", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  } };
}, Ql = function(e) {
  var n = Kl(e);
  return { reseedDemo: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.reseedDemo(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["DemoApi.reseedDemo"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "reseedDemo", value: function(s, i) {
    var t = this;
    return Ql(this.configuration).reseedDemo(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
})(Oe);
var Xl = function(e) {
  return { getHealth: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a;
      return g(this, function(o) {
        return s = new URL("/health", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), r = {}, I(s, {}), a = i && i.headers ? i.headers : {}, t.headers = p({}, r, a, n.headers), [2, { url: T(s), options: t }];
      });
    })();
  } };
}, ec = function(e) {
  var n = Xl(e);
  return { getHealth: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.getHealth(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["HealthApi.getHealth"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getHealth", value: function(s) {
    var i = this;
    return ec(this.configuration).getHealth(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }]), n;
})(Oe);
var tc = function(e) {
  return { getHorse: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getHorse", "id", n), i = "/horse/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listHorses: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/horse", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  } };
}, oi = function(e) {
  var n = tc(e);
  return { getHorse: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getHorse(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["HorsesApi.getHorse"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listHorses: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listHorses(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["HorsesApi.listHorses"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getHorse", value: function(s, i) {
    var t = this;
    return oi(this.configuration).getHorse(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listHorses", value: function(s) {
    var i = this;
    return oi(this.configuration).listHorses(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }]), n;
})(Oe);
var nc = function(e) {
  return { getInstanceConfig: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getInstanceConfig", "instanceId", n), i = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listInstances: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/instance", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, postInstanceStatus: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("postInstanceStatus", "instanceId", n), y("postInstanceStatus", "postInstanceStatusRequest", s), t = "/instance/{instanceId}/status".replace("{instanceId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, putInstanceConfig: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("putInstanceConfig", "instanceId", n), y("putInstanceConfig", "putInstanceConfigRequest", s), t = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, zn = function(e) {
  var n = nc(e);
  return { getInstanceConfig: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getInstanceConfig(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["InstanceApi.getInstanceConfig"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listInstances: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listInstances(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["InstanceApi.listInstances"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, postInstanceStatus: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.postInstanceStatus(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["InstanceApi.postInstanceStatus"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, putInstanceConfig: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.putInstanceConfig(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["InstanceApi.putInstanceConfig"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getInstanceConfig", value: function(s, i) {
    var t = this;
    return zn(this.configuration).getInstanceConfig(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listInstances", value: function(s) {
    var i = this;
    return zn(this.configuration).listInstances(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "postInstanceStatus", value: function(s, i, t) {
    var r = this;
    return zn(this.configuration).postInstanceStatus(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "putInstanceConfig", value: function(s, i, t) {
    var r = this;
    return zn(this.configuration).putInstanceConfig(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var rc = function(e) {
  return { createCompositeJudgeMap: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("createCompositeJudgeMap", "createCompositeJudgeMapRequest", n), i = new URL("/composite-judge-map", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteCompositeJudgeMap", "id", n), i = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, deleteJudgeSignature: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteJudgeSignature", "id", n), i = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getCompositeJudgeMap", "id", n), i = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("listCompositeJudgeMaps", "showId", n), i = new URL("/composite-judge-map", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.showId = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, listJudges: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("listJudges", "showId", n), i = new URL("/judge", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.showId = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, putJudgeSignature: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("putJudgeSignature", "id", n), y("putJudgeSignature", "putJudgeSignatureRequest", s), t = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, resolveJudgeComposite: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("resolveJudgeComposite", "id", n), i = "/judge/{id}/resolve".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("updateCompositeJudgeMap", "id", n), t = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, pt = function(e) {
  var n = rc(e);
  return { createCompositeJudgeMap: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createCompositeJudgeMap(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.createCompositeJudgeMap"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteCompositeJudgeMap(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.deleteCompositeJudgeMap"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteJudgeSignature: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteJudgeSignature(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.deleteJudgeSignature"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getCompositeJudgeMap(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.getCompositeJudgeMap"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listCompositeJudgeMaps(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.listCompositeJudgeMaps"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listJudges: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listJudges(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.listJudges"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.putJudgeSignature(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["JudgesApi.putJudgeSignature"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, resolveJudgeComposite: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.resolveJudgeComposite(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["JudgesApi.resolveJudgeComposite"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.updateCompositeJudgeMap(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["JudgesApi.updateCompositeJudgeMap"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "createCompositeJudgeMap", value: function(s, i) {
    var t = this;
    return pt(this.configuration).createCompositeJudgeMap(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteCompositeJudgeMap", value: function(s, i) {
    var t = this;
    return pt(this.configuration).deleteCompositeJudgeMap(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteJudgeSignature", value: function(s, i) {
    var t = this;
    return pt(this.configuration).deleteJudgeSignature(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getCompositeJudgeMap", value: function(s, i) {
    var t = this;
    return pt(this.configuration).getCompositeJudgeMap(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listCompositeJudgeMaps", value: function(s, i) {
    var t = this;
    return pt(this.configuration).listCompositeJudgeMaps(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listJudges", value: function(s, i) {
    var t = this;
    return pt(this.configuration).listJudges(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(s, i, t) {
    var r = this;
    return pt(this.configuration).putJudgeSignature(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "resolveJudgeComposite", value: function(s, i) {
    var t = this;
    return pt(this.configuration).resolveJudgeComposite(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "updateCompositeJudgeMap", value: function(s, i, t) {
    var r = this;
    return pt(this.configuration).updateCompositeJudgeMap(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var sc = function(e) {
  return { createPerson: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/people", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, deletePerson: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deletePerson", "id", n), i = "/people/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getPerson: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getPerson", "id", n), i = "/people/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listPeople: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/people", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.personType = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, updatePerson: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("updatePerson", "id", n), t = "/people/{id}".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, cn = function(e) {
  var n = sc(e);
  return { createPerson: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createPerson(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["PeopleApi.createPerson"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deletePerson: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deletePerson(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["PeopleApi.deletePerson"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getPerson: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getPerson(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["PeopleApi.getPerson"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listPeople: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listPeople(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["PeopleApi.listPeople"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, updatePerson: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.updatePerson(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["PeopleApi.updatePerson"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "createPerson", value: function(s, i) {
    var t = this;
    return cn(this.configuration).createPerson(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deletePerson", value: function(s, i) {
    var t = this;
    return cn(this.configuration).deletePerson(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getPerson", value: function(s, i) {
    var t = this;
    return cn(this.configuration).getPerson(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listPeople", value: function(s, i) {
    var t = this;
    return cn(this.configuration).listPeople(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "updatePerson", value: function(s, i, t) {
    var r = this;
    return cn(this.configuration).updatePerson(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var ic = function(e) {
  return { listPresence: function(n, s, i) {
    var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("listPresence", "showId", n), r = new URL("/presence", _), e && (a = e.baseOptions), o = p({ method: "GET" }, a, t), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), n !== void 0 && (l.showId = n), s !== void 0 && (l.ring = s), i !== void 0 && (l.classId = i), I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, t.headers), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, postHeartbeat: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("postHeartbeat", "postHeartbeatRequest", n), i = new URL("/presence/heartbeat", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  } };
}, ui = function(e) {
  var n = ic(e);
  return { listPresence: function(s, i, t, r) {
    return v(function() {
      var a, o, u, l, c, d;
      return g(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, n.listPresence(s, i, t, r)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = x["PresenceApi.listPresence"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return C(u, w.default, R, e)(m, d || j);
            }];
        }
      });
    })();
  }, postHeartbeat: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.postHeartbeat(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["PresenceApi.postHeartbeat"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "listPresence", value: function(s, i, t, r) {
    var a = this;
    return ui(this.configuration).listPresence(s, i, t, r).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }, { key: "postHeartbeat", value: function(s, i) {
    var t = this;
    return ui(this.configuration).postHeartbeat(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
})(Oe);
var ac = function(e) {
  return { quarantinePayload: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("quarantinePayload", "quarantinePayloadRequest", n), i = new URL("/quarantine", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  } };
}, oc = function(e) {
  var n = ac(e);
  return { quarantinePayload: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.quarantinePayload(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["QuarantineApi.quarantinePayload"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "quarantinePayload", value: function(s, i) {
    var t = this;
    return oc(this.configuration).quarantinePayload(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
})(Oe);
var uc = function(e) {
  return { getClassResults: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getClassResults", "classId", n), i = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getClassResultsSummary: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getClassResultsSummary", "showId", n), y("getClassResultsSummary", "ring", s), t = new URL("/class-results-summary", _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, i), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), n !== void 0 && (u.showId = n), s !== void 0 && (u.ring = s), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, i.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getRideResult: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getRideResult", "rideId", n), i = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getShowResultsSummary: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("getShowResultsSummary", "showId", n), i = new URL("/show-results-summary", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.showId = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, setClassPlacings: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setClassPlacings", "classId", n), y("setClassPlacings", "setClassPlacingsRequest", s), t = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setRidePlacing: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setRidePlacing", "rideId", n), t = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, Dt = function(e) {
  var n = uc(e);
  return { getClassResults: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getClassResults(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ResultsApi.getClassResults"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getClassResultsSummary: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.getClassResultsSummary(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ResultsApi.getClassResultsSummary"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, getRideResult: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getRideResult(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ResultsApi.getRideResult"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getShowResultsSummary: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getShowResultsSummary(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ResultsApi.getShowResultsSummary"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, setClassPlacings: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setClassPlacings(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ResultsApi.setClassPlacings"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setRidePlacing: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setRidePlacing(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ResultsApi.setRidePlacing"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getClassResults", value: function(s, i) {
    var t = this;
    return Dt(this.configuration).getClassResults(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getClassResultsSummary", value: function(s, i, t) {
    var r = this;
    return Dt(this.configuration).getClassResultsSummary(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "getRideResult", value: function(s, i) {
    var t = this;
    return Dt(this.configuration).getRideResult(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getShowResultsSummary", value: function(s, i) {
    var t = this;
    return Dt(this.configuration).getShowResultsSummary(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "setClassPlacings", value: function(s, i, t) {
    var r = this;
    return Dt(this.configuration).setClassPlacings(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setRidePlacing", value: function(s, i, t) {
    var r = this;
    return Dt(this.configuration).setRidePlacing(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var lc = function(e) {
  return { listReviewQueue: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/review-queue", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, resolveReviewItem: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("resolveReviewItem", "itemId", n), y("resolveReviewItem", "resolveReviewItemRequest", s), t = "/review-queue/{itemId}/resolve".replace("{itemId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, li = function(e) {
  var n = lc(e);
  return { listReviewQueue: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listReviewQueue(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["ReviewQueueApi.listReviewQueue"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, resolveReviewItem: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.resolveReviewItem(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ReviewQueueApi.resolveReviewItem"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "listReviewQueue", value: function(s) {
    var i = this;
    return li(this.configuration).listReviewQueue(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "resolveReviewItem", value: function(s, i, t) {
    var r = this;
    return li(this.configuration).resolveReviewItem(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var cc = function(e) {
  return { addRideMovement: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("addRideMovement", "rideId", n), t = "/ride/{rideId}/movements".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, batchRideStatus: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("batchRideStatus", "batchRideStatusRequest", n), i = new URL("/rides/status", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, createRide: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/ride", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, createRideUtilityEvent: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("createRideUtilityEvent", "rideId", n), y("createRideUtilityEvent", "createRideUtilityEventRequest", s), t = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("deleteRideUtilityEvent", "rideId", n), y("deleteRideUtilityEvent", "eventId", s), t = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(n))).replace("{eventId}", encodeURIComponent(String(s))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "DELETE" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, fillChampionshipSlot: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("fillChampionshipSlot", "rideId", n), y("fillChampionshipSlot", "fillChampionshipSlotRequest", s), t = "/ride/{rideId}/championship-slot".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, getRide: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getRide", "rideId", n), i = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getRideExcused: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getRideExcused", "rideId", n), i = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getRideNoShow: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getRideNoShow", "rideId", n), i = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listRideUtilityEvents: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("listRideUtilityEvents", "rideId", n), i = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listRides: function(n, s, i, t, r, a, o, u, l) {
    var c = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : {};
    return v(function() {
      var d, h, m, j, S, F;
      return g(this, function(q) {
        switch (q.label) {
          case 0:
            return d = new URL("/ride", _), e && (h = e.baseOptions), m = p({ method: "GET" }, h, c), S = {}, [4, O(j = {}, e)];
          case 1:
            return q.sent(), n !== void 0 && (S.classId = n), s !== void 0 && (S.showId = s), i !== void 0 && (S.day = i), t !== void 0 && (S.ring = t), r !== void 0 && (S.needsReview = r), a !== void 0 && (S.riderId = a), o !== void 0 && (S.horseId = o), u !== void 0 && (S.fvdPushStatus = u), l !== void 0 && (S.unscheduled = l), I(d, S), F = h && h.headers ? h.headers : {}, m.headers = p({}, j, F, c.headers), [2, { url: T(d), options: m }];
        }
      });
    })();
  }, markRideExcused: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("markRideExcused", "rideId", n), i = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "POST" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, markRideNoShow: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("markRideNoShow", "rideId", n), i = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "POST" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, removeRideMovement: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("removeRideMovement", "rideId", n), y("removeRideMovement", "movementNumber", s), t = "/ride/{rideId}/movements/{movementNumber}".replace("{rideId}", encodeURIComponent(String(n))).replace("{movementNumber}", encodeURIComponent(String(s))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "DELETE" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, repointRide: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("repointRide", "rideId", n), y("repointRide", "repointRideRequest", s), t = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, reportFvdPushStatus: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("reportFvdPushStatus", "reportFvdPushStatusRequest", n), i = new URL("/rides/fvd-push-status", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, resolveManualRide: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("resolveManualRide", "rideId", n), y("resolveManualRide", "resolveManualRideRequest", s), t = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setRideStatus: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setRideStatus", "rideId", n), y("setRideStatus", "setRideStatusRequest", s), t = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, undoRideExcused: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("undoRideExcused", "rideId", n), i = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, undoRideNoShow: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("undoRideNoShow", "rideId", n), i = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  } };
}, Ne = function(e) {
  var n = cc(e);
  return { addRideMovement: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.addRideMovement(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.addRideMovement"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, batchRideStatus: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.batchRideStatus(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.batchRideStatus"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, createRide: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createRide(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.createRide"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.createRideUtilityEvent(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.createRideUtilityEvent"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.deleteRideUtilityEvent(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.deleteRideUtilityEvent"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, fillChampionshipSlot: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.fillChampionshipSlot(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.fillChampionshipSlot"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, getRide: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getRide(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.getRide"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRideExcused: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getRideExcused(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.getRideExcused"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRideNoShow: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getRideNoShow(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.getRideNoShow"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listRideUtilityEvents(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.listRideUtilityEvents"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listRides: function(s, i, t, r, a, o, u, l, c, d) {
    return v(function() {
      var h, m, j, S, F, q;
      return g(this, function(B) {
        switch (B.label) {
          case 0:
            return [4, n.listRides(s, i, t, r, a, o, u, l, c, d)];
          case 1:
            return j = B.sent(), F = (S = e == null ? void 0 : e.serverIndex) !== null && S !== void 0 ? S : 0, q = (m = x["RidesApi.listRides"]) === null || m === void 0 || (h = m[F]) === null || h === void 0 ? void 0 : h.url, [2, function(be, ee) {
              return C(j, w.default, R, e)(be, q || ee);
            }];
        }
      });
    })();
  }, markRideExcused: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.markRideExcused(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.markRideExcused"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, markRideNoShow: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.markRideNoShow(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.markRideNoShow"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, removeRideMovement: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.removeRideMovement(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.removeRideMovement"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, repointRide: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.repointRide(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.repointRide"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, reportFvdPushStatus: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.reportFvdPushStatus(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.reportFvdPushStatus"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, resolveManualRide: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.resolveManualRide(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.resolveManualRide"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setRideStatus: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setRideStatus(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RidesApi.setRideStatus"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, undoRideExcused: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.undoRideExcused(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.undoRideExcused"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, undoRideNoShow: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.undoRideNoShow(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RidesApi.undoRideNoShow"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "addRideMovement", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).addRideMovement(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "batchRideStatus", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).batchRideStatus(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "createRide", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).createRide(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).createRideUtilityEvent(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).deleteRideUtilityEvent(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "fillChampionshipSlot", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).fillChampionshipSlot(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "getRide", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).getRide(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getRideExcused", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).getRideExcused(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getRideNoShow", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).getRideNoShow(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).listRideUtilityEvents(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listRides", value: function(s, i, t, r, a, o, u, l, c, d) {
    var h = this;
    return Ne(this.configuration).listRides(s, i, t, r, a, o, u, l, c, d).then(function(m) {
      return m(h.axios, h.basePath);
    });
  } }, { key: "markRideExcused", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).markRideExcused(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "markRideNoShow", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).markRideNoShow(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "removeRideMovement", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).removeRideMovement(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "repointRide", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).repointRide(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "reportFvdPushStatus", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).reportFvdPushStatus(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "resolveManualRide", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).resolveManualRide(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setRideStatus", value: function(s, i, t) {
    var r = this;
    return Ne(this.configuration).setRideStatus(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "undoRideExcused", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).undoRideExcused(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "undoRideNoShow", value: function(s, i) {
    var t = this;
    return Ne(this.configuration).undoRideNoShow(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
})(Oe);
var dc = function(e) {
  return { clearRingState: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("clearRingState", "showId", n), y("clearRingState", "ring", s), t = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(s))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "DELETE" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), n !== void 0 && (l.showId = n), I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, getRingState: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("getRingState", "showId", n), y("getRingState", "ring", s), t = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(s))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "GET" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), n !== void 0 && (l.showId = n), I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, listRingStates: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("listRingStates", "showId", n), i = new URL("/ring-state", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.showId = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, setRingState: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("setRingState", "setRingStateRequest", n), i = new URL("/ring-state", _), e && (t = e.baseOptions), r = p({ method: "PUT" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  } };
}, $n = function(e) {
  var n = dc(e);
  return { clearRingState: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.clearRingState(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RingStateApi.clearRingState"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, getRingState: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.getRingState(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["RingStateApi.getRingState"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, listRingStates: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listRingStates(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RingStateApi.listRingStates"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, setRingState: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.setRingState(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["RingStateApi.setRingState"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "clearRingState", value: function(s, i, t) {
    var r = this;
    return $n(this.configuration).clearRingState(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "getRingState", value: function(s, i, t) {
    var r = this;
    return $n(this.configuration).getRingState(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "listRingStates", value: function(s, i) {
    var t = this;
    return $n(this.configuration).listRingStates(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "setRingState", value: function(s, i) {
    var t = this;
    return $n(this.configuration).setRingState(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }]), n;
})(Oe);
var hc = function(e) {
  return { addScoreSheetAnnotation: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("addScoreSheetAnnotation", "id", n), y("addScoreSheetAnnotation", "addScoreSheetAnnotationRequest", s), t = "/scoresheet/{id}/annotations".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("commitScoreSheetEdit", "id", n), y("commitScoreSheetEdit", "commitScoreSheetEditRequest", s), t = "/scoresheet/{id}/commit".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, completeScoreSheet: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("completeScoreSheet", "id", n), i = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "POST" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("confirmScoreSheetMarks", "id", n), i = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "POST" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, createScoreSheet: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoresheet", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("discardScoreSheetDraft", "id", n), i = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getRideAuditTrail: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getRideAuditTrail", "rideId", n), i = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getScoreSheet: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getScoreSheet", "id", n), i = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getScoreSheetAuditTrail", "id", n), i = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getScoreSheetDraft: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getScoreSheetDraft", "id", n), i = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getScoreSheetSignature: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getScoreSheetSignature", "id", n), i = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listScoreSheets: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return t = new URL("/scoresheet", _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, i), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), n !== void 0 && (u.rideId = n), s !== void 0 && (u.judgeId = s), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, i.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("listScoreSheetsForRides", "listScoreSheetsForRidesRequest", n), i = new URL("/scoresheet/batch", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, putScoreSheetDraft: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("putScoreSheetDraft", "id", n), t = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, resolveStaleWriteConflict: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("resolveStaleWriteConflict", "id", n), y("resolveStaleWriteConflict", "resolveStaleWriteConflictRequest", s), t = "/scoresheet/{id}/resolve-stale-write-conflict".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, restoreScoreSheetVersion: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("restoreScoreSheetVersion", "id", n), y("restoreScoreSheetVersion", "restoreScoreSheetVersionRequest", s), t = "/scoresheet/{id}/restore".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, signScoreSheetPanel: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("signScoreSheetPanel", "id", n), y("signScoreSheetPanel", "signScoreSheetPanelRequest", s), t = "/scoresheet/{id}/panel-signature".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, switchAuthoritativeScoreSheet: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("switchAuthoritativeScoreSheet", "id", n), i = "/scoresheet/{id}/switch-authoritative".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "POST" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, unlockScoreSheet: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("unlockScoreSheet", "id", n), y("unlockScoreSheet", "unlockScoreSheetRequest", s), t = "/scoresheet/{id}/unlock".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, updateScoreSheet: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("updateScoreSheet", "id", n), t = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, Le = function(e) {
  var n = hc(e);
  return { addScoreSheetAnnotation: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.addScoreSheetAnnotation(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.addScoreSheetAnnotation"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.commitScoreSheetEdit(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.commitScoreSheetEdit"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, completeScoreSheet: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.completeScoreSheet(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.completeScoreSheet"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.confirmScoreSheetMarks(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, createScoreSheet: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createScoreSheet(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.createScoreSheet"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.discardScoreSheetDraft(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.discardScoreSheetDraft"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getRideAuditTrail(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.getRideAuditTrail"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheet: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getScoreSheet(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.getScoreSheet"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getScoreSheetAuditTrail(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetDraft: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getScoreSheetDraft(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.getScoreSheetDraft"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getScoreSheetSignature(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.getScoreSheetSignature"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listScoreSheets: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.listScoreSheets(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.listScoreSheets"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listScoreSheetsForRides(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.listScoreSheetsForRides"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, putScoreSheetDraft: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.putScoreSheetDraft(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.putScoreSheetDraft"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, resolveStaleWriteConflict: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.resolveStaleWriteConflict(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.resolveStaleWriteConflict"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, restoreScoreSheetVersion: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.restoreScoreSheetVersion(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.restoreScoreSheetVersion"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, signScoreSheetPanel: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.signScoreSheetPanel(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.signScoreSheetPanel"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, switchAuthoritativeScoreSheet: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.switchAuthoritativeScoreSheet(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreSheetsApi.switchAuthoritativeScoreSheet"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, unlockScoreSheet: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.unlockScoreSheet(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.unlockScoreSheet"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.updateScoreSheet(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreSheetsApi.updateScoreSheet"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "addScoreSheetAnnotation", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).addScoreSheetAnnotation(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "commitScoreSheetEdit", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).commitScoreSheetEdit(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "completeScoreSheet", value: function(s, i) {
    var t = this;
    return Le(this.configuration).completeScoreSheet(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(s, i) {
    var t = this;
    return Le(this.configuration).confirmScoreSheetMarks(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "createScoreSheet", value: function(s, i) {
    var t = this;
    return Le(this.configuration).createScoreSheet(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "discardScoreSheetDraft", value: function(s, i) {
    var t = this;
    return Le(this.configuration).discardScoreSheetDraft(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(s, i) {
    var t = this;
    return Le(this.configuration).getRideAuditTrail(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getScoreSheet", value: function(s, i) {
    var t = this;
    return Le(this.configuration).getScoreSheet(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(s, i) {
    var t = this;
    return Le(this.configuration).getScoreSheetAuditTrail(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getScoreSheetDraft", value: function(s, i) {
    var t = this;
    return Le(this.configuration).getScoreSheetDraft(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(s, i) {
    var t = this;
    return Le(this.configuration).getScoreSheetSignature(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listScoreSheets", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).listScoreSheets(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "listScoreSheetsForRides", value: function(s, i) {
    var t = this;
    return Le(this.configuration).listScoreSheetsForRides(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "putScoreSheetDraft", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).putScoreSheetDraft(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "resolveStaleWriteConflict", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).resolveStaleWriteConflict(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "restoreScoreSheetVersion", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).restoreScoreSheetVersion(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "signScoreSheetPanel", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).signScoreSheetPanel(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "switchAuthoritativeScoreSheet", value: function(s, i) {
    var t = this;
    return Le(this.configuration).switchAuthoritativeScoreSheet(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "unlockScoreSheet", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).unlockScoreSheet(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(s, i, t) {
    var r = this;
    return Le(this.configuration).updateScoreSheet(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var fc = function(e) {
  return { createBrandAsset: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("createBrandAsset", "createBrandAssetRequest", n), i = new URL("/scoreboard/asset", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, createScoreboardView: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoreboard/view", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, deleteBrandAsset: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteBrandAsset", "id", n), i = "/scoreboard/asset/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteScoreboardTheme", "id", n), i = "/scoreboard/theme/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, deleteScoreboardView: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteScoreboardView", "id", n), i = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, deleteSponsor: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteSponsor", "id", n), i = "/scoreboard/sponsor/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getPublicClassResults: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        return y("getPublicClassResults", "showId", n), y("getPublicClassResults", "classId", s), t = "/public/scoreboard/{showId}/class/{classId}/results".replace("{showId}", encodeURIComponent(String(n))).replace("{classId}", encodeURIComponent(String(s))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "GET" }, a, i), u = {}, I(r, {}), l = a && a.headers ? a.headers : {}, o.headers = p({}, u, l, i.headers), [2, { url: T(r), options: o }];
      });
    })();
  }, getPublicScoreboard: function(n, s, i) {
    var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        return y("getPublicScoreboard", "showId", n), y("getPublicScoreboard", "year", s), y("getPublicScoreboard", "slug", i), r = "/public/scoreboard/{showId}/{year}/{slug}?".replace("{showId}", encodeURIComponent(String(n))).replace("{year}", encodeURIComponent(String(s))).replace("{slug}", encodeURIComponent(String(i))), a = new URL(r, _), e && (o = e.baseOptions), u = p({ method: "GET" }, o, t), l = {}, I(a, {}), c = o && o.headers ? o.headers : {}, u.headers = p({}, l, c, t.headers), [2, { url: T(a), options: u }];
      });
    })();
  }, listBrandAssets: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/scoreboard/assets", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, listScoreboardThemes: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/scoreboard/themes", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, listScoreboardViews: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return y("listScoreboardViews", "showId", n), i = new URL("/scoreboard/views", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.showId = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, listSponsors: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/scoreboard/sponsors", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, putScoreboardTheme: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoreboard/theme", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, putSponsor: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/scoreboard/sponsor", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, resolveClassByNumber: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        return y("resolveClassByNumber", "showId", n), y("resolveClassByNumber", "classNumber", s), t = "/public/scoreboard/{showId}/class-number/{classNumber}".replace("{showId}", encodeURIComponent(String(n))).replace("{classNumber}", encodeURIComponent(String(s))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "GET" }, a, i), u = {}, I(r, {}), l = a && a.headers ? a.headers : {}, o.headers = p({}, u, l, i.headers), [2, { url: T(r), options: o }];
      });
    })();
  }, setScoreboardViewCurrentMode: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setScoreboardViewCurrentMode", "id", n), t = "/scoreboard/view/{id}/current-mode".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "POST" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, updateScoreboardView: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("updateScoreboardView", "id", n), t = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PATCH" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, ze = function(e) {
  var n = fc(e);
  return { createBrandAsset: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createBrandAsset(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.createBrandAsset"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, createScoreboardView: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createScoreboardView(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.createScoreboardView"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteBrandAsset: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteBrandAsset(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.deleteBrandAsset"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteScoreboardTheme(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.deleteScoreboardTheme"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteScoreboardView: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteScoreboardView(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.deleteScoreboardView"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteSponsor: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteSponsor(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.deleteSponsor"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicClassResults: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.getPublicClassResults(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreboardApi.getPublicClassResults"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, getPublicScoreboard: function(s, i, t, r) {
    return v(function() {
      var a, o, u, l, c, d;
      return g(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, n.getPublicScoreboard(s, i, t, r)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = x["ScoreboardApi.getPublicScoreboard"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return C(u, w.default, R, e)(m, d || j);
            }];
        }
      });
    })();
  }, listBrandAssets: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listBrandAssets(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["ScoreboardApi.listBrandAssets"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, listScoreboardThemes: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listScoreboardThemes(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["ScoreboardApi.listScoreboardThemes"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, listScoreboardViews: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listScoreboardViews(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.listScoreboardViews"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listSponsors: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listSponsors(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["ScoreboardApi.listSponsors"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, putScoreboardTheme: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.putScoreboardTheme(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.putScoreboardTheme"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, putSponsor: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.putSponsor(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ScoreboardApi.putSponsor"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, resolveClassByNumber: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.resolveClassByNumber(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreboardApi.resolveClassByNumber"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setScoreboardViewCurrentMode: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setScoreboardViewCurrentMode(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreboardApi.setScoreboardViewCurrentMode"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, updateScoreboardView: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.updateScoreboardView(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ScoreboardApi.updateScoreboardView"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "createBrandAsset", value: function(s, i) {
    var t = this;
    return ze(this.configuration).createBrandAsset(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "createScoreboardView", value: function(s, i) {
    var t = this;
    return ze(this.configuration).createScoreboardView(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteBrandAsset", value: function(s, i) {
    var t = this;
    return ze(this.configuration).deleteBrandAsset(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteScoreboardTheme", value: function(s, i) {
    var t = this;
    return ze(this.configuration).deleteScoreboardTheme(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteScoreboardView", value: function(s, i) {
    var t = this;
    return ze(this.configuration).deleteScoreboardView(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteSponsor", value: function(s, i) {
    var t = this;
    return ze(this.configuration).deleteSponsor(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getPublicClassResults", value: function(s, i, t) {
    var r = this;
    return ze(this.configuration).getPublicClassResults(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "getPublicScoreboard", value: function(s, i, t, r) {
    var a = this;
    return ze(this.configuration).getPublicScoreboard(s, i, t, r).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }, { key: "listBrandAssets", value: function(s) {
    var i = this;
    return ze(this.configuration).listBrandAssets(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "listScoreboardThemes", value: function(s) {
    var i = this;
    return ze(this.configuration).listScoreboardThemes(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "listScoreboardViews", value: function(s, i) {
    var t = this;
    return ze(this.configuration).listScoreboardViews(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listSponsors", value: function(s) {
    var i = this;
    return ze(this.configuration).listSponsors(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "putScoreboardTheme", value: function(s, i) {
    var t = this;
    return ze(this.configuration).putScoreboardTheme(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "putSponsor", value: function(s, i) {
    var t = this;
    return ze(this.configuration).putSponsor(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "resolveClassByNumber", value: function(s, i, t) {
    var r = this;
    return ze(this.configuration).resolveClassByNumber(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setScoreboardViewCurrentMode", value: function(s, i, t) {
    var r = this;
    return ze(this.configuration).setScoreboardViewCurrentMode(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "updateScoreboardView", value: function(s, i, t) {
    var r = this;
    return ze(this.configuration).updateScoreboardView(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var pc = function(e) {
  return { getShow: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getShow", "id", n), i = "/show/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listShows: function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var s, i, t, r, a, o;
      return g(this, function(u) {
        switch (u.label) {
          case 0:
            return s = new URL("/show", _), e && (i = e.baseOptions), t = p({ method: "GET" }, i, n), a = {}, [4, O(r = {}, e)];
          case 1:
            return u.sent(), I(s, a), o = i && i.headers ? i.headers : {}, t.headers = p({}, r, o, n.headers), [2, { url: T(s), options: t }];
        }
      });
    })();
  }, setShowDefaultPlacingView: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setShowDefaultPlacingView", "id", n), t = "/show/{id}/default-placing-view".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setShowFriendlyName: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setShowFriendlyName", "id", n), y("setShowFriendlyName", "setShowFriendlyNameRequest", s), t = "/show/{id}/friendly-name".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setShowLogo: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setShowLogo", "id", n), t = "/show/{id}/logo".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setShowNoFoxbox: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setShowNoFoxbox", "id", n), y("setShowNoFoxbox", "setShowNoFoxboxRequest", s), t = "/show/{id}/no-foxbox".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setShowScribeUnlockPin", "id", n), t = "/show/{id}/scribe-unlock-pin".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  }, setShowVenueTimezone: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("setShowVenueTimezone", "id", n), t = "/show/{id}/venue-timezone".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, St = function(e) {
  var n = pc(e);
  return { getShow: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getShow(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["ShowsApi.getShow"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listShows: function(s) {
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, n.listShows(s)];
          case 1:
            return r = l.sent(), o = (a = e == null ? void 0 : e.serverIndex) !== null && a !== void 0 ? a : 0, u = (t = x["ShowsApi.listShows"]) === null || t === void 0 || (i = t[o]) === null || i === void 0 ? void 0 : i.url, [2, function(c, d) {
              return C(r, w.default, R, e)(c, u || d);
            }];
        }
      });
    })();
  }, setShowDefaultPlacingView: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setShowDefaultPlacingView(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ShowsApi.setShowDefaultPlacingView"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowFriendlyName: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setShowFriendlyName(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ShowsApi.setShowFriendlyName"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowLogo: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setShowLogo(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ShowsApi.setShowLogo"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowNoFoxbox: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setShowNoFoxbox(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ShowsApi.setShowNoFoxbox"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setShowScribeUnlockPin(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ShowsApi.setShowScribeUnlockPin"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  }, setShowVenueTimezone: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.setShowVenueTimezone(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["ShowsApi.setShowVenueTimezone"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "getShow", value: function(s, i) {
    var t = this;
    return St(this.configuration).getShow(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listShows", value: function(s) {
    var i = this;
    return St(this.configuration).listShows(s).then(function(t) {
      return t(i.axios, i.basePath);
    });
  } }, { key: "setShowDefaultPlacingView", value: function(s, i, t) {
    var r = this;
    return St(this.configuration).setShowDefaultPlacingView(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setShowFriendlyName", value: function(s, i, t) {
    var r = this;
    return St(this.configuration).setShowFriendlyName(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setShowLogo", value: function(s, i, t) {
    var r = this;
    return St(this.configuration).setShowLogo(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setShowNoFoxbox", value: function(s, i, t) {
    var r = this;
    return St(this.configuration).setShowNoFoxbox(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setShowScribeUnlockPin", value: function(s, i, t) {
    var r = this;
    return St(this.configuration).setShowScribeUnlockPin(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }, { key: "setShowVenueTimezone", value: function(s, i, t) {
    var r = this;
    return St(this.configuration).setShowVenueTimezone(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
var vc = function(e) {
  return { listStationSnapshots: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("listStationSnapshots", "showId", n), i = "/show/{showId}/station-snapshot".replace("{showId}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, markStationReconcileReviewed: function(n, s, i, t) {
    var r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    return v(function() {
      var a, o, u, l, c, d, h;
      return g(this, function(m) {
        switch (m.label) {
          case 0:
            return y("markStationReconcileReviewed", "showId", n), y("markStationReconcileReviewed", "deviceId", s), y("markStationReconcileReviewed", "scribeSub", i), y("markStationReconcileReviewed", "markStationReconcileReviewedRequest", t), a = "/show/{showId}/station-snapshot/{deviceId}/{scribeSub}/reconcile/review".replace("{showId}", encodeURIComponent(String(n))).replace("{deviceId}", encodeURIComponent(String(s))).replace("{scribeSub}", encodeURIComponent(String(i))), o = new URL(a, _), e && (u = e.baseOptions), l = p({ method: "POST" }, u, r), d = {}, [4, O(c = {}, e)];
          case 1:
            return m.sent(), c["Content-Type"] = "application/json", I(o, d), h = u && u.headers ? u.headers : {}, l.headers = p({}, c, h, r.headers), l.data = M(t, l, e), [2, { url: T(o), options: l }];
        }
      });
    })();
  }, postStationSnapshot: function(n, s, i) {
    var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var r, a, o, u, l, c, d;
      return g(this, function(h) {
        switch (h.label) {
          case 0:
            return y("postStationSnapshot", "showId", n), y("postStationSnapshot", "deviceId", s), r = "/show/{showId}/station-snapshot/{deviceId}".replace("{showId}", encodeURIComponent(String(n))).replace("{deviceId}", encodeURIComponent(String(s))), a = new URL(r, _), e && (o = e.baseOptions), u = p({ method: "POST" }, o, t), c = {}, [4, O(l = {}, e)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", I(a, c), d = o && o.headers ? o.headers : {}, u.headers = p({}, l, d, t.headers), u.data = M(i, u, e), [2, { url: T(a), options: u }];
        }
      });
    })();
  }, reconcileStation: function(n, s, i) {
    var t = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var r, a, o, u, l, c, d;
      return g(this, function(h) {
        switch (h.label) {
          case 0:
            return y("reconcileStation", "showId", n), y("reconcileStation", "deviceId", s), y("reconcileStation", "scribeSub", i), r = "/show/{showId}/station-snapshot/{deviceId}/{scribeSub}/reconcile".replace("{showId}", encodeURIComponent(String(n))).replace("{deviceId}", encodeURIComponent(String(s))).replace("{scribeSub}", encodeURIComponent(String(i))), a = new URL(r, _), e && (o = e.baseOptions), u = p({ method: "POST" }, o, t), c = {}, [4, O(l = {}, e)];
          case 1:
            return h.sent(), I(a, c), d = o && o.headers ? o.headers : {}, u.headers = p({}, l, d, t.headers), [2, { url: T(a), options: u }];
        }
      });
    })();
  } };
}, Bn = function(e) {
  var n = vc(e);
  return { listStationSnapshots: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listStationSnapshots(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["StationSnapshotApi.listStationSnapshots"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, markStationReconcileReviewed: function(s, i, t, r, a) {
    return v(function() {
      var o, u, l, c, d, h;
      return g(this, function(m) {
        switch (m.label) {
          case 0:
            return [4, n.markStationReconcileReviewed(s, i, t, r, a)];
          case 1:
            return l = m.sent(), d = (c = e == null ? void 0 : e.serverIndex) !== null && c !== void 0 ? c : 0, h = (u = x["StationSnapshotApi.markStationReconcileReviewed"]) === null || u === void 0 || (o = u[d]) === null || o === void 0 ? void 0 : o.url, [2, function(j, S) {
              return C(l, w.default, R, e)(j, h || S);
            }];
        }
      });
    })();
  }, postStationSnapshot: function(s, i, t, r) {
    return v(function() {
      var a, o, u, l, c, d;
      return g(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, n.postStationSnapshot(s, i, t, r)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = x["StationSnapshotApi.postStationSnapshot"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return C(u, w.default, R, e)(m, d || j);
            }];
        }
      });
    })();
  }, reconcileStation: function(s, i, t, r) {
    return v(function() {
      var a, o, u, l, c, d;
      return g(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, n.reconcileStation(s, i, t, r)];
          case 1:
            return u = h.sent(), c = (l = e == null ? void 0 : e.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = x["StationSnapshotApi.reconcileStation"]) === null || o === void 0 || (a = o[c]) === null || a === void 0 ? void 0 : a.url, [2, function(m, j) {
              return C(u, w.default, R, e)(m, d || j);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "listStationSnapshots", value: function(s, i) {
    var t = this;
    return Bn(this.configuration).listStationSnapshots(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "markStationReconcileReviewed", value: function(s, i, t, r, a) {
    var o = this;
    return Bn(this.configuration).markStationReconcileReviewed(s, i, t, r, a).then(function(u) {
      return u(o.axios, o.basePath);
    });
  } }, { key: "postStationSnapshot", value: function(s, i, t, r) {
    var a = this;
    return Bn(this.configuration).postStationSnapshot(s, i, t, r).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }, { key: "reconcileStation", value: function(s, i, t, r) {
    var a = this;
    return Bn(this.configuration).reconcileStation(s, i, t, r).then(function(o) {
      return o(a.axios, a.basePath);
    });
  } }]), n;
})(Oe);
var gc = function(e) {
  return { createTest: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/test", _), e && (t = e.baseOptions), r = p({ method: "POST" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), a["Content-Type"] = "application/json", I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), r.data = M(n, r, e), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, deleteTest: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("deleteTest", "id", n), i = "/test/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "DELETE" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, getTest: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return y("getTest", "id", n), i = "/test/{id}".replace("{id}", encodeURIComponent(String(n))), t = new URL(i, _), e && (r = e.baseOptions), a = p({ method: "GET" }, r, s), u = {}, [4, O(o = {}, e)];
          case 1:
            return c.sent(), I(t, u), l = r && r.headers ? r.headers : {}, a.headers = p({}, o, l, s.headers), [2, { url: T(t), options: a }];
        }
      });
    })();
  }, listTests: function(n) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var i, t, r, a, o, u;
      return g(this, function(l) {
        switch (l.label) {
          case 0:
            return i = new URL("/test", _), e && (t = e.baseOptions), r = p({ method: "GET" }, t, s), o = {}, [4, O(a = {}, e)];
          case 1:
            return l.sent(), n !== void 0 && (o.showId = n), I(i, o), u = t && t.headers ? t.headers : {}, r.headers = p({}, a, u, s.headers), [2, { url: T(i), options: r }];
        }
      });
    })();
  }, updateTest: function(n, s) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var t, r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return y("updateTest", "id", n), t = "/test/{id}".replace("{id}", encodeURIComponent(String(n))), r = new URL(t, _), e && (a = e.baseOptions), o = p({ method: "PUT" }, a, i), l = {}, [4, O(u = {}, e)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(r, l), c = a && a.headers ? a.headers : {}, o.headers = p({}, u, c, i.headers), o.data = M(s, o, e), [2, { url: T(r), options: o }];
        }
      });
    })();
  } };
}, dn = function(e) {
  var n = gc(e);
  return { createTest: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.createTest(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["TestsApi.createTest"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, deleteTest: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.deleteTest(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["TestsApi.deleteTest"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, getTest: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.getTest(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["TestsApi.getTest"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, listTests: function(s, i) {
    return v(function() {
      var t, r, a, o, u, l;
      return g(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, n.listTests(s, i)];
          case 1:
            return a = c.sent(), u = (o = e == null ? void 0 : e.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = x["TestsApi.listTests"]) === null || r === void 0 || (t = r[u]) === null || t === void 0 ? void 0 : t.url, [2, function(d, h) {
              return C(a, w.default, R, e)(d, l || h);
            }];
        }
      });
    })();
  }, updateTest: function(s, i, t) {
    return v(function() {
      var r, a, o, u, l, c;
      return g(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, n.updateTest(s, i, t)];
          case 1:
            return o = d.sent(), l = (u = e == null ? void 0 : e.serverIndex) !== null && u !== void 0 ? u : 0, c = (a = x["TestsApi.updateTest"]) === null || a === void 0 || (r = a[l]) === null || r === void 0 ? void 0 : r.url, [2, function(h, m) {
              return C(o, w.default, R, e)(h, c || m);
            }];
        }
      });
    })();
  } };
};
(function(e) {
  function n() {
    return Ae(this, n), ke(this, n, arguments);
  }
  return je(n, e), Pe(n, [{ key: "createTest", value: function(s, i) {
    var t = this;
    return dn(this.configuration).createTest(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "deleteTest", value: function(s, i) {
    var t = this;
    return dn(this.configuration).deleteTest(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "getTest", value: function(s, i) {
    var t = this;
    return dn(this.configuration).getTest(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "listTests", value: function(s, i) {
    var t = this;
    return dn(this.configuration).listTests(s, i).then(function(r) {
      return r(t.axios, t.basePath);
    });
  } }, { key: "updateTest", value: function(s, i, t) {
    var r = this;
    return dn(this.configuration).updateTest(s, i, t).then(function(a) {
      return a(r.axios, r.basePath);
    });
  } }]), n;
})(Oe);
function mc(e, n) {
  for (var s = 0; s < n.length; s++) {
    var i = n[s];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function gt(e, n, s) {
  return n in e ? Object.defineProperty(e, n, { value: s, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = s, e;
}
function ci(e) {
  for (var n = 1; n < arguments.length; n++) {
    var s = arguments[n] != null ? arguments[n] : {}, i = Object.keys(s);
    typeof Object.getOwnPropertySymbols == "function" && (i = i.concat(Object.getOwnPropertySymbols(s).filter(function(t) {
      return Object.getOwnPropertyDescriptor(s, t).enumerable;
    }))), i.forEach(function(t) {
      gt(e, t, s[t]);
    });
  }
  return e;
}
(function() {
  function e() {
    var i, t, r, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, e), gt(this, "apiKey", void 0), gt(this, "username", void 0), gt(this, "password", void 0), gt(this, "accessToken", void 0), gt(this, "basePath", void 0), gt(this, "serverIndex", void 0), gt(this, "baseOptions", void 0), gt(this, "formDataCtor", void 0), this.apiKey = a.apiKey, this.username = a.username, this.password = a.password, this.accessToken = a.accessToken, this.basePath = a.basePath, this.serverIndex = a.serverIndex, this.baseOptions = (t = ci({}, a.baseOptions), r = (r = { headers: ci({}, (i = a.baseOptions) === null || i === void 0 ? void 0 : i.headers) }) != null ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(r)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(r, o));
    }), t), this.formDataCtor = a.formDataCtor;
  }
  var n, s;
  return n = e, (s = [{ key: "isJsonMime", value: function(i) {
    var t = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return i !== null && (t.test(i) || i.toLowerCase() === "application/json-patch+json");
  } }]) && mc(n.prototype, s), e;
})();
const bc = {
  [kt.PENDING]: { color: "default", label: "Scheduled" },
  // #768 — stored pre-sheet, C's "Bell" press (#767). Same "info" color
  // family as IN_PROGRESS (both mean "the horse is at the ring"); the label
  // is what tells entering from actually in progress.
  [kt.ENTERING_RING]: { color: "info", label: "Entering ring" },
  [kt.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [kt.CONFIRMED]: { color: "success", label: "Confirmed" },
  [kt.COMPLETED]: { color: "warning", label: "Scored" },
  [kt.FINAL]: { color: "success", label: "Final" },
  [kt.SCRATCHED]: { color: "error", label: "Scratched" }
}, yc = { color: "default", label: "—" };
function Qd({ status: e, labels: n, size: s = "small", ...i }) {
  const t = bc[e] ?? yc, r = (n == null ? void 0 : n[e]) ?? t.label;
  return /* @__PURE__ */ f.jsx(jr, { size: s, color: t.color, label: r, ...i });
}
function Xd(e, n, { intervalMs: s, enabled: i = !0 } = {}) {
  const [t, r] = J({}), [a, o] = J(!1), [u, l] = J(null), [c, d] = J(null), h = Array.from(new Set((e ?? []).filter(Boolean))), m = h.join(","), j = rt(n);
  j.current = n;
  const S = rt(h);
  S.current = h;
  const F = rt(m), q = i && h.length > 0 && typeof n == "function", B = ut(async () => {
    const be = S.current;
    if (!(!be.length || typeof j.current != "function")) {
      o(!0);
      try {
        const ee = await j.current(be), ue = {};
        for (const de of ee ?? []) ue[de.rideId] = de.status;
        r(ue), l(null), d(/* @__PURE__ */ new Date());
      } catch (ee) {
        l(ee);
      } finally {
        o(!1);
      }
    }
  }, []);
  return xe(() => {
    if (F.current !== m && (F.current = m, d(null)), !h.length) {
      r({});
      return;
    }
    if (!q)
      return;
    if (!s) {
      B();
      return;
    }
    document.visibilityState !== "hidden" && B();
    let be = null;
    const ee = () => {
      document.visibilityState !== "hidden" && be == null && (be = setInterval(B, s));
    }, ue = () => {
      be != null && (clearInterval(be), be = null);
    }, de = () => {
      document.visibilityState === "hidden" ? ue() : (B(), ee());
    };
    return ee(), document.addEventListener("visibilitychange", de), () => {
      ue(), document.removeEventListener("visibilitychange", de);
    };
  }, [m, q, s, B]), { statuses: t, loading: a, error: u, refresh: B, lastUpdated: c };
}
function eh({
  judgeName: e,
  url: n,
  loading: s = !1,
  label: i = "Judge signature",
  ...t
}) {
  return s ? /* @__PURE__ */ f.jsxs(tr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...t, children: [
    /* @__PURE__ */ f.jsx(er, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ f.jsx(er, { variant: "text", width: 140 })
  ] }) : n ? /* @__PURE__ */ f.jsxs(
    tr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...t,
      children: [
        /* @__PURE__ */ f.jsx(bn, { variant: "caption", color: "text.secondary", children: i }),
        /* @__PURE__ */ f.jsx(
          Te,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ f.jsx(
              Te,
              {
                component: "img",
                src: n,
                alt: e || i,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        e && /* @__PURE__ */ f.jsx(
          bn,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: e
          }
        )
      ]
    }
  ) : null;
}
function th(e, n, { enabled: s = !0 } = {}) {
  const [i, t] = J(null), [r, a] = J(!1), [o, u] = J(null), l = rt(n);
  l.current = n;
  const c = s && !!e && typeof n == "function";
  return xe(() => {
    if (!c) {
      t(null);
      return;
    }
    let d = !1;
    return a(!0), u(null), (async () => {
      try {
        const h = await l.current(e);
        d || t(h ?? null);
      } catch (h) {
        d || u(h);
      } finally {
        d || a(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [c, e]), { signature: i, loading: r, error: o };
}
const Sc = '[data-grid-cell="true"]', wc = { "data-grid-cell": "true" };
function nh(e, { selector: n = Sc, getOrderedCells: s } = {}) {
  const i = e.key === "Enter", t = e.key === "Tab";
  if (!i && !t || t && !s) return;
  const r = (s ? s() : Array.from(document.querySelectorAll(n))).filter((l) => l && !l.disabled), a = r.indexOf(e.target);
  if (i && e.preventDefault(), a === -1) return;
  const o = e.shiftKey ? -1 : 1, u = r[a + o];
  u && (t && e.preventDefault(), u.focus());
}
const ts = 64, Rc = 50, xc = 2;
function _c(e) {
  return (e.match(/[0-9]/g) || []).length;
}
function Ic(e) {
  return /^[0-9]*\.?[0-9]*$/.test(e) ? _c(e) <= xc : !1;
}
function Tc(e) {
  return e.endsWith(".") ? e.slice(0, -1) : e;
}
function di({
  value: e,
  onChange: n,
  disabled: s,
  width: i = ts,
  borderless: t = !1,
  inputRef: r,
  onKeyDown: a,
  // #698 — true once this sheet's marks are confirmed (server-side, one-
  // way freeze). Renders the SAME success/green token RideStatusBadge uses
  // for its CONFIRMED status, so a locked-in mark reads as "confirmed", not
  // "broken/disabled".
  locked: o = !1,
  // #712 — granularity this field snaps to on blur (score-common
  // SCORE_STEP/ARTISTIC_SCORE_STEP/TENTH_SCORE_STEP, resolved per mark via
  // scoreStepFor). Defaults to the standard half-point step.
  step: u = cr,
  // #1755 — see the strict-mode doc above.
  strict: l = !1,
  // #1755 — static, already-translated tooltip text shown when `strict`
  // rejects the typed value. Required for `strict` to have
  // any visible effect; harmless (unused) otherwise.
  invalidLabel: c,
  // #1755 — fires with the current invalid boolean whenever it changes.
  // ScoreEntry's coefficient box uses this to turn its OWN border red too,
  // since the box's border replaces this field's outline (borderless) and
  // wouldn't otherwise reflect a rejected value.
  onValidityChange: d,
  // #2623 — stamps GRID_CELL_DATA_ATTR (data-grid-cell="true") on the native
  // input so a caller's Enter-as-Tab handler (common-fe's focusNextGridCell)
  // can find this field by DOM query, matching scribe-fe's class grid.
  // Purely a marker; it has no effect unless the caller also wires
  // `onKeyDown={focusNextGridCell}`. Uses the shared constant rather than a
  // second hardcoded copy of the literal, so the attribute name can't drift
  // from what focusNextGridCell's own GRID_CELL_SELECTOR looks for.
  gridCell: h = !1
}) {
  const [m, j] = J(!1), [S, F] = J(""), [q, B] = J(!1);
  xe(() => {
    d == null || d(q);
  }, [q]);
  const be = m || q ? S : typeof e == "number" ? e.toFixed(1) : "", ee = /* @__PURE__ */ f.jsx(
    $t,
    {
      size: "small",
      value: be,
      type: "text",
      inputRef: r,
      error: q,
      onKeyDown: a,
      inputProps: {
        inputMode: "decimal",
        pattern: "[0-9.]*",
        // #2656 — deliberately NO maxLength here. A native maxLength sits
        // in FRONT of the onChange gate below and TRUNCATES pasted text to
        // fit instead of rejecting it (browsers, and @testing-library/
        // user-event v14, both do this) — with maxLength: 3, pasting
        // "10.5" truncated to "10." (passes the digit gate, silently
        // stores 10.0) and "78.5" truncated to "78." (silently stores
        // 7.8/8.0). That is exactly the silent coercion this card exists
        // to prevent. Without it, a paste arrives whole at onChange, hits
        // isTypeableScoreDraft's real digit-count check, and is refused
        // cleanly instead of mangled. The onChange gate is the single
        // source of truth for what this field accepts.
        // #2623 — see the `gridCell` doc above.
        ...h && wc,
        // #221 — all number entry uses the same monospace typography as
        // the coefficient box (700, 0.875rem, centered) so every score
        // field reads consistently. The borderless in-box variant just
        // tightens its padding.
        style: {
          textAlign: "center",
          fontFamily: "monospace",
          fontWeight: 700,
          fontSize: "0.875rem",
          ...t && { padding: "4px 2px" }
        }
      },
      sx: (ue) => ({
        width: i,
        // #221 — borderless variant sits inside the coefficient box, so
        // it drops its own outline (the box provides the border).
        ...t && {
          "& .MuiOutlinedInput-notchedOutline": { border: "none" }
        },
        // #698 — locked (confirmed) numeric entry renders green, not the
        // washed-out default disabled grey.
        ...o && {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: ue.palette.success.main
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: ue.palette.success.main,
            color: ue.palette.success.main
          }
        }
      }),
      disabled: s,
      onFocus: (ue) => {
        F(typeof e == "number" ? String(e) : ""), B(!1), j(!0), ue.target.select();
      },
      onBlur: () => {
        const ue = Tc(S);
        if (l) {
          if (ue === "") {
            if (S === "") {
              B(!1), j(!1), e !== void 0 && n(void 0);
              return;
            }
            B(!1), j(!1);
            return;
          }
          const W = Ki(ue);
          if (W === null || W < al || W > Bt) {
            B(!0), j(!1);
            return;
          }
          B(!1);
          const Fe = Yi(W, u);
          Fe !== e && n(Fe), j(!1);
          return;
        }
        const de = ll(ue, u);
        de === null ? S === "" && e !== void 0 && n(void 0) : de !== e && n(de), j(!1);
      },
      onChange: (ue) => {
        const de = ue.target.value;
        Ic(de) && (F(de), q && B(!1));
      }
    }
  );
  return /* @__PURE__ */ f.jsx(
    Wa,
    {
      title: q ? c ?? "" : "",
      open: !!(q && c),
      arrow: !0,
      placement: "top",
      children: ee
    }
  );
}
function rh({
  value: e,
  onChange: n,
  disabled: s,
  coefficient: i = 1,
  inputRef: t,
  onKeyDown: r,
  // #698 — see ScoreInput's `locked` doc above; threaded through unchanged.
  locked: a = !1,
  // #712 — see ScoreInput's `step` doc above; threaded through unchanged.
  step: o = cr,
  // #1755 — see ScoreInput's `strict`/`invalidLabel` doc above; threaded
  // through unchanged.
  strict: u = !1,
  invalidLabel: l,
  // #1755 continuation — save-gating (driver decision, card comment):
  // fires with the current invalid boolean whenever it changes, so
  // RideEditor can disable Save/Commit while any score cell is in error
  // instead of silently committing the last-known-good value under a
  // visibly-errored field.
  onValidityChange: c,
  // #2623 — see ScoreInput's `gridCell` doc above; threaded through unchanged.
  gridCell: d = !1
}) {
  const [h, m] = J(!1), j = (S) => {
    m(S), c == null || c(S);
  };
  return i && i !== 1 ? /* @__PURE__ */ f.jsxs(
    ae,
    {
      "data-testid": "coefficient-entry",
      onClick: s ? void 0 : (S) => {
        var F;
        return (F = S.currentTarget.querySelector("input")) == null ? void 0 : F.focus();
      },
      sx: (S) => ({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: ts,
        height: 40,
        px: 0.75,
        borderRadius: 1,
        border: 1,
        cursor: s ? "default" : "text",
        // Match MUI's outlined-input border in both themes. #1755 — a
        // strict-mode rejected value wins over everything (the borderless
        // inner field's own red outline is suppressed, so this box is the
        // only place a coefficient row can show the error visibly). #698 —
        // locked (confirmed) otherwise wins over the plain-disabled divider
        // color so a coefficient row visibly freezes green too.
        borderColor: h ? S.palette.error.main : a ? S.palette.success.main : s ? S.palette.divider : S.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)"
      }),
      children: [
        /* @__PURE__ */ f.jsx(
          di,
          {
            value: e,
            onChange: n,
            disabled: s,
            width: Rc,
            borderless: !0,
            inputRef: t,
            onKeyDown: r,
            locked: a,
            step: o,
            strict: u,
            invalidLabel: l,
            onValidityChange: j,
            gridCell: d
          }
        ),
        /* @__PURE__ */ f.jsxs(
          Ve,
          {
            component: "span",
            "data-testid": "coefficient-segment",
            "aria-label": `Coefficient ×${i}`,
            sx: {
              position: "absolute",
              right: 4,
              bottom: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              fontSize: "0.7rem",
              lineHeight: 1,
              color: "warning.main"
            },
            children: [
              "×",
              i
            ]
          }
        )
      ]
    }
  ) : /* @__PURE__ */ f.jsx(
    di,
    {
      value: e,
      onChange: n,
      disabled: s,
      width: ts,
      inputRef: t,
      onKeyDown: r,
      locked: a,
      step: o,
      strict: u,
      invalidLabel: l,
      onValidityChange: c,
      gridCell: d
    }
  );
}
function sh({ buildId: e, testId: n = "build-badge" }) {
  const s = Ni(e);
  return s ? /* @__PURE__ */ f.jsx(
    ae,
    {
      "data-testid": n,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: s
    }
  ) : null;
}
function Cc({ testId: e = "usa-badge", variant: n = "fixed" }) {
  const s = n === "static";
  return /* @__PURE__ */ f.jsxs(
    ae,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: s ? "static" : "fixed",
        ...s ? {} : { bottom: 2, left: 2, zIndex: 1250 },
        width: 80,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ f.jsx(
          ae,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ f.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ f.jsx(
          ae,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
function ih({ testId: e = "badge-footer" }) {
  return /* @__PURE__ */ f.jsx(
    ae,
    {
      component: "footer",
      "data-testid": e,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 2
      },
      children: /* @__PURE__ */ f.jsx(Cc, { variant: "static" })
    }
  );
}
const Ec = "5432";
function ah({
  pin: e = Ec,
  onUnlock: n,
  testId: s = "pin-lock",
  ariaLabel: i = "Unlock"
}) {
  const [t, r] = J(!1), [a, o] = J(""), [u, l] = J(!1), c = rt(null);
  return xe(() => {
    t || (o(""), l(!1));
  }, [t]), xe(() => {
    if (!t || a.length !== e.length) return;
    const d = setTimeout(() => {
      a === e ? (r(!1), n == null || n()) : (l(!0), setTimeout(() => {
        var h;
        o(""), l(!1), (h = c.current) == null || h.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [a, t, e, n]), /* @__PURE__ */ f.jsxs(f.Fragment, { children: [
    /* @__PURE__ */ f.jsx(
      Xn,
      {
        onClick: () => r(!0),
        "aria-label": i,
        "data-testid": s,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ f.jsx(mo, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ f.jsxs(
      Jn,
      {
        open: t,
        onClose: () => r(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ f.jsx(qn, { children: /* @__PURE__ */ f.jsx(ae, { sx: { pt: 1 }, children: /* @__PURE__ */ f.jsx(
            $t,
            {
              inputRef: c,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: a,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                o(
                  d.target.value.replace(/\D/g, "").slice(0, e.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: e.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ f.jsx(Pr, { children: /* @__PURE__ */ f.jsx($e, { color: "inherit", onClick: () => r(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
const vn = /* @__PURE__ */ new Map();
function oh() {
  vn.clear();
}
const hi = (e) => e != null ? vn.get(e) : null;
function Oc(e, n) {
  if (e.length !== n.length) return !1;
  for (let s = 0; s < n.length; s++)
    if (!Object.is(e[s], n[s])) return !1;
  return !0;
}
function uh(e, n, s = [], i = !0, t = null, r = null) {
  const [a, o] = J(() => {
    const F = hi(t);
    return F ? { data: F.data, loading: !1, error: null, settled: !0 } : { data: void 0, loading: !0, error: null, settled: !1 };
  }), [u, l] = J(!1), [c, d] = J(0), h = [...s, i], [m, j] = J(h);
  if (!Oc(m, h)) {
    j(h);
    const F = hi(t);
    F ? o({ data: F.data, loading: !1, error: null, settled: !0 }) : a.settled && o((q) => ({ ...q, settled: !1 }));
  }
  xe(() => {
    if (r != null && t != null && c === 0) {
      const B = vn.get(t);
      if (B && Date.now() - B.at < r) {
        o({ data: B.data, loading: !1, error: null, settled: !0 });
        return;
      }
    }
    let F = !1;
    const q = new AbortController();
    return (async () => {
      let B;
      try {
        B = await e();
      } catch {
        B = void 0;
      }
      const be = B != null;
      if (!F && be && (o({ data: B, loading: !1, error: null, settled: !0 }), t != null && vn.set(t, { data: B, at: -1 / 0 })), i)
        try {
          const ee = await n(q.signal);
          F || (o({ data: ee, loading: !1, error: null, settled: !0 }), t != null && vn.set(t, { data: ee, at: Date.now() }));
        } catch (ee) {
          if (q.signal.aborted) return;
          !F && !be && o({ data: null, loading: !1, error: ee, settled: !0 });
        } finally {
          F || l(!1);
        }
      else
        !F && !be && o({ data: null, loading: !1, error: null, settled: !0 }), F || l(!1);
    })(), () => {
      F = !0, q.abort();
    };
  }, [...s, i, c]);
  const S = ut(() => {
    l(!0), d((F) => F + 1);
  }, []);
  return { ...a, refetch: S, refreshing: u };
}
function lh(e, n = []) {
  const [s, i] = J({ data: null, loading: !0, error: null });
  return xe(() => {
    let t = !1;
    return i({ data: null, loading: !0, error: null }), e().then((r) => {
      t || i({ data: r, loading: !1, error: null });
    }).catch((r) => {
      t || i({ data: null, loading: !1, error: r });
    }), () => {
      t = !0;
    };
  }, n), s;
}
function kc({ clientId: e, cognitoDomain: n, logoutUri: s }) {
  if (e && n && s) {
    const i = `https://${n}/logout?client_id=${e}&logout_uri=${encodeURIComponent(s)}`;
    window.location.replace(i);
  }
}
function ch() {
  const { mode: e, setMode: n } = Si();
  return { mode: e, toggleTheme: () => {
    n(e === "dark" ? "light" : "dark");
  } };
}
function dh({ t: e, mode: n, toggleTheme: s, navigate: i, cognitoConfig: t, settingsLink: r = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ f.jsx(wi, {}),
      text: e("navigation.homeLink"),
      onClick: () => i("/")
    },
    {
      icon: /* @__PURE__ */ f.jsx(Ri, {}),
      text: e("navigation.settingsLink"),
      onClick: () => window.location.href = r
    },
    {
      icon: n === "dark" ? /* @__PURE__ */ f.jsx(Ti, { fontSize: "small" }) : /* @__PURE__ */ f.jsx(Ii, { fontSize: "small" }),
      text: e(n === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: s
    },
    {
      icon: /* @__PURE__ */ f.jsx(Ci, {}),
      text: e("navigation.logoutLink"),
      onClick: () => kc(t)
    }
  ];
}
const Ac = "Server Error";
let fi = !1;
function hh(e = vo) {
  fi || (fi = !0, e.interceptors.response.use(
    (n) => n,
    (n) => {
      var t, r, a;
      const s = (t = n == null ? void 0 : n.response) == null ? void 0 : t.data, i = ((r = s == null ? void 0 : s.data) == null ? void 0 : r.message) || (s == null ? void 0 : s.message) || (s == null ? void 0 : s.error) || (s == null ? void 0 : s.code) || (n == null ? void 0 : n.message);
      return console.error("[api error]", (a = n == null ? void 0 : n.response) == null ? void 0 : a.status, i, s), n && (n.serverErrorDetail = i, n.message = Ac), Promise.reject(n);
    }
  ));
}
export {
  So as AccountMenu,
  Md as ActiveOrgProvider,
  Hd as ActiveShowProvider,
  Ro as AppBar,
  Rd as AppFooter,
  xd as AppLayout,
  ih as BadgeFooter,
  sh as BuildBadge,
  Id as CallbackPage,
  Cd as CognitoAuthProvider,
  Ed as ConfirmButton,
  Rt as DEFAULT_VENUE_TIMEZONE,
  Nr as FullScreenLoader,
  wc as GRID_CELL_DATA_ATTR,
  Sc as GRID_CELL_SELECTOR,
  qd as GateHeader,
  Fd as ItemCard,
  kd as LoggedOutPage,
  Ad as LogoutPage,
  _o as MainContent,
  Wd as MockAuthProvider,
  Yd as MockLoginPage,
  Zd as MockProtectedRoute,
  Pd as MuiThemeProvider,
  jd as NavRail,
  Dd as NewItemCard,
  mu as OrgSwitcher,
  Nd as PageLayout,
  $d as PermissionProvider,
  ah as PinLock,
  Ud as ProtectedRoute,
  bc as RIDE_STATUS_DISPLAY,
  zu as ReportList,
  qu as ReportParamsForm,
  tl as ReportViewer,
  Kd as Reports,
  Qd as RideStatusBadge,
  Xu as RunHistory,
  ts as SCORE_ENTRY_WIDTH,
  Rc as SCORE_FIELD_WIDTH,
  Ac as SERVER_ERROR_MESSAGE,
  rh as ScoreEntry,
  di as ScoreInput,
  zd as ShowSwitcher,
  eh as SignatureBox,
  Ld as StyledBreadcrumb,
  Od as TableSkeleton,
  Ec as UNLOCK_PIN,
  Cc as UsaBadge,
  gu as UserDisplayName,
  oh as _resetWarmCacheForTests,
  _d as basenameFromRedirectUri,
  Td as beginSignOut,
  nh as focusNextGridCell,
  Gd as formatVenueTime,
  dh as getDefaultAccountMenuItems,
  hh as installServerErrorInterceptor,
  Uo as isCypressTestMode,
  su as isShowInActiveWindow,
  ks as isSigningOut,
  kc as logoutCognito,
  Ni as resolveBuildId,
  rs as resolveVenueTimeZone,
  Ht as unwrapReport,
  ns as useActiveOrg,
  uu as useActiveShow,
  Mu as useApiConfig,
  lh as useApiResource,
  uh as useCachedResource,
  Ji as useMockAuth,
  Pi as useNavRailState,
  Bd as usePermission,
  Gu as useReportApi,
  Xd as useRideStatuses,
  th as useSheetSignature,
  ch as useThemeSwitcher,
  pu as userDisplayName,
  Jd as userFirstName,
  nu as venueDayKey,
  Vd as venueZoneLabel
};
//# sourceMappingURL=common-fe.js.map
